/**
 * iq_table
 */
(function () {
  var paramcont = [];
  function iqtable() {
    return {
      restrict: "AE",
      scope: {
        tabledata: "=tableData",
        changepage: "=changePage",
      },
      controller: function ($scope, $attrs) {
        var pager_len = 6;
        var half_pager_len = parseInt(pager_len / 2);
        var pg;
        var pager = [];
        var tabledata = $scope.$parent[$attrs.tabledata];
        var changePage = $scope.$parent[$attrs.changepage];
        var init = function () {
          if (tabledata && tabledata.data) {
            // 没有数据则不初始化
          } else {
            return;
          }
          pg = tabledata.data.page.number;
          var totalPages = tabledata.data.page.totalPages;
          $scope.pageFlag = "";

          pager = [];
          if (totalPages <= pager_len) {
            for (var i = 1; i < totalPages; i++) {
              pager.push({
                page: i,
                type: "redirect",
              });
            }
          } else if (pg <= half_pager_len) {
            var i = 1;
            for (; i < pager_len; i++) {
              pager.push({
                page: i,
                type: "redirect",
              });
            }
            pager.push({
              page: i,
              type: "next",
            });
          } else if (pg >= totalPages - half_pager_len) {
            var i = totalPages - pager_len + 1;
            pager.push({
              page: i,
              type: "pre",
            });
            for (; i <= totalPages; i++) {
              pager.push({
                page: i,
                type: "redirect",
              });
            }
          } else {
            var i = pg - half_pager_len + 1;
            pager.push({
              page: i,
              type: "pre",
            });
            for (i; i <= pg + half_pager_len - 1; i++) {
              pager.push({
                page: i,
                type: "redirect",
              });
            }
            pager.push({
              page: i,
              type: "next",
            });
          }
          if (pg <= 1) {
            $scope.pageFlag = "first";
          } else if (pg >= totalPages) {
            $scope.pageFlag = "last";
          }
          $scope.title = tabledata.data.fields;
          $scope.content = tabledata.data.page.content;
          $scope.totalPages = tabledata.data.page.totalPages;
          $scope.pager = pager;
          $scope.pg = pg;
        };
        if (changePage) {
          $scope.refresh = function (p) {
            if (p == "pre") {
              pg--;
            } else if (p == "next") {
              pg++;
            } else {
              pg = p.page;
            }
            if (changePage) changePage(pg);
          };
        }

        $scope.$parent.$watch($attrs.tabledata, function (current, old) {
          tabledata = current;
          init();
        });
        init();
      },
      templateUrl: "./templates/common/iq_table.html",
    };
  }
  var iqPagerList = function () {
    return {
      restrict: "E",
      transclude: true,
      template: "<div ng-transclude></div>",
      scope: {
        data: "=*",
      },
      controller: function ($scope, $attrs) {
        var data = $attrs.data;
        // $scope[data] = $scope.$parent[data];
        var pageSetting = {};

        var targetScope = {};
        var preFix = [];

        $scope.$watchCollection("data", function (current, old) {
          var newData = angular.copy(current);
          for (var i = 0; i < preFix.length; i++) {
            var func = preFix[i];
            if (func && angular.isFunction(func)) {
              newData = func(newData);
            }
          }
          targetScope[data] = newData;
        });
        angular.extend(this, {
          addPreFix: function (func) {
            preFix.push(func);
          },
          preFixData: function () {
            var newData = this.getData();
            for (var i = 0; i < preFix.length; i++) {
              var func = preFix[i];
              if (func && angular.isFunction(func)) {
                newData = func(newData);
              }
            }
            targetScope[data] = newData;
            return newData;
          },
          linkScope: function (cs) {
            targetScope = cs;
            cs[data] = this.preFixData(angular.copy($scope.data));
            return $scope;
          },
          getPageSetting: function () {
            return pageSetting;
          },
          setPageSetting: function (ps, scope) {
            pageSetting = angular.extend(pageSetting, ps);
            if (scope) {
              scope.pageSetting = pageSetting;
            }
          },
          getDataName: function () {
            return data;
          },
          getData: function () {
            return angular.copy($scope.data);
          },
        });
      },
    };
  };
  var iqPagerListPager = function () {
    return {
      require: "^iqPagerList",
      restrict: "AE",
      replace: true,
      templateUrl: "./templates/common/iq_pager.html",
      compile: function iqPagerListPagerCompile($element, $attr) {
        return function iqPagerListPagerLink(
          $scope,
          $element,
          $attr,
          ctrl,
          $transclude
        ) {
          var attr_page = $attr.page;
          var attr_totalpage = $attr.totalpage;
          var pg = 1; // 当前页码 方法体用
          var totalpage = 1; // 总页数

          var data = ctrl.getDataName();

          var pageSetting = ctrl.getPageSetting();
          if (pageSetting.hasPager == undefined) {
            ctrl.setPageSetting({
              hasPager: true,
            });
            $scope[data] = angular.copy(ctrl.getData());
          }
          ctrl.setPageSetting({}, $scope);

          $scope.pager = {
            page: 1, // 当前所在页码
            choosePage: 1, // 当前选择页码，已提供跳转
            totalPage: 1,
            pageList: [],
            pageFlag: "",
          };

          var innerPgFlag = false; // 页码使用内置
          var pager_len = 9; // 分页器长度
          var hide_len = 2;
          var half_pager_len = pager_len - parseInt(pager_len / 2) + 1; // 分页器半长

          $scope.refresh = function (p) {
            if (!p) {
              p = {
                page: $scope.pager.choosePage,
              };
            }
            var tmppage = 1;
            if (p == "pre") {
              tmppage = parseInt(pg) - 1;
            } else if (p == "next") {
              tmppage = parseInt(pg) + 1;
            } else {
              tmppage = p.page;
            }

            if (tmppage <= 1) {
              tmppage = 1;
            } else if (tmppage >= totalpage) {
              tmppage = totalpage;
            }
            if (innerPgFlag) {
              pg = tmppage;
            }
            if ($attr.changepage) {
              // 如果传递了changepage参数
              if ($attr.changepage.substring(0, 1) == ".") {
                // 如果changepage参数第一个字符是.

                var tmp = $attr.changepage.split("."); // 用changepage字符串中的.分割成字符串数组
                var functmp = $scope[data]; // 定义functmp等于
                for (var i = 1; i < tmp.length; i++) {
                  if (functmp) {
                    functmp = functmp[tmp[i]];
                  }
                }
                if (functmp) {
                  eval(
                    "$scope[data]" + $attr.changepage + "({'page':tmppage})"
                  );
                  // 不直接使用functmp()是为了防止调用方不同导致this值不对
                }
              } else {
                if (frameScope.$parent[$attr.changepage]) {
                  frameScope.$parent[$attr.changepage]({
                    page: tmppage,
                  });
                  // 不直接使用func()是为了防止调用方不同导致this值不对
                }
              }
            }
          };
          var initPage = function () {
            // 通过参数 处理page和totalpage的情况

            if (attr_totalpage) {
              if (attr_totalpage.substring(0, 1) == ".") {
                var tmp = attr_totalpage.split(".");
                var pgtmp = $scope[data];
                for (var i = 1; i < tmp.length; i++) {
                  if (pgtmp) {
                    pgtmp = pgtmp[tmp[i]];
                  }
                }
                totalpage = pgtmp;
              } else if (angular.isNumber(attr_totalpage)) {
                // 第一个字符不为点号
                // 且为数字
                totalpage = attr_totalpage;
              } else {
                // 则监听父scope的对象
                totalpage = frameScope.$parent[attr_totalpage];
                frameScope.$parent.$watch(attr_totalpage, function (current) {
                  totalpage = current;
                  initPager();
                });
              }
            } else {
              // 没有值 使用默认设置
              if ($scope[data] && $scope[data].totalpage) {
                totalpage = $scope[data].totalpage;
              } else {
                totalpage = 0;
              }
            }
            if (attr_page) {
              // 有值
              if (attr_page.substring(0, 1) == ".") {
                // 第一个字符为点号
                // 则取data的子对象
                var tmp = attr_page.split(".");
                var pgtmp = $scope[data];
                for (var i = 1; i < tmp.length; i++) {
                  if (pgtmp) {
                    pgtmp = pgtmp[tmp[i]];
                  }
                }
                pg = pgtmp;
              } else {
                // 第一个字符不为点号 则监听父scope的对象
                pg = frameScope.$parent[attr_page];
                frameScope.$parent.$watch(attr_page, function (current) {
                  pg = current;
                  initPager();
                });
              }
            } else {
              // 没有值 则使用内部保存值
              innerPgFlag = true;
            }
            initPager();
          };

          // 监听的调用
          var watchCall = function (current, old) {
            /*
             * if ($scope.pageSetting.hasPager) {
             */
            if (attr_totalpage && attr_totalpage.substring(0, 1) == ".") {
              var tmp = attr_totalpage.split(".");
              var pgtmp = current;
              for (var i = 1; i < tmp.length; i++) {
                if (pgtmp) {
                  pgtmp = pgtmp[tmp[i]];
                }
              }
              if (totalpage != pgtmp) {
                totalpage = pgtmp;
                initPager();
              }
            }
            if (attr_page && attr_page.substring(0, 1) == ".") {
              // 第一个字符为点号
              // 则取data的子对象
              var tmp = attr_page.split(".");
              var pgtmp = current;
              for (var i = 1; i < tmp.length; i++) {
                if (pgtmp) {
                  pgtmp = pgtmp[tmp[i]];
                }
              }
              if (pg != pgtmp) {
                pg = pgtmp;
                initPager();
              }
            }
            // }
          };
          if (angular.isArray($scope[data])) {
            $scope.$watchGroup(data, function (current, old) {
              /*
               * if ($scope.hasPager) { initPager(); }
               */
            });
          } else {
            $scope.$watchCollection(data, function (current, old) {
              watchCall(current, old);
            });
          }
          var initPager = function () {
            // 通过totalpage 和page 加载pager
            pager = [];
            var pageFlag = "mid";

            $scope.pager = {
              page: 1, // 当前所在页码
              choosePage: 1, // 当前选择页码，已提供跳转
              totalPage: 1,
              pageList: [],
              pageFlag: "",
            };
            if (angular.isNumber(pg) && !!totalpage) {
              if (pg < 1) {
                pg = 1;
              }
              /*
               * else if (pg > totalpage) { pg = totalpage; }
               */

              if (pg <= 1) {
                pageFlag = "first";
              } else if (pg >= totalpage) {
                pageFlag = "last";
              }

              if (totalpage <= pager_len) {
                for (var i = 1; i <= totalpage; i++) {
                  pager.push({
                    page: i,
                    type: "redirect",
                  });
                }
              } else if (pg < half_pager_len) {
                var i = 1;
                for (; i <= pager_len - hide_len; i++) {
                  pager.push({
                    page: i,
                    type: "redirect",
                  });
                }
                pager.push({
                  page: "...",
                  type: "disabled",
                });
                pager.push({
                  page: totalpage,
                  type: "redirect",
                });
              } else if (pg > totalpage - half_pager_len + 1) {
                var i = totalpage - pager_len + hide_len + 1;
                pager.push({
                  page: 1,
                  type: "redirect",
                });
                pager.push({
                  page: "...",
                  type: "disabled",
                });
                for (; i <= totalpage; i++) {
                  pager.push({
                    page: i,
                    type: "redirect",
                  });
                }
              } else {
                var i = parseInt(pg) - half_pager_len + hide_len * 2;
                var j = parseInt(pg) + parseInt(half_pager_len) - hide_len * 2;

                pager.push({
                  page: 1,
                  type: "redirect",
                });
                pager.push({
                  page: "...",
                  type: "disabled",
                });
                for (; i <= j; i++) {
                  pager.push({
                    page: i,
                    type: "redirect",
                  });
                }
                pager.push({
                  page: "...",
                  type: "disabled",
                });
                pager.push({
                  page: totalpage,
                  type: "redirect",
                });
              }
              $scope.pager = {
                page: pg, // 当前所在页码
                choosePage: pg, // 当前选择页码，已提供跳转
                totalPage: totalpage ? totalpage : 1,
                pageList: pager,
                pageFlag: pageFlag,
              };
            }
          };
          var frameScope = ctrl.linkScope($scope);
          initPage();
        };
      },
    };
  };
  var iqPagerMore = function () {
    // TODO 如果页面上先有数据，分页有bug。 需要优化：增加更多的长度 样式优化等
    return {
      require: "^iqPagerList",
      restrict: "AE",

      template:
        "<a ng-if='pageSetting.hasMore' href='javascript:void(0)' class='read-more' ng-click='more()'>更多...</a>",
      controller: function ($scope) {},
      compile: function iqPagerMoreCompile($element, $attr) {
        return function iqPagerMoreLink(
          $scope,
          $element,
          $attr,
          ctrl,
          $transclude
        ) {
          $element.addClass("angular-tag");
          var _hide = function () {
            $element.addClass("hide");
          };
          var _show = function () {
            $element.removeClass("hide");
          };

          // 初始化页面设置
          ctrl.setPageSetting(
            {
              hasMore: true,
              hasPager: false,
            },
            $scope
          );
          _show();

          var data = ctrl.getDataName();
          var len = 5;
          var index = 1;
          var noMore = false;
          var loopDataPath = $attr.iqPagerMore || "";

          var getLoopData = function (_data) {
            try {
              return eval("_data" + loopDataPath + "");
            } catch (e) {
              console.log(e);
            }
            return undefined;
          };
          var getNextLoopData = function (_data) {
            try {
              eval("var list = _data" + loopDataPath + "");
              var i = getRealData().length;
              var nextList = [];
              var hasMore = false;
              var hasPager = false;
              if (list && list.length > 0) {
                for (
                  i = index * len - len;
                  i < index * len && i < list.length;
                  i++
                ) {
                  nextList.push(list[i]);
                }
                if (i == 0) {
                  hasMore = false;
                } else if (i >= list.length) {
                  hasPager = true;
                  hasMore = false;
                  noMore = true;
                } else {
                  hasMore = true;
                }
              } else {
                hasMore = false;
              }

              ctrl.setPageSetting(
                {
                  hasMore: hasMore,
                  hasPager: hasPager,
                },
                $scope
              );

              // 有则显示，没有则隐藏
              hasMore ? _show() : _hide();

              return nextList;
            } catch (e) {
              console.log(e);
            }
            return [];
          };
          var setLoopData = function (_data, list) {
            try {
              eval("_data" + loopDataPath + " = list");
              $scope[data] = _data;
            } catch (e) {
              console.log(e);
            }
            return _data;
          };
          var getRealData = function () {
            try {
              return eval("$scope[data]" + loopDataPath);
            } catch (e) {
              console.log(e);
            }
            return [];
          };
          var initData = function (current) {
            var _data;
            if (current) {
              _data = current;
            } else {
              _data = angular.copy(ctrl.getData());
            }
            if (!_data) {
              return;
            }
            var loopData = [];

            loopData = angular.copy(getLoopData(_data));
            var list = [];
            var hasMore = false;
            var hasPager = false;
            if (loopData) {
              var i = 0;
              for (; i < index * len && i < loopData.length; i++) {
                list.push(loopData[i]);
              }
              if (i == 0) {
                hasMore = false;
              } else if (i >= loopData.length) {
                hasPager = true;
                hasMore = false;
                noMore = true;
              } else {
                hasMore = true;
              }
            } else {
              hasMore = false;
            }

            ctrl.setPageSetting(
              {
                hasMore: hasMore,
                hasPager: hasPager,
              },
              $scope
            );

            // 有则显示，没有则隐藏
            hasMore ? _show() : _hide();

            return setLoopData(_data, list);
          };
          $scope.more = function () {
            index++;
            var list = getNextLoopData(angular.copy(ctrl.getData()));
            for (var i = 0; i < list.length; i++) {
              eval("$scope[data]" + loopDataPath + ".push(list[i])");
            }
          };

          ctrl.addPreFix(function (current) {
            return initData(current);
          });
          var frameScope = ctrl.linkScope($scope);
        };
      },
    };
  };

  function iqdiscuss() {
    return {
      restrict: "AE",
      scope: {
        blog: "=blog",
        discuss: "=discuss",
        netdisktype: "=netdisktype",
      },
      link: function ($scope, $element, $attr, $iq_popup) {
        $(document).one(
          "focus",
          "[name='discussMessage']", // 绑定@显示用户列表
          function () {
            $("[name='discussMessage']", $element).showAtUsers();
          }
        );
        $(document).one(
          "focus",
          "[name='discussMessage']", // 绑定#显示话题列表
          function () {
            $("[name='discussMessage']", $element).showJing();
          }
        );

        var text = $("[name='discussMessage']", $element).get(0).placeholder; // 处理IE下placeholder不好用的情况

        $("[name='discussMessage']", $element).focus(function () {
          // $(this).showJing();
          // $(this).showAtUsers();
          // $("[name='subDiscuss']",
          // $element).get(0).style.background = "#41c0e6"; // 发布按钮变颜色
          if ($attr.netdisktype == "netdisk" || $attr.netdisktype == "plate") {
            $(".publish-ctrl").css("display", "block");
            $(".netdisk-discuss").addClass("bordercss");
          }
          $("[name='subDiscuss']", $element).addClass("sub-btn-focus");
          if ($("[name='discussMessage']", $element).get(0).value === text) {
            // 处理IE下placeholder不好用的情况
            $("[name='discussMessage']", $element).get(0).value = "";
          }
        });
        $("[name='discussMessage']", $element).blur(function () {
          // 失去焦点
          // $("[name='subDiscuss']",
          // $element).get(0).style.background = "rgba(65,
          // 192,
          // 230, 0.5)"; // 变颜色
          $("[name='subDiscuss']", $element).removeClass("sub-btn-focus");
        });
        $("[name='topicBtnDiscuss']", $element).click(function () {
          // 点击#键
          var textarea = $("[name='discussMessage']", $element).get(0); // 没办法
          // setSelectionRange和jquery不兼容
          var con = "请在这里输入自定义话题";
          if (textarea.value == "评论一下吧~......") {
            // 如果是初始文字，清空
            textarea.value = "";
          }
          textarea.value += "#" + con + "# ";
          var l = textarea.value.length;
          // 创建选择区域

          if (textarea.createTextRange) {
            // IE浏览器

            var range = textarea.createTextRange();
            range.moveEnd("character", -l);
            // range.moveStart("character",-l)

            range.moveEnd("character", l - 2);
            range.moveStart("character", l - 2 - con.length);
            range.select();
          } else {
            textarea.focus();
            textarea.setSelectionRange(l - 2 - con.length, l - 2);
          }
        });
        // $("[name='publishMessage']",tE).showJing();//绑定#显示用户列表

        var isShowImg = false;
        var isShowOther = false;

        $("[name='imgBtnDiscuss']", $element).click(function () {
          // 点击表情
          var faceDiv = $("[name='faceDiv']", $element);
          faceDiv.css("display", "block");
          isShowOther = false;
          $(this).prev().animate(
            {
              marginTop: "20px",
            },
            300
          );
          var otherDiv = $("[name='otherDiv']", $element);
          otherDiv.css("display", "none");
          // }

          if (isShowImg == false) {
            isShowImg = true;
            $(this).prev().animate(
              {
                marginTop: "30px",
              },
              300
            );
            if (faceDiv.children().length == 0) {
              for (var i = 0; i < ImgIputHandler.facePath.length; i++) {
                faceDiv.append(
                  '<span name="faceDivImg" title="' +
                    ImgIputHandler.facePath[i].faceName +
                    '" class=' +
                    ImgIputHandler.facePath[i].facePath +
                    '" />'
                );
              }
              $("[name='faceDivImg']", $element).click(function () {
                isShowImg = false;
                $(this).animate(
                  {
                    marginTop: "2px",
                  },
                  300
                );
                setTimeout(function () {
                  faceDiv.css("display", "none");
                }, 100);
                var textarea = $("[name='discussMessage']", $element).get(0);
                ImgIputHandler.insertAtCursor(
                  textarea,
                  "[" + $(this).attr("title") + "]"
                );
              });
            }
          } else {
            isShowImg = false;
            $(this).prev().animate(
              {
                marginTop: "20px",
              },
              300
            );
            setTimeout(function () {
              faceDiv.css("display", "none");
            }, 100);
          }
        });

        $("[name='othersBtnDiscuss']", $element).click(function () {
          // 点击附件
          var otherDiv = $("[name='otherDiv']", $element);
          otherDiv.css("display", "block");

          if (isShowOther == false) {
            isShowImg = false; // 表情框直接消失
            $(this).prev().animate(
              {
                marginTop: "20px",
              },
              300
            );
            var faceDiv = $("[name='faceDiv']", $element);
            faceDiv.css("display", "none");

            isShowOther = true; // 打开附件框
            $(this).prev().animate(
              {
                marginTop: "30px",
              },
              300
            );
          } else {
            isShowOther = false;
            $(this).prev().animate(
              {
                marginTop: "20px",
              },
              300
            );
            setTimeout(function () {
              otherDiv.css("display", "none");
            }, 100);
          }
        });

        $("[name='discusssubbut']", $element).click(function () {
          // 上传附件
          var discussfile1 = $("[name='discussfile1']", $element);
          var discussfile2 = $("[name='discussfile2']", $element);
          var discussfile3 = $("[name='discussfile3']", $element);
          var discussfile4 = $("[name='discussfile4']", $element);
          var discussfile5 = $("[name='discussfile5']", $element);
          if (
            discussfile1.val().length > 0 ||
            discussfile2.val().length > 0 ||
            discussfile3.val().length > 0 ||
            discussfile4.val().length > 0 ||
            discussfile5.val().length > 0
          ) {
            var fileSize1 = discussfile1[0].files[0];
            var fileSize2 = discussfile2[0].files[0];
            var fileSize3 = discussfile3[0].files[0];
            var fileSize4 = discussfile4[0].files[0];
            var fileSize5 = discussfile5[0].files[0];

            if (
              fileSize1 != null &&
              fileSize1 != "undefined" &&
              fileSize1 != undefined
            ) {
              if (fileSize1.size / (1024 * 1024) > 30) {
                $iq_popup.alert("第一个文件超出了30M，不能上传。");
                discussfile1.focus();
                return false;
              }
            }
            if (
              fileSize2 != null &&
              fileSize2 != "undefined" &&
              fileSize2 != undefined
            ) {
              if (fileSize2.size / (1024 * 1024) > 30) {
                $iq_popup.alert("第二个文件超出了30M，不能上传。");
                discussfile2.focus();
                return false;
              }
            }
            if (
              fileSize3 != null &&
              fileSize3 != "undefined" &&
              fileSize3 != undefined
            ) {
              if (fileSize3.size / (1024 * 1024) > 30) {
                $iq_popup.alert("第三个文件超出了30M，不能上传。");
                discussfile3.focus();
                return false;
              }
            }
            if (
              fileSize4 != null &&
              fileSize4 != "undefined" &&
              fileSize4 != undefined
            ) {
              if (fileSize4.size / (1024 * 1024) > 30) {
                $iq_popup.alert("第四个文件超出了30M，不能上传。");
                discussfile4.focus();
                return false;
              }
            }
            if (
              fileSize5 != null &&
              fileSize5 != "undefined" &&
              fileSize5 != undefined
            ) {
              if (fileSize5.size / (1024 * 1024) > 30) {
                $iq_popup.alert("第五个文件超出了30M，不能上传。");
                discussfile5.focus();
                return false;
              }
            }

            $.ajaxFileUploadDiscuss({
              // 上传文件
              url: getIquickerWebPath() + "weibo/file/upload",
              type: "post",
              secureuri: false, // 一般设置为false
              fileElementName: [
                "discussfile1",
                "discussfile2",
                "discussfile3",
                "discussfile4",
                "discussfile5",
              ],
              dataType: "text", // 返回值类型，一般设置为json、application/json
              success: function (re, status) {
                if (re != null) {
                  var obj = eval("(" + re + ")");
                  var success = obj.success;
                  if (success) {
                    var list = obj.data;
                    var len = list.length;
                    for (var i = 0; i < list.length; i++) {
                      var attach = list[i];

                      var discussfileview = $(
                        "[name='discussfileview" + (i + 1) + "']",
                        $element
                      );
                      var discussfileviewname = $(
                        "[name='discussfileviewname" + (i + 1) + "']",
                        $element
                      );
                      var discussfileviewpath = $(
                        "[name='discussfileviewpath" + (i + 1) + "']",
                        $element
                      );
                      var discussfileviewtype = $(
                        "[name='discussfileviewtype" + (i + 1) + "']",
                        $element
                      );

                      if (attach.type == "pic") {
                        discussfileview.attr(
                          "src",
                          getIquickerWebPath() +
                            "newsUploader/download?fileName=" +
                            attach.path +
                            "&realName=" +
                            attach.name
                        );
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "txt") {
                        discussfileview.attr("src", "img/fileupload/txt.png");
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "doc") {
                        discussfileview.attr("src", "img/fileupload/doc.png");
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "xls") {
                        discussfileview.attr("src", "img/fileupload/xls.png");
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "ppt") {
                        discussfileview.attr("src", "img/fileupload/ppt.png");
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "rar") {
                        discussfileview.attr("src", "img/fileupload/rar.png");
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "pdf") {
                        discussfileview.attr("src", "img/fileupload/pdf.png");
                        discussfileviewname.html(attach.name);
                      } else if (attach.type == "unknown") {
                        discussfileview.attr(
                          "src",
                          "img/fileupload/unknown.png"
                        );
                        discussfileviewname.html(attach.name);
                      } else {
                        discussfileview.attr(
                          "src",
                          "img/fileupload/unknown.png"
                        );
                        discussfileviewname.html(attach.name);
                      }

                      discussfileviewpath.html(attach.path);
                      discussfileviewtype.html(attach.type);
                    }
                  } else {
                    $iq_popup.alert("上传失败！");
                    return;
                  }
                  // }
                }
              },
              error: function (re) {
                $iq_popup.alert("上传失败！");
              },
            });
          } else {
            $iq_popup.alert("请选择要上传的文件！");
            return;
          }

          var resprocess = null;
          var eventFun = function () {
            // 获取上传进度
            $.ajax({
              type: "GET",
              url: getIquickerWebPath() + "weibo/upload/process",
              data: {},
              dataType: "json",
              success: function (data) {
                resprocess = data;
                var discussproBar = $("[name='discussproBar']", $element);
                discussproBar.css("width", data.rate + "" + "%");
                discussproBar.empty();
                discussproBar.append(data.show);
                if (data.rate == 100) {
                  // 这里再调用一下后台清空session里面的东西
                  window.clearInterval(intId);
                }
              },
            });
          };
          var intId = window.setInterval(eventFun, 500);

          setTimeout(function () {
            // 如果三秒内没有获取到进度条数据
            // 停止无限循环
            if (resprocess == null) {
              window.clearInterval(intId);
            }
          }, 3000);
        });

        $("[name='discussAttachment']", $element).click(function () {
          // 新的点击附件
          if ($("[name='discussMessage']", $element).get(0).value === text) {
            // 处理IE下placeholder不好用的情况
            $("[name='discussMessage']", $element).get(0).value = "";
          }

          $thisBtn = $("[name='discussAttachment']", $element).get(0);
          $thisPopAtt = $("[name='discussAttShow']", $element).get(0);
          $thisPopEmoji = $("[name='discussEmojiShow']", $element).get(0);
          $thisParent = $("[name='discussPublish']", $element).get(0);

          pop_x = $thisParent.offsetLeft;
          pop_y = $thisParent.offsetTop + 30;
          thisArrow_x = (0 + 0.3) * 78;

          $thisPopAtt.style.top = pop_y + "px";
          $thisPopAtt.style.left = pop_x + "px";

          if ($attr.netdisktype != "netdisk" && $attr.netdisktype != "plate") {
            $thisArrow = $("[name='attSpan']", $element).get(0);
            $thisArrow.style.left = thisArrow_x + "px";
          }
          $thisPopAtt.className = "publish-pop-discuss add-upload-discuss hide";
          $thisPopEmoji.className = "publish-pop-discuss add-face-discuss hide";

          $thisPopAtt.className = "publish-pop-discuss add-upload-discuss";

          $("body").on("mousedown", function () {
            $thisPopAtt.className =
              "publish-pop-discuss add-upload-discuss hide";
          });
          $(".publish-pop-discuss").mousedown(function (event) {
            event.stopPropagation();
          });
        });

        $("[name='discussEmoji']", $element).click(function () {
          // 新的点击表情
          if ($attr.netdisktype == undefined || $attr.netdisktype == "plate") {
            var EmojiList = $("[name='discussEmojiList']", $element).get(0)
              .childNodes;
            if (EmojiList.length == 7) {
              console.log(EmojiList);
              console.log("--------");
              console.log(EmojiList[0]);
              console.log(EmojiList[1]);
              console.log(EmojiList[2]);
              console.log(EmojiList[3]);
              console.log(EmojiList[4]);
              console.log(EmojiList[5]);
              console.log(EmojiList[6]);
              console.log("--------");
              $(EmojiList[6]).remove();
              //EmojiList[6].remove();
              $(EmojiList[5]).remove();
            }
          }
          if ($("[name='discussMessage']", $element).get(0).value === text) {
            // 处理IE下placeholder不好用的情况
            $("[name='discussMessage']", $element).get(0).value = "";
          }

          $thisBtn = $("[name='discussAttachment']", $element).get(0);
          $thisPopAtt = $("[name='discussAttShow']", $element).get(0);
          $thisPopEmoji = $("[name='discussEmojiShow']", $element).get(0);
          $thisParent = $("[name='discussPublish']", $element).get(0);

          pop_x = $thisParent.offsetLeft;
          pop_y = $thisParent.offsetTop + 30;
          thisArrow_x = (1 + 0.3) * 78;

          $thisPopEmoji.style.top = pop_y + "px";
          $thisPopEmoji.style.left = pop_x + 50 + "px";
          if ($attr.netdisktype == "netdisk" || $attr.netdisktype == "plate") {
            $thisArrow = $("[name='emojiSpan']", $element).get(0);
            $thisArrow.style.left = thisArrow_x + "px";
          }

          $thisPopAtt.className = "publish-pop-discuss add-upload-discuss hide";
          $thisPopEmoji.className = "publish-pop-discuss add-face-discuss hide";

          $thisPopEmoji.className = "publish-pop-discuss add-face-discuss";
          $(".modal-dialog").on("mousedown", function () {
            $thisPopEmoji.className =
              "publish-pop-discuss add-face-discuss hide";
          });
          $("body").on("mousedown", function () {
            $thisPopEmoji.className =
              "publish-pop-discuss add-face-discuss hide";
          });
          $(".publish-pop-discuss").mousedown(function (event) {
            event.stopPropagation();
          });

          //							$scope.netdisktype = $attr.netdisktype;
          //							$scope.discussFace = true;
          //							if($scope.netdisktype!=undefined&&$scope.netdisktype == 'netdisk'){
          //								$scope.discussFace = false;
          //							}else{
          //								$scope.discussFace = true;
          //							}
          // 处理表情框
          var $addFaceBox = $("[name='discussEmojiList']", $element).get(0)
            .childNodes;
          var $addFaceList = [];
          //							$scope.type = $attr.type;
          //							$scope.discussFace = true;
          //							if($scope.type!=undefined&&$scope.type == 'netdisk'){
          //								$scope.discussFace = false;
          //							}else{
          //								$scope.discussFace = true;
          //							}
          //console.log($scope.type,$attr.type,$addFaceBox);
          for (var i = 0; i < $addFaceBox.length; i++) {
            if (
              $addFaceBox[i].nodeName == "ul" ||
              $addFaceBox[i].nodeName == "UL"
            ) {
              $addFaceList[$addFaceList.length] = $addFaceBox[i];
            }
          }

          $addFaceBtnBox = $("[name='discussEmojiBtn']", $element).get(0);
          var addFace_btnHtml = "";
          addFacePage = $addFaceList.length;
          for (i = 1; i <= addFacePage; i++) {
            // $addFaceList.eq(i-1).css('left',373*(i-1)+'px');
            $addFaceList[i - 1].style.left = 373 * (i - 1) + "px";
            if ($scope.netdisktype == "netdisk" || addFacePage == 3) {
              $addFaceList[i - 1].innerHTML = emojinetdiskLiArrs[i - 1];
            } else {
              $addFaceList[i - 1].innerHTML = emojiLiArrs[i - 1];
            }
            if (i == 1) {
              addFace_btnHtml += '<span class="faceActive-discuss"></span>';
            } else {
              addFace_btnHtml += "<span></span>";
            }
          }
          // $addFaceBtnBox.html(addFace_btnHtml);

          var template = angular.element(addFace_btnHtml);
          angular.element("[name='discussEmojiBtn']").empty();
          angular.element("[name='discussEmojiBtn']").append(template);
          // $addFaceBtn = $addFaceBtnBox.find('span');
          var faceBoxChilds = $addFaceBtnBox.childNodes;
          var $addFaceBtn = [];
          for (var i = 0; i < faceBoxChilds.length; i++) {
            if (
              faceBoxChilds[i].nodeName == "span" ||
              faceBoxChilds[i].nodeName == "SPAN"
            ) {
              $addFaceBtn[$addFaceBtn.length] = faceBoxChilds[i];
            }
          }

          $(".add-face-btn-discuss>span").click(function () {
            // 绑定表情分页点击
            for (var i = 0; i < $addFaceBtn.length; i++) {
              $addFaceBtn[i].className = "";
            }

            $(this).get(0).className = "faceActive-discuss";
            addFaceBtnIndex = $addFaceBtn.indexOf($(this).get(0));
            for (var ai = 0; ai < $addFaceList.length; ai++) {
              var addFaceList_left = (ai - addFaceBtnIndex) * 373;

              $([$addFaceList[ai]])
                .stop()
                .animate(
                  {
                    left: addFaceList_left + "px",
                  },
                  "slow"
                );
            }
          });

          // 单独添加：点击表情的动作
          // $(".add-face-list-discuss>ul>li>img").click(function(){
          $(".add-face-list-discuss>ul>li>span")
            .off("click.add-emoji-discuss")
            .on("click.add-emoji-discuss", function () {
              var textarea = $("[name='discussMessage']", $element);
              ImgIputHandler.insertAtCursor(
                textarea[0],
                "[" + $(this).attr("title") + "]"
              );
              $thisPopEmoji = $("[name='discussEmojiShow']", $element).get(0);
              // $thisPopEmoji.className = "publish-pop-discuss add-face-discuss hide";
            });
        });
      },

      controller: function (
        $scope,
        $attrs,
        $element,
        $iq_http,
        $iq_server,
        $iq_popup,
        $rootScope,
        $iq_loading
      ) {
        $scope.type = $attrs.type;
        $scope.discussFace = true;
        if (
          $scope.netdisktype != undefined &&
          $scope.netdisktype == "netdisk"
        ) {
          $scope.discussFace = false;
        } else {
          $scope.discussFace = true;
        }
        $("[name='subDiscuss']", $element).click(function () {
          // 点击发表

          var text = $("[name='discussMessage']", $element).get(0).placeholder; // 处理IE下placeholder不好用的情况
          if ($("[name='discussMessage']", $element).get(0).value === text) {
            // 处理IE下placeholder不好用的情况
            $("[name='discussMessage']", $element).get(0).value = "";
          }

          var discussType = $attrs.type;

          var title = "";
          var blog = $scope.$parent[$attrs.blog];

          var discuss = $scope.$parent[$attrs.discuss];

          var masterId = blog.id;
          if (blog.companyMasterFile) {
            masterId = blog.companyMasterFile.id;
          }
          if (blog.type == "discuss" || blog.typeId == "discuss") {
            // 新增，用于评论的单独展示
            discuss = blog.content.discuss;
            masterId = blog.content.discuss.masterId;
          }

          if ($scope.uploading) {
            $iq_popup.alert("请等待附件上传完毕后再提交", 5, "warn");
            return;
          }

          if (discussType == "weibo") {
            // 获取链接标题
            // if(blog.type == 'blog'){
            // title = blog.content.content;
            // }else if(blog.type == 'discuss'){
            // title = blog.content.discuss.content;
            // }else{
            // title = "点击查看";
            // }
            title = "点击查看";
          } else if (discussType == "news") {
            title = blog.title;
          } else if (discussType == "task") {
            title = blog.subject;
          } else if (discussType == "schedul") {
            title = blog.title;
          } else if (discussType == "workreport") {
            title = blog.summary;
          } else if (discussType == "rule") {
            title = blog.title;
          } else if (discussType == "personfile") {
            title = blog.name;
          } else if (discussType == "companyfile") {
            title = blog.name;
            masterId = blog.companyMasterFile.id;
          } else if (discussType == "kanbantask") {
            title = blog.content;
          } else {
            title = "点击查看";
          }

          if (title && title.length > 20) {
            title = title.substring(0, 20) + "...";
          }

          if (
            discuss == null ||
            discuss == undefined ||
            discuss == "undefined"
          ) {
            discuss = {
              id: "",
              userId: "",
              userName: "",
            };
          }

          var content = $("[name='discussMessage']", $element).val();
          var filesList = $scope.filesdiscuss;

          var userIdNames = $("[name='userIdNamesDiscuss']", $element).val();

          if (content != null && content != undefined) {
            content = content.trim();
          }

          if (content == null || content == undefined || content == "") {
            if (
              filesList != null &&
              filesList != undefined &&
              filesList != "undefined"
            ) {
              if (filesList.length > 0) {
                content = filesList[0].fileName + "...等附件";
              } else {
                $iq_popup.alert("请输入内容！", 3, "warn");
                return;
              }
            } else {
              $iq_popup.alert("请输入内容！", 3, "warn");
              return;
            }
          }

          if (content != null && content != undefined) {
            var sum = JudgeLength(content);
            if (sum > 140) {
              $iq_popup.alert("评论最多可以发表140字，请重新调整！", 3, "warn");
              return;
            }
          }

          var isFile = "N";
          if (
            filesList != null &&
            filesList != undefined &&
            filesList != "undefined"
          ) {
            if (filesList.length > 0) {
              isFile = "Y";
            }
          }

          content = transBeforeSave(content); // 存入数据库之前转换表情 @
          // #

          var publishTime = getStringDate(new Date());
          var datas = {
            discussType: discussType,
            masterId: masterId,
            discussedId: discuss.id,
            discussedUserId: discuss.userId,
            discussedUserName: discuss.userName,
            content: content,
            isFile: isFile,
            publishTime: publishTime,
            relay: 0,
            attachments: filesList,
            userIdNames: userIdNames,
            atConnectTitle: title,
          };

          var func = {
            success: function (res) {
              // list = [blogParam].concat(list)
              if (res.data.success == true) {
                $iq_popup.alert("发布成功！", 3, "success");
                $("[name='discussMessage']", $element).val("");
                // $("[name='userIdNamesDiscuss']",
                // $element).val("");
                var inputIdNames = angular.element(
                  "[name='userIdNamesDiscuss']"
                );
                for (var i = 0; i < inputIdNames.length; i++) {
                  inputIdNames[i].value = "";
                }

                $scope.filesdiscuss = [];

                // var newQu = [res.data.data];//
                // 把返回结果转换成数组（虽然只有一个，下面调用的方法需要的是数组）
                // blog.discussList =
                // newQu.concat(blog.discussList);//
                // 动态添加新数据
                // blog.discusses = blog.discusses + 1;
                getDiscuss(blog);
                // blog.myblogdiscuss = "no";
                // discuss.dfdiscuss = "no";

                $rootScope.$broadcast("refreshBlog", ""); // 广播事件
                // 刷新说说
              } else {
                $iq_popup.alert(res.data.message, 3, "fail");
              }

              $iq_loading.hide(); // 隐藏加载
            },
          };
          var params = {
            data: datas,
            dataType: "json",
            method: "POST",
            url: $iq_server.server() + "discuss/data",
          };
          $iq_loading.show(); // 显示加载
          $iq_http.http(params, func);
        });

        var getDiscuss = function (blog) {
          var masterId = blog.id;
          if (blog.companyMasterFile) {
            masterId = blog.companyMasterFile.id;
          }
          var func = {
            success: function (res) {
              if (res.data.success == true) {
                var dlList = res.data.data;
                if (dlList == null || dlList.length < 1) {
                  blog.discussList = [];
                } else {
                  var dl = dlList[0];
                  blog.discussList = dl.discussList;
                }
              }
            },
          };
          var params = {
            // params: {
            // "masterId": masterId
            // },
            method: "GET",
            url: $iq_server.server() + "discusslist/data/" + masterId,
          };
          $iq_http.http(params, func);
        };
      },
      templateUrl: function ($scope, $element, $attr) {
        var uul = "";
        if (
          $element.netdisktype == "netdisk" ||
          $element.netdisktype == "plate"
        ) {
          uul = "./templates/common/netdisk_discuss.html";
        } else {
          uul = "./templates/common/discuss.html";
        }
        return uul;
      },
    };
  }

  function iqdiscussshow() {
    return {
      restrict: "AE",
      scope: {
        type: "=type",
        blog: "=blog",
        discuss: "=discuss",
      },
      link: function ($scope, $element, $attr) {},

      controller: function (
        $scope,
        $attrs,
        $element,
        $iq_http,
        $iq_server,
        $iq_user,
        $iq_popup,
        $discuss_service,
        $location,
        $iq_loading
      ) {
        // 同步到文件库
        $scope.fileTree = function (file) {
          var filetree = $iq_popup.filetree(file.fileId, file.fileName);
          filetree.then(function (re) {});
        };
        // $scope.myId = $iq_user.getUserInfo().$$state.value.id;
        $iq_user.getUserInfo().then(function (user) {
          $scope.myId = user.id;
        });

        $scope.iq_serverPath = $iq_server.server();
        var blog = !$scope.$parent[$attrs.blog]
          ? $scope[$attrs.blog]
          : $scope.$parent[$attrs.blog];
        $scope.mytype = $attrs.type;
        //----start-----原来的逻辑：不管任何模块，使用评论组件的地方，评论的回复类型都是'blog'，对于回复的通知无法实现，
        //现改为由评论的类型决定，周报的评论workreport，对应的回复也是workreport --------
        $scope.discussType = $scope.mytype ? $scope.mytype : "blog";
        //----------------------------------end---------------
        $scope.showDiscuss = function (blog) {
          if (blog.showblogdiscuss == "yes") {
            blog.showblogdiscuss = "no";
          } else {
            if (blog.discussList == null || blog.discussList.length < 1) {
              getDiscuss(blog);
            }
            blog.showblogdiscuss = "yes";
          }
        };

        $scope.discussShowForDiscuss = function (discuss) {
          if (discuss.dfshowdiscuss == "yes") {
            discuss.dfshowdiscuss = "no";
          } else {
            discuss.dfshowdiscuss = "yes";
          }
        };

        $scope.goPersonelPageDiscuss = function (userId) {
          $location.path("/personalpage/gotouserpage/" + userId);
        };

        var getDiscuss = function (blog) {
          var masterId = blog.id;
          if (blog.companyMasterFile) {
            masterId = blog.companyMasterFile.id;
          }
          var func = {
            success: function (res) {
              if (res.data.success == true) {
                var dlList = res.data.data;
                if (dlList == null || dlList.length < 1) {
                  blog.discussList = [];
                } else {
                  var dl = dlList[0];
                  blog.discussList = dl.discussList;
                }
              }
            },
          };
          var params = {
            // params: {
            // "masterId": masterId
            // },
            method: "GET",
            url: $iq_server.server() + "discusslist/data/" + masterId,
          };
          $iq_http.http(params, func);
        };
        $scope.$watch("blog", function (v, o) {
          if (blog != undefined && v && v.showblogdiscuss == "yes") {
            getDiscuss(blog);
          }
        });
        //				$scope.$on("companydetailparamdiscuss",function(){
        //					if(blog!=undefined){
        //						getDiscuss(blog);
        //					}
        //				});
        $scope.shownowpagediscuss = 1;
        $scope.pageSizediscussshow = 10;
        $scope.showtotalpagediscuss = 20;

        //看板scope
        $scope.platediscussClass = "discusslog-bor";
        $scope.discusslogClass = "";
        $scope.discusslog = true;
        $scope.platediscuss = function () {
          $scope.discusslog = true;
          $scope.platediscussClass = "discusslog-bor";
          $scope.discusslogClass = "";
        };
        $scope.platelog = function () {
          $scope.discusslog = false;
          $scope.platediscussClass = "";
          $scope.discusslogClass = "discusslog-bor";
        };

        $scope.delDiscussForShow = function (blog, discuss) {
          // 删除评论
          var confirm = $iq_popup.confirm("确定删除吗?");
          confirm.then(
            function () {
              $iq_loading.show(); // 显示加载

              var discussParam = {
                masterId:
                  blog.companyMasterFile == undefined
                    ? blog.id
                    : blog.companyMasterFile.id,
                discussId: discuss.id,
                discussType: "news",
              };

              var delDiscussFunc = function (res) {
                if (res.data.success == true) {
                  blog.discussList = removeElementById(
                    blog.discussList,
                    discuss
                  );
                  $scope.$parent[$attrs.blog].discussList = blog.discussList;
                  getDiscuss($scope.$parent[$attrs.blog]);
                }
                $iq_loading.hide(); // 隐藏加载
              };
              $discuss_service.del(discussParam, delDiscussFunc);
            },
            function () {
              console.log("Cancel");
            }
          );
        };
      },
      templateUrl: function ($scope, $element, $attrs) {
        var uul = "";
        if ($element.netdisktype == "netdisk") {
          uul = "./templates/common/netdisk_discuss_show.html";
        } else {
          if ($element.type == "kanbantask") {
            uul = "./templates/common/plate_discuss_show.html";
          } else {
            uul = "./templates/common/discuss_show.html";
          }

          // uul = './templates/common/discuss_show.html';
        }
        return uul;
      },
    };
  }

  function iqtag() {
    return {
      restrict: "AE",
      scope: {
        obj: "=obj",
        tagtype: "=tagtype"
      },
      controller: function (
        $scope,
        $rootScope,
        $attrs,
        $element,
        $iq_http,
        $iq_server,
        $iq_popup,
        $iq_loading
      ) {
        $scope.myId = "";
        $scope.tjbq = "添加标签";
        $scope.labelAddButton = function (obj) {
          if (obj.addbutton == "yes") {
            obj.addbutton = "no";
            $scope.tjbq = "添加标签";
          } else {
            obj.addbutton = "yes";
            // $scope.tjbq = "隐藏";
          }
        };

        $scope.hideLabelClick = function (obj) {
          obj.addbutton = "no";
          $scope.tjbq = "添加标签";
          $scope.showSelect = false;
          $scope.searchTags = [];
        };

        // 打开直接查询该对象的标签
        var func = {
          success: function (res) {
            if (res.data.success == true) {
              // $scope.obj1 =
              // angular.extend($scope.obj,{labelObjectList:res.data.data});
              $scope.obj.labelObjectList = res.data.data.myList;
              $scope.myId = res.data.data.myId;
            } else {
              $iq_popup.alert(res.data.message, 3, "fail");
            }
          },
        };
        var params = {
          // params: {
          // "objId": $scope.obj.id
          // },
          method: "GET",
          url: $iq_server.server() + "labelobject/data/" + $scope.obj.id,
        };
        $iq_http.http(params, func);
        // 打开直接查询该对象的标签-结束
        $scope.tagType = $attrs.tagtype;
        var tagtype = $attrs.tagtype;
        // 保存
        $scope.addLabelClick = function () {
          // 点击发表
          var obj = $scope.$parent[$attrs.obj];

          var labelcontent = $("[name='labelcontent']", $element).val();
          if (labelcontent == null || labelcontent == undefined) {
            $iq_popup.alert("请输入标签内容！", 3, "warn");
            return;
          } else {
            labelcontent = labelcontent.trim();
          }

          if (labelcontent == "") {
            $iq_popup.alert("请输入标签内容！", 3, "warn");
            return;
          }

          var max = 10;
          var slc = labelcontent.split(" ");
          for (var p = 0; p < slc.length; p++) {
            if (slc[p].length > max) {
              $iq_popup.alert("每个标签最多不能超过10字！", 3, "warn");
              return;
            }
          }

          var addTime = getStringDate(new Date());
          var datas = {
            obj: obj,
            tagtype: tagtype,
            content: labelcontent,
            addTime: addTime,
          };

          $scope.success = "";

          var func = {
            success: function (res) {
              $scope.showSelect = false;
              $scope.searchTags = [];
              if (res.data.success == true) {
                $("[name='labelcontent']", $element).val("");

                $scope.obj.addbutton = "no";
                $scope.tjbq = "添加标签";

                $scope.obj.labelObjectList = res.data.data.myList;
                $scope.myId = res.data.data.myId;

                // 各自操作
                if ($scope.$parent.updateTag) {
                  // 如果父级scope里面有updateTag方法
                  $scope.$parent.updateTag(obj, $scope.obj.labelObjectList); // 调用其他模块的方法，以方便他们保存一份标签到自己的表中
                }
              } else {
                $iq_popup.alert(res.data.message, 3, "fail");
              }
              $iq_loading.hide(); // 隐藏加载
            },
          };
          var params = {
            data: datas,
            dataType: "json",
            method: "POST",
            url: $iq_server.server() + "label/data",
          };
          $iq_loading.show(); // 显示加载
          $iq_http.http(params, func);
        };
        // 保存-结束
        // 清空标签
        $scope.clearLabels = function () {
          $("[name='labelcontent']", $element).val("");
        };
        // 清空标签--结束
        $scope.deleteLabel = function (label, obj) {
          // 删除标签
          $iq_loading.show(); // 显示加载
          var func = {
            success: function (res) {
              if (res.data.success == true) {
                // $scope.obj.labelObjectList =
                // removeElement($scope.obj.labelObjectList,
                // label);
                $scope.obj.labelObjectList = res.data.data.myList;
                $scope.myId = res.data.data.myId;

                if ($scope.$parent.updateTag) {
                  // 如果父级scope里面有updateTag方法
                  $scope.$parent.updateTag(obj, $scope.obj.labelObjectList); // 调用其他模块的方法，以方便他们保存一份标签到自己的表中
                }
              } else {
                $iq_popup.alert(res.data.message, 3, "fail");
              }
              $iq_loading.hide(); // 隐藏加载
            },
          };
          var params = {
            // data: {
            // "objId": $scope.obj.id,
            // "label": label
            // },
            method: "DELETE",
            url:
              $iq_server.server() + "label/data/" + label + "/" + $scope.obj.id,
          };
          $iq_http.http(params, func);
        };
        $scope.showSelect = false;
        $scope.searchTags = [];
        $scope.searchLabel = "";
        $scope.tagSelectFunc = function () {
          setTimeout(function () {
            let label = $("[name='labelcontent']", $element).val().trim();
            findTags(label);
          }, 1500);
        };
        $scope.selectTag = function (item) {
          $("[name='labelcontent']").val(item);
          $scope.showSelect = false;
        };

        var findTags = function (keyword) {
          var params = {
            method: "GET",
            url: $iq_server.server() + "netdisk/tag/tags",
            params: { keyword: keyword },
          };

          var func = {
            success: function (res) {
              if ( res.data.success == true && res.data.list && res.data.list.length > 0 ) {
                $scope.showSelect = true;
                $scope.searchTags = res.data.list;
              } else {
                $scope.showSelect = false;
                $scope.searchTags = [];
              }
            },
          };

          $iq_http.http(params, func);
        };

        // $scope.$on("hideFileTagSearchResult",function(event, msg){
        //   $scope.showSelect = false;
        //   $scope.searchTags = [];
        // });
		
        $scope.curIndex = -1;
        $scope.keyDown = function(e){
          let curIndex = -1;
          //上下键获取焦点
          var key = window.event ? e.keyCode : e.which;
          $scope.curIndex = $('.search-tags-box li.search-tag-cur').size() > 0 ? $('.search-tags-box li.search-tag-cur').index() : -1;
          // if (key == 13){
          //   $('.search-tags-box li.search-tag-cur a').click();
          // } /*回车搜索*/

          if (key == 38) { /*向上按钮*/
            if($scope.curIndex > 0){
              $('.search-tags-box li').eq($scope.curIndex - 1).addClass('search-tag-cur').siblings('li').removeClass('search-tag-cur');
              curIndex = $scope.curIndex - 1;
            }else if($scope.curIndex == -1){
              $('.search-tags-box li').eq(0).addClass('search-tag-cur');
              curIndex = $scope.curIndex - 1;
            }else{
              $('.search-tags-box li').eq($('.search-tags-box li').size() - 1).addClass('search-tag-cur').siblings('li').removeClass('search-tag-cur');
              curIndex = $('.search-tags-box li').size() - 1;
            }
            var inputVal = $('.search-tags-box li.search-tag-cur').text().trim();
            $("[name='labelcontent']").val(inputVal);
          } else if (key == 40) {/*向下按钮*/
            if($scope.curIndex == -1){
              $('.search-tags-box li').eq(0).addClass('search-tag-cur');
              curIndex = $scope.curIndex + 1;
            }else if($scope.curIndex < $('.search-tags-box li').size() - 1){
              $('.search-tags-box li').eq($scope.curIndex + 1).addClass('search-tag-cur').siblings('li').removeClass('search-tag-cur');
              curIndex = $scope.curIndex + 1;
            }else{
              $('.search-tags-box li').eq(0).addClass('search-tag-cur').siblings('li').removeClass('search-tag-cur');
              curIndex = 0;
            }
            $("[name='labelcontent']").val($('.search-tags-box li.search-tag-cur').text().trim());
          }
          $('.search-tags-box').animate({
            scrollTop:  curIndex * 30
          })
        }

        $scope.mouseOver = function(index){
          $scope.curIndex = index;
          $('.search-tags-box li').eq(index).addClass('search-tag-cur').siblings('li').removeClass('search-tag-cur');
        }
      },
      templateUrl: "./templates/common/label.html",
    };
  }

  var iqTreeDept = function () {
    return {
      restrict: "AE",
      replace: true,
      scope: {
        data: "=*data",
        nodeclick: "=nodeclick",
        icheckclick: "=icheckclick",
        showdisdept: "=showdisdept",
        open: "=open",
        showicheck: "=showicheck",
        cid: "=cancelid",
        allicheck: "=allicheck",
      },
      templateUrl: "./templates/common/iq_tree_dept.html",
      controller: function ($scope, $attrs) {
        $scope.$on("deptopen", function (e) {
          $scope.isOpen = e.targetScope.isOpen;
          $scope.isChildOpen = e.targetScope.isChildOpen;
          if ($scope.isOpen == true) {
            $scope.toggle1 = true;
            $scope.toggle2 = false;
          } else {
            $scope.toggle1 = false;
            $scope.toggle2 = true;
          }
          if ($scope.isChildOpen == true) {
            $scope.toggle1 = true;
            $scope.toggle2 = true;
          }
        });

        // 显示选中样式
        $scope.id = "";
        $scope.active = function (node) {
          $scope.id = node.id;
        };
        if ($scope.cid) {
          $scope.cid = $scope.cancelid;
        }
        // 显示icheck框
        $scope.icheck = false;
        if ($scope.showicheck) {
          $scope.icheck = $scope.showicheck;
        }
        // 点击折叠或展开列表
        if ($scope.open) {
          $scope.toggle2 = $scope.open;
        }
        $scope.toggleclick = function (e) {
          this.toggle1 = !this.toggle1;
          this.toggle2 = !this.toggle2;
          if (e.stopPropagation) {
            e.stopPropagation(); // 标准浏览器的
          } else {
            e.cancelBubble = true; // IE浏览器
          }
        };

        // 点击折叠或展开未激活部门
        $scope.disdept = false;
        if ($scope.showdisdept) {
          $scope.disdept = $scope.showdisdept;
        }
        $scope.$watch("showdisdept", function (n, o) {
          $scope.disdept = n;
        });
        $scope.nodestatus = function (node) {
          if (node.status == 0) {
            return $scope.disdept;
          } else if (node.status == 1) {
            return true;
          }
        };
      },
    };
  };

  var iqSelect = function (
    $iq_http,
    $iq_server,
    $ocLazyLoad,
    $iq_popup_loadone
  ) {
    // 递归深度遍历部门数组获得节点
    var getallnode = function (data, getdata) {
      for (var i = 0; i < data.length; i++) {
        var tempdata = data[i];
        getdata.push(tempdata);
        if (tempdata.subDept && tempdata.subDept.length > 0) {
          getallnode(tempdata.subDept, getdata);
        }
      }
    };
    // 检测对象是否为空对象
    function isEmptyObject(obj) {
      for (var n in obj) {
        return false;
      }
      return true;
    }
    // 去掉对象的text属性
    function delText(obj) {
      if (obj instanceof Array) {
        for (var i = 0; i < obj.length; i++) {
          var cur = obj[i];
          delete cur.text;
        }
      } else {
        if (obj) {
          delete obj.text;
        }
      }
    }
    return {
      restrict: "A",
      scope: {
        url: "=url",
        updateparam: "=updateparam",
        selecttype: "=selecttype",
        select2Model: "=select2Model",
        choicedata: "=choicedata",
        withparam: "=withparam",
        manual: "=manual",
        time: "=time",
      },
      controller: function ($scope) {
        // 动态获取后台数据
        $scope.config = {};
        $scope.config.data = [];
        $scope.$watch("time", function (n, o) {
          if ($scope.time) {
            $scope.time = false;
            var tmpObj = {};
            tmpObj.time = true;
            $iq_popup_loadone.loadone(tmpObj);
          }
        });
        if (typeof $scope.url == "string") {
          $iq_popup_loadone.loadone($scope.url).then(
            function (re) {
              var getdata = [];
              getallnode(re, getdata);
              $scope.config.data = getdata;
              for (var i = 0; i < $scope.config.data.length; i++) {
                $scope.config.data[i].text = $scope.config.data[i].name;
              }
            },
            function () {
              return;
            }
          );
        } else {
          if ($scope.url && $scope.url.length > 0) {
            for (var i = 0; i < $scope.url.length; i++) {
              var tempurl = $scope.url[i];
              $iq_popup_loadone.loadone(tempurl).then(
                function (re) {
                  var getdata = [];
                  getallnode(re, getdata);
                  $scope.config.data = $scope.config.data.concat(getdata);
                  for (var i = 0; i < $scope.config.data.length; i++) {
                    $scope.config.data[i].text = $scope.config.data[i].name;
                  }
                },
                function () {
                  return;
                }
              );
            }
          }
        }
      },
      link: function (scope, element, attrs) {
        $ocLazyLoad
          .load({
            files: ["../lib/plugins/angular-select/select2.js"],
          })
          .then(function () {
            var tagName = element[0].tagName,
              config = {
                allowClear: true,
                multiple: !!attrs.multiple,
                placeholder: attrs.placeholder || " ",
              };

            // 处理input
            if (tagName === "INPUT") {
              var $element = $(element);
              // 动态生成select2
              scope.$watch(
                "config",
                function () {
                  angular.extend(config, scope.config);
                  $element.select2("destroy").select2(config);
                  if (isEmptyObject(scope.select2Model)) {
                    scope.select2Model = null;
                  }
                  // 监控带入的数据（withparam）
                  scope.$watch("withparam", function (n, o) {
                    // 对带入的数据进行对比和数据展示
                    if (scope.withparam && scope.withparam.length > 0) {
                      if (scope.selecttype == "single") {
                        scope.select2Model = null;
                      } else {
                        scope.select2Model = [];
                      }
                      for (var i = 0; i < scope.withparam.length; i++) {
                        var objselect = scope.withparam[i];
                        for (var j = 0; j < scope.config.data.length; j++) {
                          var objconfigid = scope.config.data[j];
                          if (scope.selecttype == "single") {
                            if (scope.withparam == objconfigid.id) {
                              scope.select2Model = objconfigid;
                              break;
                            }
                          } else {
                            if (objselect == objconfigid.id) {
                              scope.select2Model.push(objconfigid);
                            }
                          }
                        }
                      }
                    }
                    scope.choicedata = angular.copy(scope.select2Model);
                    delText(scope.choicedata);
                  });
                  // 监控未改变withparam值的 特殊参数（部门使用）
                  scope.$watch("manual", function (n, o) {
                    if (scope.manual) {
                      scope.manual = false;
                      if (scope.selecttype == "single") {
                        scope.select2Model = null;
                      } else {
                        scope.select2Model = [];
                      }
                    }
                  });
                  // 修改的时候自动赋值
                  scope.$watch("updateparam", function (n, o) {
                    if (scope.updateparam && scope.updateparam.length > 0) {
                      scope.select2Model = null;
                      for (var i = 0; i < scope.config.data.length; i++) {
                        var objconfigname = scope.config.data[i];
                        if (scope.updateparam == objconfigname.name) {
                          scope.select2Model = objconfigname;
                          break;
                        }
                      }
                    }
                  });
                  scope.$watch("choicedata", function (n, o) {
                    if (scope.choicedata == "") {
                      scope.select2Model = null;
                    }
                  });
                },
                true
              );
              // view - model
              $element.on("change", function () {
                scope.$apply(function () {
                  scope.select2Model = $element.select2("data");
                });
              });
              // model - view
              scope.$watch(
                "select2Model",
                function (newVal) {
                  $element.select2("data", newVal);
                  scope.choicedata = angular.copy(scope.select2Model);
                  delText(scope.choicedata);
                },
                true
              );
            }
          });
      },
    };
  };

  var iqInputSelect = function ($iq_popup) {
    return {
      restrict: "E",
      replace: true,
      scope: {
        choicedata: "=choicedata",
        popuptype: "=popuptype",
        updateparam: "=updateparam",
        withparam: "=withparam",
        disabled: "=disabled",
        manual: "=manual",
        disdept: "=disdept",
        time: "=time",
        manualurl: "=manualurl",
      },
      templateUrl: "./templates/common/iq_popupinput.html",
      controller: function ($scope) {
        // 创建禁止修改的对象
        $scope.disable = false;
        $scope.$watch("disabled", function (n, o) {
          $scope.disable = n;
        });
        // 处理带入的choicedata参数
        if ($scope.choicedata) {
          if ($scope.choicedata instanceof Array) {
            for (var i = 0; i < $scope.choicedata.length; i++) {
              var cur = $scope.choicedata[i];
              cur.text = cur.name;
            }
          } else {
            if ($scope.choicedata.name) {
              $scope.choicedata.text = $scope.choicedata.name;
            }
          }
        }
        // 自动匹配模糊选择的类型参数
        if (
          $scope.popuptype == "deptSingle" ||
          $scope.popuptype == "peopleSingle" ||
          $scope.popuptype == "roleSingle_D" ||
          $scope.popuptype == "roleSingle_C" ||
          $scope.popuptype == "roleSingle_DC"
        ) {
          $scope.selecttypetemp = "single";
        } else {
          $scope.selecttypetemp = "multiple";
        }
        // 自动匹配模糊选择的url
        var tempdept = "status-filter:1";
        if ($scope.disdept) {
          tempdept = $scope.disdept;
        }
        if (
          $scope.popuptype == "deptSingle" ||
          $scope.popuptype == "deptMultiple"
        ) {
          if ($scope.manualurl) {
            $scope.url = $scope.manualurl;
          } else {
            $scope.url = "departments/" + tempdept + "/tree";
          }
        } else if (
          $scope.popuptype == "peopleSingle" ||
          $scope.popuptype == "peopleMultiple"
        ) {
          $scope.url = "persons/all-active?up_executive=1";
        } else if ($scope.popuptype == "deptPeople") {
          $scope.url = [
            "departments/" + tempdept + "/tree",
            "persons/all-active",
          ];
        } else if ($scope.popuptype == "team") {
          $scope.url = [
            "departments/" + tempdept + "/tree",
            "persons/all-active",
          ];
        } else if ($scope.popuptype == "shareFile") {
          $scope.url = [
            "departments/" + tempdept + "/tree",
            "persons/all-active",
          ];
        } else if ($scope.popuptype == "roleSingle_D") {
          $scope.url = "stations?&pageSize=999999999";
        } else if ($scope.popuptype == "roleSingle_C") {
          $scope.url = "roles?&pageSize=999999999";
        } else if ($scope.popuptype == "roleSingle_DC") {
          $scope.url = [
            "stations?&pageSize=999999999",
            "roles?&pageSize=999999999",
          ];
        }
        // 点击弹出框事件
        $scope.popclick = function () {
          if ($scope.popuptype == "deptSingle") {
            // 传入的是部门单项选择

            var deptlist = $iq_popup.deptlist(
              $scope.choicedata,
              "single",
              $scope.manualurl
            );
            deptlist.then(
              function (re) {
                re[0].text = re[0].name;
                $scope.tmpchoicedata = re[0];
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "deptMultiple") {
            // 传入的是部门多项选择
            var deptlist = $iq_popup.deptlist($scope.choicedata);
            deptlist.then(
              function (re) {
                for (var i = 0; i < re.length; i++) {
                  var cur = re[i];
                  cur.text = cur.name;
                }
                $scope.tmpchoicedata = re;
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "peopleSingle") {
            // 传入的是人员单项选择
            var deptpeople = $iq_popup.deptpeople($scope.choicedata, "single");
            deptpeople.then(
              function (re) {
                if (re.length == 0) {
                  $scope.tmpchoicedata = null;
                } else {
                  re[0].text = re[0].name;
                  $scope.tmpchoicedata = re[0];
                }
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "peopleMultiple") {
            // 传入的是人员多项选择
            var deptpeople = $iq_popup.deptpeople($scope.choicedata);
            deptpeople.then(
              function (re) {
                for (var i = 0; i < re.length; i++) {
                  var cur = re[i];
                  cur.text = cur.name;
                }
                $scope.tmpchoicedata = re;
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "deptPeople") {
            // 传入的是人员&&部门多项选择
            var team = $iq_popup.sharefile($scope.choicedata);
            team.then(
              function (re) {
                for (var i = 0; i < re.length; i++) {
                  var cur = re[i];
                  cur.text = cur.name;
                }
                $scope.tmpchoicedata = re;
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "team") {
            // 选择弹出框 team
            // 默认自带部门和人员
            // 'team' 为团队
            var team = $iq_popup.sharefile($scope.choicedata, "team");
            team.then(
              function (re) {
                for (var i = 0; i < re.length; i++) {
                  var cur = re[i];
                  cur.text = cur.name;
                }
                $scope.tmpchoicedata = re;
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "shareFile") {
            // 选择弹出框
            // sharefile
            // 默认自带部门和人员
            // 'file'
            // 为文件库
            var sharefile = $iq_popup.sharefile($scope.choicedata, "file");
            sharefile.then(
              function (re) {
                for (var i = 0; i < re.length; i++) {
                  var cur = re[i];
                  cur.text = cur.name;
                }
                $scope.tmpchoicedata = re;
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "roleSingle_D") {
            // 角色组件弹出框
            // D->dept
            // C->company
            // DC->dept&&company
            var role = $iq_popup.role($scope.choicedata, "single", "showDept");
            role.then(
              function (re) {
                re[0].text = re[0].name;
                $scope.tmpchoicedata = re[0];
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "roleSingle_C") {
            // 角色组件弹出框
            // D->dept
            // C->company
            // DC->dept&&company
            var role = $iq_popup.role(
              $scope.choicedata,
              "single",
              "showCompany"
            );
            role.then(
              function (re) {
                re[0].text = re[0].name;
                $scope.tmpchoicedata = re[0];
              },
              function () {
                console.log("cancel");
              }
            );
          } else if ($scope.popuptype == "roleSingle_DC") {
            // 角色组件弹出框
            // D->dept
            // C->company
            // DC->dept&&company
            var role = $iq_popup.role(
              $scope.choicedata,
              "single",
              "showDeptCompany"
            );
            role.then(
              function (re) {
                re[0].text = re[0].name;
                $scope.tmpchoicedata = re[0];
              },
              function () {
                console.log("cancel");
              }
            );
          }
        };
      },
    };
  };

  //excel模板导入 chiheng 2016-09-19
  var iqExcelUploader = function ($ocLazyLoad) {
    var loadjs = false;
    return {
      restrict: "E",
      replace: true,
      scope: {
        url: "=url",
        excelCallback: "=",
      },
      templateUrl: "./templates/common/iq_excel_uploader.html",
      controller: function (
        $scope,
        $attrs,
        $iq_server,
        FileUploader,
        $iq_http,
        $iq_popup,
        $iq_excel
      ) {
        var moduleCode = $attrs.moduleCode;
        var form = $attrs.form;
        var org = $attrs.org;
        var url = $scope.url;
        var uploader = ($scope.uploader = new FileUploader({
          url: $iq_server.server() + "excel/upload",
        }));
        uploader.filters.push({
          name: "type_Filter",
          fn: function (item, options) {
            // 判断文件后缀名是否符合
            if (item.name != null && item.name.length > 0) {
              var dot = item.name.lastIndexOf(".");
              if (dot > -1 && dot < item.name.length - 1) {
                fileNameEnd = item.name.substring(dot + 1);
              }
            }
            if (fileNameEnd != "xls" && fileNameEnd != "xlsx") {
              return false;
            } else return true;
          },
        });

        // CALLBACKS
        uploader.onWhenAddingFileFailed = function (item, filter, options) {
          if (filter.name == "type_Filter") {
            $iq_popup.alert("请上传后缀名为“xls”或“xlsx”的文件！", "2", "fail");
          }
        };
        uploader.onAfterAddingAll = function (fileItems) {
          if (fileItems.length > 1) {
            uploader.queue = [];
            $iq_popup.alert("对不起，只能上传一个excel文件！", "2", "fail");
          } else {
            uploader.uploadAll();
            var func = $iq_excel.upload_progress(uploader, fileItems[0]);
            func.then(function (re) {
              re.queue = [];
            });
          }
        };
        uploader.onSuccessItem = function (
          fileItem,
          response,
          status,
          headers
        ) {
          $iq_excel.handle_excel(url, response.message, function (data) {
            var func = $iq_excel.display_contents(data);
            func.then(function (re) {
              $scope.excelCallback = re;
            });
          });
        };

        //下载excel模板
        $scope.download = function () {
          $iq_excel.download_auth(moduleCode, form, org, function (re) {
            if (re == true) {
              window.location.href =
                $iq_server.server() +
                "excel/download/" +
                moduleCode +
                "/" +
                form +
                "/" +
                org;
            }
          });
        };

        $scope.batchUpload = function () {
          document.querySelector("#excel_uploader").click();
        };
      },
    };
  };
  var iqClipboard = function () {
    return {
      restrict: "A",
      scope: {
        iqClipboard: "=",
        copySuccess: "&",
        copyFallback: "&",
      },
      link: function (scope, element, iAttr, ctrl, $transclude) {
        var clipboard = new Clipboard(element[0], {
          text: function (trigger) {
            return scope.iqClipboard;
          },
        });
        clipboard.on("success", function (e) {
          if (angular.isDefined(iAttr.copySuccess)) {
            scope.$apply(scope.copySuccess);
          }

          e.clearSelection();
        });

        clipboard.on("error", function (e) {
          if (angular.isDefined(iAttr.copyFallback)) {
            scope.$apply(scope.copyFallback);
          }
        });
      },
    };
  };
  // 文件上传 zhangwen修改

  var iqUploader = function ($ocLazyLoad) {
    var loadjs = false;
    return {
      restrict: "AE",
      replace: true,
      scope: {
        // 新建作用域,没有原型继承
        data: "=data",
        obj: "=obj",
        uploading: "=uploading",
        type: "=type",
        // 其他可选attr参数
        // maximum:"=maximum",// 上传文件最大数量
        // maxisize:"=maxisize",// 上传文件最大值
        // filepath:"=filepath",//
        // 上传路径，默认是/resource/userid/,不为空时则/resource/userid/filepath
        // file_label:"=label" // label
        // show_icon:"=show_icon" // show_icon
        // app_type:"=app_type" // 0代表是form表单上的上传附件，默认是0，1代表有弹出层的上传附件
      },

      // 放到开始加载
      compile: function () {
        if (!loadjs) {
          loadjs = true;
          var res = {
            name: "angularFileUpload",
            files: ["../lib/plugins/angular-upload/angular-file-upload.js"],
          };
          if (old_browser.IE && old_browser.version <= 9) {
            res.files.push(
              "../lib/plugins/angular-upload/ng-file-upload-shim.min.js"
            );
          }
          var lazyLoadPromise = $ocLazyLoad.load(res);
          return lazyLoadPromise;
        }
      },
      controller: function (
        $scope,
        $attrs,
        $iq_server,
        FileUploader,
        $iq_http,
        $iq_popup,
        $q
      ) {
        var promise_index = 0;
        var promise_array = [];
        var def_array = [];
        /**
         * 新文件上传，创建primise
         */
        var newUploading = function (fileItem) {
          $scope.uploading = true;
          fileItem.promise_index = promise_index;
          var def = $q.defer();
          // 新建def
          def_array.push(def);
          promise_array.push(def.promise);
          promise_index++;

          // 在所有的上传 完成之后
          $q.all(promise_array).then(function () {
            if (fileItem.promise_index + 1 == promise_array.length) {
              $scope.uploading = false;
            }
          });
        };
        $scope.app_type = $attrs.appType | 0;

        $scope.isIE = false;
        if (old_browser.IE && old_browser.version <= 9) {
          $scope.isIE = true;
        }
        // 是否显示附件图标，如果要显示设置属性show_icon=true,默认不显示
        var show_icon = $attrs.showIcon;
        $scope.show_icon =
          show_icon == undefined || show_icon == null || show_icon == ""
            ? true
            : show_icon;

        // 模块名
        var module = $attrs.modelName;

        if (module != undefined && module != null && module != "") {
          $scope.url = $iq_server.server() + "common/file/upload/" + module;
        } else {
          $scope.url = $iq_server.server() + "common/file/upload/";
        }

        // 文件最大值，设置属性maxisize=9，默认是10M
        var maxisize = $attrs.maxisize;
        $scope.maxisize =
          maxisize == undefined || maxisize == null || maxisize == ""
            ? 10
            : maxisize;
        // 上传文件的最大数量，设置属性maximum=5，默认最大数据为9
        var maximum = $attrs.maximum;
        $scope.maximum =
          maximum == undefined || maximum == null || maximum == ""
            ? 9
            : maximum;
        var uploader = ($scope.uploader = new FileUploader({
          url: $scope.url,
          maxSize: $scope.maxisize,
          queueLimit: $scope.maximum,
        }));
        $scope.upFiles = [];
        // 是否显示附件label，设置fileLabel='上传',不传则不显示
        $scope.fileLabel = $attrs.fileLabel;
        // 限制上传的文件类型
        $scope.limitFileType = $attrs.limitType;

        // 监听数据变化 data指的是文件了列表
        $scope.$watchCollection("data", function (newVal, old) {
          newVal = newVal == undefined || newVal == null ? [] : newVal;
          old = old == undefined || old == null ? [] : old;
          if (newVal.length == 0) {
            uploader.queue = [];
            $scope.sourceFiles = [];
            $scope.upFiles = [];
            $scope.targetFiles = [];
            uploader.setExistLimit(0);
          }

          if (angular.isArray(newVal) && angular.isArray(old)) {
            if (newVal.length != old.length) {
              // 最后返回的文件总记录
              $scope.targetFiles = $scope.$parent[$attrs.data];
            }
            // 第一次时加载原来的
            if ($scope.upFiles.length == 0) {
              // 原来的，可为null
              $scope.sourceFiles = angular.copy($scope.$parent[$attrs.data]);
              $scope.existLimit = $scope.sourceFiles
                ? $scope.sourceFiles.length
                : 0;
              uploader.setExistLimit($scope.existLimit);
            }
          }
        });
        uploader.onProgressItem = function (item, progress) {
          item.progressStyle = { width: progress + "%" };
        };
        uploader.onAfterAddingFile = function (fileItem) {
          newUploading(fileItem);

          if ($scope.limitFileType == "IMGAGE") {
            var fileName = fileItem.file.name;
            var fileType = fileName.substring(
              fileName.indexOf(".") + 1,
              fileName.length
            );
            if (
              fileType != "bmp" &&
              fileType != "BMP" &&
              fileType != "svg" &&
              fileType != "SVG" &&
              fileType != "jpg" &&
              fileType != "JPG" &&
              fileType != "jpeg" &&
              fileType != "JPEG" &&
              fileType != "gif" &&
              fileType != "GIF" &&
              fileType != "png" &&
              fileType != "PNG"
            ) {
              // 移除已经上传的
              var list = uploader.queue;
              var flag = false;
              for (var i = 0, j = 0; j < list.length; i++, j++) {
                if (list[i].file.name == fileName) {
                  if (!flag) {
                    j++;
                    flag = true;
                  }
                }
                list[i] = list[j];
              }
              if (flag) {
                list.length = list.length - 1;
              }
              uploader.queue = list;
              $iq_popup.alert(
                "对不起，您只能上传bmp,svg,jpg,jpeg,gif,png类型的文件！",
                3,
                "warn"
              );
              return;
            } else {
              fileItem.upload(1);
            }
          } else {
            fileItem.upload(1);
          }
        };
        uploader.onCompleteItem = function (
          fileItem,
          response,
          status,
          headers
        ) {
          var _result = response;
          if (old_browser.IE && old_browser.version <= 9) {
            _result = new Function("return " + $(response).text())();
          }
          if (_result.success) {
            if ($scope.upFiles == null) {
              $scope.upFiles = new Array();
            }
            fileItem.fileSize = _result.data.fileSize; // =
            // angular.extend(fileItem,_result.data);
            fileItem.fileName = _result.data.fileName;
            fileItem.fileId = _result.data.fileId;
            // fileItem.id = _result.data.id;

            var tmp_file = angular.copy(_result.data);

            $scope.upFiles.push(tmp_file);

            if ($scope.sourceFiles) {
              var newArr = new Array();
              $scope.targetFiles = newArr.concat(
                $scope.sourceFiles,
                $scope.upFiles
              );
            } else {
              $scope.targetFiles = $scope.upFiles;
            }
            $scope.$parent[$attrs.data] = $scope.targetFiles;
            var t = fileItem.promise_index;
            if (def_array[t]) def_array[t].resolve();
          } else {
            $iq_popup.alert(_result.message, 3, "warn");
            //uploader.queue.pop();
          }
        };
        $scope.selfdownload = function (file) {
          if (file && file.fileId) {
            window.location.href =
              $iq_server.server() +
              "common/file/selfdownload/" +
              file.fileId +
              "?" +
              file.fileName;
          } else {
            $iq_popup.alert("文件不存在", 3, "warn");
          }
        };
        $scope.download = function (file) {
          if (module && file && file.id) {
            if ($scope.obj && $scope.obj.id) {
              window.location.href =
                $iq_server.server() +
                "file/download/" +
                module +
                "/" +
                $scope.obj.id +
                "/" +
                file.id;
            } else {
              window.location.href =
                $iq_server.server() +
                "common/file/selfdownload/" +
                file.fileId +
                "?" +
                file.fileName;
            }
          } else {
            $iq_popup.alert("文件不存在", 3, "warn");
          }
        };

        var delUpFile = function (fileId, item) {
          if (item) {
            //console.log(item.fileId);
            item.remove();
            $scope.upFiles = $scope.removeOne(
              $scope.upFiles,
              item.fileId || item.filePath
            );
            var t = item.promise_index;
            if (def_array[t]) def_array[t].resolve();
          }
          if (fileId) {
            if ($scope.sourceFiles) {
              $scope.sourceFiles = $scope.removeOne($scope.sourceFiles, fileId);
              $scope.existLimit = $scope.sourceFiles
                ? $scope.sourceFiles.length
                : 0;
              uploader.setExistLimit($scope.existLimit);
            }
            if ($scope.upFiles) {
              $scope.upFiles = $scope.removeOne($scope.upFiles, fileId);
            }
          }
        };
        //删除正在上传中的项目
        $scope.delCancelFile = function (item) {
          $iq_popup.confirm("确定删除不继续上传吗？").then(function () {
            delUpFile(null, item);
          });
        };
        // 移除数组中对象

        $scope.removeOne = function (files, fileId) {
          var list = files;
          var flag = false;
          for (var i = 0, j = 0; j < list.length; i++, j++) {
            if (list[i]["fileId"] == fileId || list[i]["id"] == fileId) {
              j++;
              flag = true;
            }
            list[i] = list[j];
          }
          if (flag) {
            list.length = list.length - 1;
          }
          return (files = angular.copy(list));
        };

        // 删除文件
        $scope.delFile = function (fileId, item) {
          $iq_popup.confirm("确定删除吗？").then(function () {
            delUpFile(fileId, item);
            $iq_popup.alert("删除成功！", 3, "success");

            if ($scope.sourceFiles) {
              var newArr = new Array();
              $scope.targetFiles = newArr.concat(
                $scope.sourceFiles,
                $scope.upFiles
              );
            } else {
              $scope.targetFiles = $scope.upFiles;
            }
            $scope.$parent[$attrs.data] = $scope.targetFiles;
          });
        };
      },
      templateUrl: function (tElement, tAttrs) {
        var url = "";
        if (tAttrs.appType == "2") {
          url = "./templates/common/iq_form_uploader_2.html";
        } else {
          if (tAttrs.type == "netdisk") {
            url = "./templates/common/iq_form_uploader3.html";
          } else {
            url = "./templates/common/iq_form_uploader.html";
          }
        }
        return url;
      },
    };
  };

  // 图片上传
  var iqImguploader = function ($ocLazyLoad) {
    var loadjs = false;
    return {
      restrict: "AE",
      replace: true,
      scope: {
        // 新建作用域,没有原型继承
        data: "=data",
        obj: "=obj",
        uploading: "=uploading",
        limittype: "=limittype",
        // 其他可选attr参数
        // maximum:"=maximum",// 上传文件最大数量
        // maxisize:"=maxisize",// 上传文件最大值
        // filepath:"=filepath",//
        // 上传路径，默认是/resource/userid/,不为空时则/resource/userid/filepath
        // file_label:"=label" // label
        // show_icon:"=show_icon" // show_icon
        // app_type:"=app_type" // 0代表是form表单上的上传附件，默认是0，1代表有弹出层的上传附件
      },
      templateUrl: function (tElement, tAttrs) {
        return "./templates/common/iq_form_uploader_img.html";
      },
      // 放到开始加载
      compile: function () {
        if (!loadjs) {
          loadjs = true;
          var res = {
            name: "angularFileUpload",
            files: ["../lib/plugins/angular-upload/angular-file-upload.js"],
          };
          if (old_browser.IE && old_browser.version <= 9) {
            res.files.push(
              "../lib/plugins/angular-upload/ng-file-upload-shim.min.js"
            );
          }
          var lazyLoadPromise = $ocLazyLoad.load(res);
          return lazyLoadPromise;
        }
      },
      controller: function (
        $scope,
        $attrs,
        $iq_server,
        FileUploader,
        $iq_http,
        $iq_popup,
        $q
      ) {
        var promise_index = 0;
        var promise_array = [];
        var def_array = [];
        /**
         * 新文件上传，创建primise
         */
        var newUploading = function (fileItem) {
          $scope.uploading = true;
          fileItem.promise_index = promise_index;
          var def = $q.defer();
          def_array.push(def);
          promise_array.push(def.promise);
          promise_index++;

          $q.all(promise_array).then(function () {
            if (fileItem.promise_index + 1 == promise_array.length) {
              $scope.uploading = false;
            }
          });
        };
        $scope.app_type = $attrs.appType | 0;

        $scope.isIE = false;
        if (old_browser.IE && old_browser.version <= 9) {
          $scope.isIE = true;
        }
        // 是否显示附件图标，如果要显示设置属性show_icon=true,默认不显示
        var show_icon = $attrs.showIcon;
        $scope.show_icon =
          show_icon == undefined || show_icon == null || show_icon == ""
            ? true
            : show_icon;

        // 模块名
        var module = $attrs.modelName;

        if (module != undefined && module != null && module != "") {
          $scope.url = $iq_server.server() + "common/file/upload/" + module;
        } else {
          $scope.url = $iq_server.server() + "common/file/upload/";
        }

        // 文件最大值，设置属性maxisize=9，默认是10M
        var maxisize = $attrs.maxisize;
        $scope.maxisize =
          maxisize == undefined || maxisize == null || maxisize == ""
            ? 10
            : maxisize;
        // 上传文件的最大数量，设置属性maximum=5，默认最大数据为9
        var maximum = $attrs.maximum;
        $scope.maximum =
          maximum == undefined || maximum == null || maximum == ""
            ? 9
            : maximum;
        var uploader = ($scope.uploader = new FileUploader({
          url: $scope.url,
          maxSize: $scope.maxisize,
          queueLimit: $scope.maximum,
        }));
        $scope.upFiles = [];
        // 是否显示附件label，设置fileLabel='上传',不传则不显示
        $scope.fileLabel = $attrs.fileLabel;
        // 限制上传的文件类型
        $scope.limitFileType = $attrs.limittype;

        // 监听数据变化
        $scope.$watchCollection("data", function (newVal, old) {
          newVal = newVal == undefined || newVal == null ? [] : newVal;
          old = old == undefined || old == null ? [] : old;
          if (newVal.length == 0) {
            uploader.queue = [];
            $scope.sourceFiles = [];
            $scope.upFiles = [];
            $scope.targetFiles = [];
            uploader.setExistLimit(0);
          }

          if (angular.isArray(newVal) && angular.isArray(old)) {
            if (newVal.length != old.length) {
              // 最后返回的文件总记录
              $scope.targetFiles = $scope.$parent[$attrs.data];
            }
            // 第一次时加载原来的
            if ($scope.upFiles.length == 0) {
              // 原来的，可为null
              $scope.sourceFiles = angular.copy($scope.$parent[$attrs.data]);
              $scope.existLimit = $scope.sourceFiles
                ? $scope.sourceFiles.length
                : 0;
              uploader.setExistLimit($scope.existLimit);
            }
          }
        });
        uploader.onAfterAddingFile = function (fileItem) {
          newUploading(fileItem);
          $scope.limitFileType = $attrs.limittype;
          if ($scope.limitFileType == "IMGAGE") {
            var fileName = fileItem.file.name;
            var fileType = fileName.substring(
              fileName.indexOf(".") + 1,
              fileName.length
            );
            if (
              fileType != "bmp" &&
              fileType != "BMP" &&
              fileType != "svg" &&
              fileType != "SVG" &&
              fileType != "jpg" &&
              fileType != "JPG" &&
              fileType != "jpeg" &&
              fileType != "JPEG" &&
              fileType != "gif" &&
              fileType != "GIF" &&
              fileType != "png" &&
              fileType != "PNG"
            ) {
              // 移除已经上传的
              var list = uploader.queue;
              var flag = false;
              for (var i = 0, j = 0; j < list.length; i++, j++) {
                if (list[i].file.name == fileName) {
                  if (!flag) {
                    j++;
                    flag = true;
                  }
                }
                list[i] = list[j];
              }
              if (flag) {
                list.length = list.length - 1;
              }
              uploader.queue = list;
              // $iq_popup.alert("对不起，您只能上传bmp,svg,jpg,jpeg,gif,png类型的文件！",3,'warn');
              $iq_popup.alert("对不起，您只能上传图片！", 3, "warn");
              return;
            } else {
              fileItem.upload(1);
            }
          } else {
            fileItem.upload(1);
          }
        };
        uploader.onCompleteItem = function (
          fileItem,
          response,
          status,
          headers
        ) {
          var _result = response;
          if (old_browser.IE && old_browser.version <= 9) {
            _result = new Function("return " + $(response).text())();
          }
          if (_result.success) {
            if ($scope.upFiles == null) {
              $scope.upFiles = new Array();
            }
            fileItem.fileSize = _result.data.fileSize; // =
            // angular.extend(fileItem,_result.data);
            fileItem.fileName = _result.data.fileName;
            fileItem.fileId = _result.data.fileId;
            var previewPath =
              $iq_server.server() +
              "common/file/selfdownload/" +
              _result.data.fileId.replace("\\", "/") +
              "?" +
              _result.data.fileName;
            fileItem.previewPath = previewPath;
            _result.data.previewPath = previewPath;

            var tmp_file = angular.copy(_result.data);

            $scope.upFiles.push(tmp_file);

            if ($scope.sourceFiles) {
              var newArr = new Array();
              $scope.targetFiles = newArr.concat(
                $scope.sourceFiles,
                $scope.upFiles
              );
            } else {
              $scope.targetFiles = $scope.upFiles;
            }
            $scope.$parent[$attrs.data] = $scope.targetFiles;
          } else {
            $iq_popup.alert(_result.message, 3, "warn");
            uploader.queue.pop();
          }
          var t = fileItem.promise_index;
          if (def_array[t]) def_array[t].resolve();
        };
        $scope.selfdownload = function (file) {
          if (file && file.fileId) {
            window.location.href =
              $iq_server.server() +
              "common/file/selfdownload/" +
              file.fileId +
              "?" +
              file.fileName;
          } else {
            $iq_popup.alert("文件不存在", 3, "warn");
          }
        };
        $scope.download = function (file) {
          if (module && file && file.id) {
            if ($scope.obj.id) {
              window.location.href =
                $iq_server.server() +
                "file/download/" +
                module +
                "/" +
                $scope.obj.id +
                "/" +
                file.id;
            } else {
              window.location.href =
                $iq_server.server() +
                "common/file/selfdownload/" +
                file.fileId +
                "?" +
                file.fileName;
            }
          } else {
            $iq_popup.alert("文件不存在", 3, "warn");
          }
        };

        var delUpFile = function (fileId, item) {
          if (item) {
            item.remove();
            $scope.upFiles = $scope.removeOne($scope.upFiles, item.fileId);
          }
          if (fileId) {
            if ($scope.sourceFiles) {
              $scope.sourceFiles = $scope.removeOne($scope.sourceFiles, fileId);
              $scope.existLimit = $scope.sourceFiles
                ? $scope.sourceFiles.length
                : 0;
              uploader.setExistLimit($scope.existLimit);
            }
            if ($scope.upFiles) {
              $scope.upFiles = $scope.removeOne($scope.upFiles, fileId);
            }
          }
        };
        $scope.delCancelFile = function (item) {
          $iq_popup.confirm("确定删除不继续上传吗？").then(function () {
            delUpFile(null, item);
          });
        };
        // 移除数组中对象

        $scope.removeOne = function (files, fileId) {
          var list = files;
          var flag = false;
          for (var i = 0, j = 0; j < list.length; i++, j++) {
            if (list[i]["fileId"] == fileId) {
              j++;
              flag = true;
            }
            list[i] = list[j];
          }
          if (flag) {
            list.length = list.length - 1;
          }
          return (files = angular.copy(list));
        };

        // 删除文件
        $scope.delFile = function (fileId, item) {
          $iq_popup.confirm("确定删除吗？").then(function () {
            delUpFile(fileId, item);

            $iq_popup.alert("删除成功！", 3, "success");

            if ($scope.sourceFiles) {
              var newArr = new Array();
              $scope.targetFiles = newArr.concat(
                $scope.sourceFiles,
                $scope.upFiles
              );
            } else {
              $scope.targetFiles = $scope.upFiles;
            }
            $scope.$parent[$attrs.data] = $scope.targetFiles;
          });
        };
      },
    };
  };

  // 新闻轮播
  var iqSlider = function ($timeout) {
    return {
      restrict: "AE",
      replace: true,
      scope: {
        swidth: "=swidth",
        sheigth: "=sheigth",
        mask: "=mask",
      },
      templateUrl: "./templates/common/iq_slider_test.html",
      controller: function ($scope, $iq_server, $iq_http, $location, $attrs) {
        $scope.sliderwidth = $attrs.swidth;
        $scope.sliderheigth = $attrs.sheigth;
        $scope.masking = true;
        if ($attrs.mask) {
          $scope.masking = $scope.mask;
        }

        $scope.iq_serverPath = $iq_server.server();

        $scope.newslist = null;
        var getNewsData = $iq_http.http({
          method: "GET",
          url: $iq_server.server() + "news/data/slider",
        });
        getNewsData.then(
          function (re) {
            list = re.data.data.list;
            $scope.newslist = list;
          },
          function () {
            return;
          }
        );

        $scope.enterToNews = function (obj) {
          $location.path("/news/content/" + obj.id);
        };
      },
    };
  };

  // 商城轮播
  var istoreSlider = function ($timeout) {
    return {
      restrict: "AE",
      replace: true,
      scope: {
        swidth: "=swidth",
        sheigth: "=sheigth",
        mask: "=mask",
      },
      templateUrl: "./templates/common/iq_slider_istore.html",
      controller: function (
        $scope,
        $iq_server,
        $iq_http,
        $location,
        $attrs,
        $iq_istore_service
      ) {
        $scope.sliderwidth = $attrs.swidth;
        $scope.sliderheigth = $attrs.sheigth;
        $scope.masking = true;
        if ($attrs.mask) {
          $scope.masking = $scope.mask;
        }

        $scope.iq_serverPath = $iq_server.server();

        $scope.istoreSliders = $iq_istore_service.list;
      },
    };
  };

  angular
    .module("iq_common")
    .directive("iqTable", iqtable)
    .directive("iqPagerList", iqPagerList)
    .directive("iqPagerListPager", iqPagerListPager)
    .directive("iqPagerMore", iqPagerMore)
    .directive("iqDiscuss", iqdiscuss)
    .directive("iqDiscussShow", iqdiscussshow)
    .directive("iqTag", iqtag)
    .directive("iqTreeDept", iqTreeDept)
    .directive("iqSelect", iqSelect)
    .directive("iqInputSelect", iqInputSelect)
    .directive("iqUploader", ["$ocLazyLoad", iqUploader])
    .directive("iqExcelUploader", ["$ocLazyLoad", iqExcelUploader])
    .directive("iqImguploader", ["$ocLazyLoad", iqImguploader])
    .directive("iqSlider", iqSlider)
    .directive("istoreSlider", istoreSlider)
    .directive("iqClipboard", iqClipboard)

    .directive("iqPermission", function (
      $animate,
      $iq_http,
      $iq_server,
      $iq_permission
    ) {
      // 权限控制directive 模仿ngShow 传入权限，根据当前登录人的权限对dom加载与否
      // 完成度80%
      // 后续优化：权限本地化

      var NG_HIDE_CLASS = "ng-hide";
      var NG_HIDE_IN_PROGRESS_CLASS = "ng-hide-animate";
      return {
        // multiElement: true,
        // transclude: 'element',
        // priority: 600,
        // terminal: true,
        // restrict: 'A',
        restrict: "A",
        multiElement: true,
        link: function (scope, iElement, iAttr, ctrl, $transclude) {
          var block, childScope, previousElements;
          /*
           * function getBlockNodes(nodes) { //
           * TODO(perf): just check if all items in
           * `nodes` are siblings and if they are return
           * the original // collection, otherwise update
           * the original collection. var node = nodes[0];
           * var endNode = nodes[nodes.length - 1]; var
           * blockNodes = [node];
           *
           * do { node = node.nextSibling; if (!node)
           * break; blockNodes.push(node); } while (node
           * !== endNode);
           *
           * return $(blockNodes); }
           */
          var changeClass = function (value) {
            // copy of ng-show
            $animate[value ? "removeClass" : "addClass"](
              iElement,
              NG_HIDE_CLASS,
              {
                tempClasses: NG_HIDE_IN_PROGRESS_CLASS,
              }
            );
            /*
             * //copy of ng-if if (value) { if
             * (!childScope) {
             * $transclude(function(clone, newScope) {
             * childScope = newScope;
             * clone[clone.length++] =
             * document.createComment(' end ngIf: ' +
             * iAttr.ngIf + ' '); // Note: We only need
             * the first/last node of the cloned nodes. //
             * However, we need to keep the reference to
             * the jqlite wrapper as it might be changed
             * later // by a directive with templateUrl
             * when its template arrives. block = {
             * clone: clone }; $animate.enter(clone,
             * iElement.parent(), iElement); }); } }
             * else { if (previousElements) {
             * previousElements.remove();
             * previousElements = null; } if
             * (childScope) { childScope.$destroy();
             * childScope = null; } if (block) {
             * previousElements =
             * getBlockNodes(block.clone);
             * $animate.leave(previousElements).then(function() {
             * previousElements = null; }); block =
             * null; } }
             */
          };
          changeClass(false); // 先隐藏
          scope.$watch(iAttr.iqPermission, function ngShowWatchAction(
            permission
          ) {
            var func = $iq_permission.has;
            var v = "";
            var reverse = false;
            if (angular.isString(permission)) {
              v = permission; // 直接取字符串
            } else if (permission != undefined) {
              v = permission.v;
              if (permission.key && permission.key.toLowerCase() == "not") {
                reverse = true;
              } else if (
                permission.key &&
                permission.key.toLowerCase() == "all"
              ) {
                if (angular.isString(v)) {
                  v = v.split(",");
                  func = $iq_permission.hasAll;
                } else if (angular.isArray(v)) {
                  func = $iq_permission.hasAll;
                }
                reverse = false;
              } else if (
                permission.key &&
                permission.key.toLowerCase() == "any"
              ) {
                if (angular.isString(v)) {
                  v = v.split(",");
                  func = $iq_permission.hasAny;
                } else if (angular.isArray(v)) {
                  func = $iq_permission.hasAny;
                }
                reverse = false;
              }
            }

            func(v).then(
              function (value) {
                if (value == true) {
                  changeClass(reverse ? !value : value);
                } else {
                  changeClass(reverse);
                }
              },
              function () {
                changeClass(reverse);
              }
            );
          });
        },
      };
    })
    /**
     * iqUserImage 人员id notLink 是否点击进入人员页面 默认false,false进入；true点击不进入
     */
    .directive("iqUserImage", [
      "$q",
      "$iq_server",
      "$location",
      "$iq_queue",
      "$userInfo",
      "$rootScope",
      function ($q, $iq_server, $location, $iq_queue, $userInfo, $rootScope) {
        var path = $iq_server.server() + "person/";
        var pss = {};

        return {
          link: function (scope, iElement, iAttr, ctrl, $transclude) {
            var id = "";
            scope.$on("userImageChange", function (e, _id, date) {
              if (_id == id) {
                // 重绘图像

                if (!pss[id]) {
                  pss[id] = {};
                }
                var timestamp = date.getTime();
                if (!pss[id][timestamp]) {
                  pss[id][timestamp] = $q.defer();
                  // iq_http有拦截、不缓存等、此处只刷新图片，要求用原地址，尚且失败不刷新即可
                  $.ajax({
                    url: path + id + "/image",
                    type: "get",
                    beforeSend: function (request) {
                      request.setRequestHeader(
                        "If-Modified-Since",
                        new Date().toISOString()
                      );
                    },
                    ifModified: true,
                    success: function () {
                      pss[id][timestamp].resolve();
                    },
                  });
                }
                pss[id][timestamp].promise.then(function () {
                  iElement.attr("src", path + id + "/image");
                  if (iElement[0]) {
                    iElement[0].src = path + id + "/image";
                  }
                });
              }
            });
            scope.$watch(iAttr.iqUserImage, function (cur) {
              id = cur;
              iElement.attr("src", path + cur + "/image");
              once = false;
            });
            var once = false;

            iElement.error(function () {
              if (!id) {
                return;
              }
              if (!once) {
                // 测试是否是IE浏览器
                if (old_browser.IE) {
                  this.src = "theme/img/default.png";
                  once = true;
                } else {
                  // 颜色数组
                  var colors = [
                    "#63d5e6",
                    "#74dcc5",
                    "#6ec1fb",
                    "#5dc9f9",
                    "#f690a1",
                    "#ff9e57",
                  ];

                  // 用户的姓名
                  var tname = {};
                  // 用户的颜色,注意最后一位有可能是字母，要转换成ASCII码
                  var color =
                    colors[parseInt(id.charCodeAt(id.length - 1)) % 6];
                  var _this = this;
                  // 取出用户的姓名
                  $iq_queue.get("user_cached").promise.then(function (data) {
                    // 检测用户id是否存在，如果不存在，则使用默认头像
                    if (!data[id]) {
                      _this.src = "theme/img/default.png";
                    } else {
                      //如果用户是chrome或者safari就显示头像，否则显示默认灰色头像
                      if (old_browser.Chrome || old_browser.Safari) {
                        // 检测用户姓名是否是英文
                        var str = data[id].name;
                        if (str.length != 0) {
                          regHan = /.*[\u4e00-\u9fa5].*/;
                          regNum = /.*[0-9].*/;
                          if (regHan.test(str) || regNum.test(str)) {
                            // 包含汉字或者数字，取后两位显示
                            tname.name = str.slice(-2);
                          } else {
                            // 判断英文中有几个单词
                            var namearray = str.split(" ");
                            if (namearray.length > 1) {
                              str =
                                namearray[0].toString().charAt(0) +
                                namearray[1].toString().charAt(0);
                              tname.name = str;
                            } else {
                              tname.name = str.slice(0, 2);
                            }
                          }
                        }
                        // svg文件内容
                        svg = encodeURI(
                          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"> <g id="canvas_1"><circle id="circle1" fill="' +
                            color +
                            '" cx="50" cy="50" r="50" /> <text id="text1" x="50%" y="50%" fill="#FFFFFF" font-family="\'MicrosoftYaHei\'" font-size="32" text-anchor="middle" dy=".3em">' +
                            tname.name +
                            " </text> </g></svg>"
                        );

                        _this.src = "data:image/svg+xml;charset=UTF-8," + svg;
                      } else {
                        _this.src = "theme/img/default.png";
                      }
                    }
                  });

                  once = true;
                }
              }
            });
            function goToPersonalpage() {
              if (id) {
                scope.$apply(function () {
                  $location.url("/personalpage/gotouserpage/" + id);
                });
              } else {
                console.log("id error:" + id);
              }
            }
            if (!iAttr.notLink) {
              if (
                !iElement.data("events") ||
                !iElement.data("event")["click"]
              ) {
                iElement.css("cursor", "pointer").on("click", function (e) {
                  goToPersonalpage();
                  e.stopPropagation();
                });
              }
            }
            if (iAttr.notHover) {
              if (
                !iElement.data("events") ||
                !iElement.data("event")["mouseenter"]
              ) {
                iElement.on("mouseenter", function (event) {
                  var imgid = id;
                  $userInfo.getOnePerson(imgid, function (re) {
                    $rootScope.$broadcast("popovershow", {
                      data: re.data.data,
                      url: iAttr.hoverType,
                      target: event.currentTarget,
                    });
                  });
                });
                iElement.on("mouseleave", function () {
                  $rootScope.$broadcast("popoverhide");
                });
              }
            }
          },
        };
      },
    ])
    .directive("iqUser", [
      "$timeout",
      "$location",
      function ($timeout, $location) {
        return {
          replace: true,
          restrict: "E",
          template: "<a></a>",
          link: function (scope, iElement, iAttr, ctrl, $transclude) {
            var id = "";
            iElement.on("click", function () {
              $timeout(function () {
                $location.path("/personalpage/gotouserpage/" + id);
              });
            });
            scope.$watch(iAttr.iqUserId, function (cur) {
              id = cur;
            });
            scope.$watch(iAttr.iqUserName, function (cur) {
              iElement.html(cur);
            });
          },
        };
      },
    ])
    .directive("ngAppAdmin", function () {
      // 应用管理员
      return {
        restrict: "AE", // 元素或者属性方式的标签
        replace: true, // 替换模板中的内容
        // scope:true,// true
        // 新建作用域，false不新建(通用组件多处使用会出现问题)，有原型继承
        scope: {
          // 新建作用域,没有原型继承
          module: "=*module", // 模块代码
        },
        templateUrl: "./templates/common/app_admin.html",
        controller: function (
          $scope,
          $attrs,
          $iq_server,
          $element,
          $iq_http,
          $iq_popup,
          $state,
          $location,
          $rootScope
        ) {
          $scope.moduleCode = $scope.$parent[$attrs.module]; // 现在父级的作用域中找，没找到直接找属性
          if (!$scope.moduleCode) {
            $scope.moduleCode = $attrs.module;
          }

          // 后台获取对应模块的管理员
          var getModuleAdminor = function (callback) {
            var func = {
              success: function (re) {
                if (callback) {
                  callback(re);
                }
              },
            };
            var strurl =
              "module/" +
              $scope.moduleCode +
              "/aclrole/admin/persons-contains-roles-not-null/status-filter:1";
            var url = $iq_server.server() + strurl; // 获取后台数据的url
            var params = {
              method: "GET",
              url: url,
            };

            $iq_http.http(params, func);
          };

          // 获取管理员
          $scope.getAdminor = function () {
            getModuleAdminor(function (list) {
              $scope.adminors = list.data.data;
              if (!$scope.adminors) {
                $scope.adminors = {};
              }
            });
          };
          $scope.getAdminor();

          // 鼠标滑动事件
          $scope.adminhover = function (inli) {
            var className = inli.currentTarget.className;
            if (className.indexOf("active") == -1) {
              var li = $("[name='adminorli']", $element);
              for (var i = 0; i < li.length; i++) {
                if (li[i].className.indexOf("active") != -1) {
                  li[i].className = li[i].className.replace("active", "");
                }
              }
              inli.currentTarget.className =
                inli.currentTarget.className + " active";
            }
          };
          // //点击管理员的头像或者名字，跳转至其个人主页
          // $scope.visithisPersonpage = function(userid){
          // $location.path("/personalpage/gotouserpage/"
          // + userid);
          // }
        },
      };
    })
    .directive("ngAppReminder", function () {
      return {
        restrict: "AE", // 元素或者属性方式的标签
        replace: true, // 替换模板中的内容
        // scope:true,// true 新建作用域，false不新建(通用组件多处使用会出现问题)，有原型继承
        scope: {
          // 新建作用域,没有原型继承
          module: "=*module", // 模块代码
        },
        templateUrl: "./templates/common/app_reminder.html",
        controller: function (
          $scope,
          $attrs,
          $iq_server,
          $iq_http,
          $iq_popup,
          $location
        ) {
          $scope.moduleCode = $scope.$parent[$attrs.module]; // 现在父级的作用域中找，没找到直接找属性
          if (!$scope.moduleCode) {
            $scope.moduleCode = $attrs.module;
          }
          /*
           * $scope.permission = { v: $scope.moduleCode +
           * ':writeAll,' + $scope.moduleCode + ':systemSetting',
           * key: 'any' };
           */
          $scope.permission = $scope.moduleCode + ":systemSetting";
          $scope.cancelNotice = function () {
            $scope.edit = !$scope.edit;
            $scope.notice.content = oldContent;
          };
          $scope.saveNotice = function () {
            if ($scope.notice) {
              var param = {
                id: $scope.notice.id,
                content: $scope.notice.content,
                module: $scope.moduleCode,
              };
            }
            saveNotice(param, function (tmp) {
              if (tmp.data.success) {
                getNotice(function (list) {
                  $scope.notice = list.data.data;
                });
                $iq_popup.alert("编辑成功", 3, "success");
                $scope.edit = false;
              } else {
                if (tmp.data.status && tmp.data.status.indexOf("2") != -1) {
                  $iq_popup.alert(tmp.data.message, 3, "fail");
                }
              }
            });
          };
          // 保存登录人的notice
          var saveNotice = function (param, callback) {
            // 分页获取数据
            var func = {
              success: function (re) {
                if (callback) {
                  callback(re);
                }
              },
            };
            var url = $iq_server.server() + "reminderController/saveReminder"; // 分页的url

            var params = {
              method: "post",
              url: url,
              data: param,
              dataType: "json",
            };

            $iq_http.http(params, func);
          };
          // 获取登录人的notice
          var getNotice = function (callback) {
            // 分页获取数据
            var func = {
              success: function (re) {
                if (callback) {
                  callback(re);
                }
              },
            };

            var url = $iq_server.server() + "reminderController/findReminder"; // 分页的url

            var params = {
              method: "post",
              url: url,
              params: {
                module: $scope.moduleCode,
              }, // 带的param值
            };

            $iq_http.http(params, func);
          };

          // 获取温馨提示
          $scope.getNotice = function () {
            getNotice(function (list) {
              $scope.notice = list.data.data;
              if (!$scope.notice) {
                $scope.notice = {};
              }
            });
          };
          $scope.getNotice();

          // 编辑温馨提示
          $scope.edit = false;
          var oldContent = null;
          $scope.openNotice = function (notice) {
            $scope.edit = true;
            oldContent = notice.content;
          };
        },
      };
    })
    .directive("ngAppRule", function () {
      return {
        restrict: "AE", // 元素或者属性方式的标签
        replace: true, // 替换模板中的内容
        // scope:true,// true 新建作用域，false不新建(通用组件多处使用会出现问题)，有原型继承
        scope: {
          // 新建作用域,没有原型继承
          module: "=*module", // 模块代码
        },
        templateUrl: "./templates/common/app_rule.html",
        controller: function (
          $scope,
          $attrs,
          $iq_server,
          $iq_http,
          $iq_popup,
          $location,
          $iq_rule_pulish,
          $rootScope
        ) {
          $scope.moduleCode = $scope.$parent[$attrs.module]; // 现在父级的作用域中找，没找到直接找属性
          if (!$scope.moduleCode) {
            $scope.moduleCode = $attrs.module;
          }

          // 发布按钮只有有系统配置操作的人才可看到
          $scope.permission = $scope.moduleCode + ":systemSetting";

          // 获取规章制度
          var getRule = function (callback, ruleDateParam) {
            // 分页获取数据
            var func = {
              success: function (re) {
                list = re.data.data;
                if (callback) {
                  callback(list);
                }
              },
            };
            var params = {
              params: ruleDateParam,
              method: "GET",
              url:
                $iq_server.server() +
                "rule/rules-top/" +
                ruleDateParam.pageSize,
            };
            $iq_http.http(params, func);
          };

          var local_param = {
            pageNo: 1,
            pageSize: 5,
            sort: "DESC_recordsSort",
            search_IS_module_Module: $scope.moduleCode,
          };
          $scope.ruleDataListShow = false;
          var local_getRuleDataLists = function (tmp) {
            if (tmp.list.length == 0) {
              $scope.ruleDataListShow = false;
            } else {
              $scope.scope_ruleDataList = tmp.list;
              $scope.ruleDataListShow = true;
            }
          };
          getRule(local_getRuleDataLists, local_param);

          // 更多制度
          $scope.goRule = function () {
            $location.path("/app-rule");
          };
          // 跳到具体制度
          $scope.showRule = function (id) {
            $scope.ruleId = angular.copy(id);
            $location.path("/app-rule/gotorulecriticism/" + $scope.ruleId);
          };
          $scope.$on("to_rule", function (e, d) {
            if (d && d.module == $scope.moduleCode) {
              getRule(local_getRuleDataLists, local_param);
            }
          });

          // 发布制度
          $scope.publicRule = function () {
            // 模块列表---定位
            var func = {
              success: function (re) {
                if (re.data.success) {
                  var newModuleList = re.data.data;
                  if (newModuleList != null && newModuleList.length > 0) {
                    for (var i = 0; i < newModuleList.length; i++) {
                      if (newModuleList[i].module == $scope.moduleCode) {
                        $scope.modulesObj = newModuleList[i];
                        // 打开发布窗口
                        $iq_rule_pulish.openDialog($scope.modulesObj);
                      }
                    }
                  }
                }
              },
            };
            var params = {
              params: {},
              method: "GET",
              url:
                $iq_server.server() +
                "/modules/allowed/has-permission/systemSetting",
            };
            $iq_http.http(params, func);
          };
        },
      };
    })

    .directive("iqTitle", function (
      $timeout,
      $q,
      $ocLazyLoad,
      $compile,
      $iq_server
    ) {
      return {
        restrict: "A",

        link: function ($scope, element, $attrs) {
          var lazyLoadPromise = $ocLazyLoad
            .load({
              files: ["../lib/jquery/jquery.title.js"],
            })
            .then(function () {
              $timeout(function () {
                $this = $(element);

                $scope.$watch($attrs.iqTitle, function (cur) {
                  $this.data("titletext", cur);
                });

                var data = $this.data("title") || "always";

                $this.title({
                  overflow: data.indexOf("overflow") > -1,
                  always: data.indexOf("always") > -1,
                  mousefollow: data.indexOf("mousefollow") > -1,
                  fromright: data.indexOf("fromright") > -1,
                });
              });
            });
          return lazyLoadPromise;
        },
      };
    })
    .directive("breadCrumbNavigation", function () {
      // 面包屑导航
      return {
        restrict: "E",
        replace: true, // 替换模板中的内容
        // scope:true,// true
        // 新建作用域，false不新建(通用组件多处使用会出现问题)，有原型继承
        scope: {
          messageTmp: "=message",
        },
        templateUrl: "./templates/common/bread_crumb_navigation.html",
        controller: function ($scope, $attrs, $location) {
          // var path;
          // var inputIndex;
          $scope.message = angular.copy($scope.messageTmp);
          // var getPath=function(){
          // path = $location.path();
          // path=document.referrer;
          // }
          // getPath();
          // var paths=path.split("/");
          // paths[0]='main';
          // var resultPath;
          $scope.goToPage = function (index) {
            // resultPath=null;
            // index=index+1;
            // for(i=1;i<=index;i++){
            // if(!resultPath){
            // resultPath="/"+paths[i];
            // }else{
            // resultPath=resultPath+"/"+paths[i];
            // }
            // }
            //
            index = index + 1;
            if (index != $scope.message.name.length) {
              // 最后一级的链接是不能点的
              history.back();
            }
          };
        },
      };
    })
    .directive("iqPublishscope", function () {
      // 发布范围
      // 普通下拉弹出
      var $this_downmenu_Btn;
      var $this_downmenu_Pop;
      // $('.current-style').click(function(){
      // down_menu_pop($(this),$('.publish-down-menu'));
      // });
      // 普通下拉弹出-窗口改变时
      $(window).resize(function () {
        if ($this_downmenu_Btn && $this_downmenu_Pop) {
          down_menu_pop($this_downmenu_Btn, $this_downmenu_Pop);
        }
      });
      // 普通下拉弹出-窗口滚动时
      $(window).scroll(function () {
        if ($this_downmenu_Btn && $this_downmenu_Pop) {
          down_menu_pop($this_downmenu_Btn, $this_downmenu_Pop);
        }
      });
      // 普通下拉弹出-POP定位
      function down_menu_pop(thisBtn, thisPop) {
        // var $thisBtn = $this_downmenu_Btn = thisBtn;
        // var $thisPop = $this_downmenu_Pop = thisPop;
        // var pop_x = $thisBtn.offset().left;
        // var pop_y = $thisBtn.offset().top;
        // var $thisArrow = $thisPop.find('.arrow-pop');
        // //普通下拉弹出-选择
        // var $thisSelectAll =
        // $thisPop.find('.down-menu-all :checkbox');
        // var $thisAllInput = $thisPop.find('li
        // :checkbox');
        //
        // $thisPop.css('left',pop_x+'px');
        // $('.publish-pop').addClass('hide');
        // $thisPop.removeClass('hide');
        // $('body').on('mousedown', function(){
        // $thisPop.addClass('hide');
        // $this_downmenu_Btn = $this_downmenu_Pop ='';
        // });
        //
        // if( $thisBtn.closest('.modal').length>0 && pop_x
        // > $(window).height()/2 ){
        // $thisPopHeight =
        // $thisPop.height()+parseInt($thisPop.css('padding-top'))+parseInt($thisPop.css('padding-bottom'));
        // $thisArrow.addClass('arrow-pop-down');
        // $thisPop.css('top','auto');
        // $thisPop.css('bottom',$(window).height()-pop_y+10+'px');
        // }else{
        // $thisArrow.removeClass('arrow-pop-down');
        // $thisPop.css('top',pop_y+$thisBtn.height()+8+'px');
        // $thisPop.css('bottom','auto');
        // }
        //
        var $thisBtn = ($this_downmenu_Btn = thisBtn);
        var $thisPop = ($this_downmenu_Pop = thisPop);
        var pop_x = $thisBtn.offset().left;
        var pop_y = $thisBtn.offset().top;
        var $thisArrow = $thisPop.find(".arrow-pop");
        // 普通下拉弹出-选择
        var $thisSelectAll = $thisPop.find(".down-menu-all :checkbox");
        var $thisAllInput = $thisPop.find("li :checkbox");

        // $thisPop.css('left',pop_x+'px');
        if ($thisBtn.closest(".down-menu").hasClass("js-float-left")) {
          $thisPop.css("left", "-20px");
          $thisPop.css("right", "auto");
        }

        $(".publish-pop").addClass("hide");
        $thisPop.removeClass("hide");
        $("body").on("mousedown", function () {
          $thisPop.addClass("hide");
          $this_downmenu_Btn = $this_downmenu_Pop = "";
        });

        // $thisPopHeight =
        // $thisPop.height()+parseInt($thisPop.css('padding-top'))+parseInt($thisPop.css('padding-bottom'));
        // $thisArrow.addClass('arrow-pop-down');
        // $thisPop.css('top','auto');
        // $thisPop.css('bottom',$(window).height()-pop_y+10+'px');
        // if( $thisBtn.hasClass('current-style') ){
        // $thisPop.css('left', 'auto');
        // $thisPop.css('bottom',25+'px');
        //
        // if (
        // parseInt($('.publish-style').css('padding-left'))
        // > 0 ){
        // $('.publish-style').css('padding-left', '0px');
        // }else{
        // $('.publish-style').css('padding-left', '1px');
        // }
        // }
        if (
          $thisBtn.closest(".modal").length > 0 &&
          pop_x > $(window).height() / 2
        ) {
          $thisPopHeight =
            $thisPop.height() +
            parseInt($thisPop.css("padding-top")) +
            parseInt($thisPop.css("padding-bottom"));
          $thisArrow.addClass("arrow-pop-down");
          $thisPop.css("top", "auto");
          $thisPop.css("bottom", $thisBtn.height() + 10 + "px");
        } else {
          $thisArrow.removeClass("arrow-pop-down");
          $thisPop.css("top", $thisBtn.height() + 8 + "px");
          $thisPop.css("bottom", "auto");
        }
      }

      return {
        restrict: "AE",
        scope: {
          publishscope: "=publishscope",
          publishscopename: "=publishscopename",
        },
        templateUrl: "./templates/common/iq_publishscope.html",
        link: function ($scope, $element, $attr, $iq_popup) {},
        controller: function (
          $scope,
          $element,
          $attrs,
          $location,
          $iq_user,
          $blog_service
        ) {
          $scope.showScope = "全公司";
          $scope.company = true;
          $scope.depList = [];
          var tempList = [];
          if (
            $scope.$parent[$attrs.publishscope] &&
            $scope.$parent[$attrs.publishscopename]
          ) {
            for (
              var i = 0;
              i < $scope.$parent[$attrs.publishscope].length;
              i++
            ) {
              var tempId = $scope.$parent[$attrs.publishscope][i];
              var tempName = $scope.$parent[$attrs.publishscopename][i];
              var dep = {
                id: tempId,
                name: tempName,
                modelId: tempId,
              };
              tempList.push(dep);
            }
          } else {
            $scope.$parent[$attrs.publishscope] = ["company"]; // 默认全公司
            $scope.$parent[$attrs.publishscopename] = ["全公司"]; // 默认全公司
          }

          // var myId =
          // $iq_user.getUserInfo().$$state.value.id;
          $iq_user.getUserInfo().then(function (user) {
            var myId = user.id;

            var getDeps = function (deps) {
              $scope.depList = deps.data.data;
              $scope.depList = removeElementByIndex($scope.depList, 0);
              for (var i = 0; i < $scope.depList.length; i++) {
                $scope.depList[i].modelId = $scope.depList[i].id;
                if (
                  $scope.$parent[$attrs.publishscope] &&
                  $scope.$parent[$attrs.publishscope].indexOf(
                    $scope.depList[i].id
                  ) != -1
                ) {
                  $scope.depList[i].modelId = true;
                }
              }
              if (
                $scope.$parent[$attrs.publishscope] &&
                $scope.$parent[$attrs.publishscope].indexOf("company") == -1
              ) {
                $scope.company = false;
              }
              // $scope.changeValue();
              $scope.companyeChangeValue();
              $scope.depChangeValue();
            };
            $blog_service.getdep(getDeps, myId, 1); // 1标示往下获取一层部门信息
          });

          // var iqdepList =
          // $scope.$parent[$attrs.deplist];
          // $scope.company =
          // $scope.$parent[$attrs.company];

          // $scope.$watch('deplist', function(current,
          // old){
          // iqdepList = current;
          // })

          $scope.showDownMenu = function () {
            // 点击出现下拉列表
            var currentStyle = $("[name='currentStyle']", $element);
            var publishDownMenu = $("[name='publishDownMenu']", $element);
            down_menu_pop(currentStyle, publishDownMenu);
          };

          $scope.companyeChangeValue = function () {
            // 改变发布范围（点击全公司）
            var temp = false;
            if ($scope.depList && $scope.depList.length > 0) {
              for (var i = 0; i < $scope.depList.length; i++) {
                var deppp = $scope.depList[i];
                var depppModelId = deppp.modelId;
                if (depppModelId == true) {
                  temp = true;
                  break;
                }
              }
            }

            if ($scope.company == true && temp == true) {
              if ($scope.depList && $scope.depList.length > 0) {
                for (var i = 0; i < $scope.depList.length; i++) {
                  $scope.depList[i].modelId = false;
                }
              }
            }

            if ($scope.company == true) {
              $scope.showScope = "全公司";
              $scope.$parent[$attrs.publishscope] = ["company"];
              $scope.$parent[$attrs.publishscopename] = ["全公司"];
              return;
            } else {
              $scope.$parent[$attrs.publishscope] = [];
              $scope.$parent[$attrs.publishscopename] = [];
            }

            if ($scope.depList && $scope.depList.length > 0) {
              var count = 0;
              var temp = "";
              for (var i = 0; i < $scope.depList.length; i++) {
                var deppp = $scope.depList[i];
                var depppModelId = deppp.modelId;
                var depppId = deppp.id;
                var depppName = deppp.name;
                if (depppModelId == true) {
                  $scope.$parent[$attrs.publishscope].push(depppId); // 部门ID放入List
                  $scope.$parent[$attrs.publishscopename].push(depppName);
                  count++; // 数量加1
                  temp = $scope.depList[i].name; // 部门名称赋予
                  // temp
                  // 用于单个勾选的时候
                }
              }

              if (count == 1) {
                $scope.showScope = temp;
              } else if (count < 1) {
                $scope.showScope = "请选择发布范围";
                $scope.$parent[$attrs.publishscope] = [];
                $scope.$parent[$attrs.publishscopename] = [];
              } else {
                $scope.showScope = count + "项已选择";
              }
            } else {
              $scope.showScope = "请选择发布范围";
              $scope.$parent[$attrs.publishscope] = [];
              $scope.$parent[$attrs.publishscopename] = [];
            }
          };

          $scope.depChangeValue = function () {
            // 改变发布范围（点击某个部门）
            var temp = false;
            if ($scope.depList && $scope.depList.length > 0) {
              for (var i = 0; i < $scope.depList.length; i++) {
                var deppp = $scope.depList[i];
                var depppModelId = deppp.modelId;
                if (depppModelId == true) {
                  temp = true;
                  break;
                }
              }
            }

            if ($scope.company == true && temp == true) {
              $scope.company = false;
            }

            if ($scope.company == true) {
              $scope.showScope = "全公司";
              $scope.$parent[$attrs.publishscope] = ["company"];
              $scope.$parent[$attrs.publishscopename] = ["全公司"];
              return;
            } else {
              $scope.$parent[$attrs.publishscope] = [];
              $scope.$parent[$attrs.publishscopename] = [];
            }

            if ($scope.depList && $scope.depList.length > 0) {
              var count = 0;
              var temp = "";
              for (var i = 0; i < $scope.depList.length; i++) {
                var deppp = $scope.depList[i];
                var depppModelId = deppp.modelId;
                var depppId = deppp.id;
                var depppName = deppp.name;
                if (depppModelId == true) {
                  $scope.$parent[$attrs.publishscope].push(depppId); // 部门ID放入List
                  $scope.$parent[$attrs.publishscopename].push(depppName);
                  count++; // 数量加1
                  temp = $scope.depList[i].name; // 部门名称赋予
                  // temp
                  // 用于单个勾选的时候
                }
              }

              if (count == 1) {
                $scope.showScope = temp;
              } else if (count < 1) {
                $scope.showScope = "请选择发布范围";
                $scope.$parent[$attrs.publishscope] = [];
                $scope.$parent[$attrs.publishscopename] = [];
              } else {
                $scope.showScope = count + "项已选择";
              }
            } else {
              $scope.showScope = "请选择发布范围";
              $scope.$parent[$attrs.publishscope] = [];
              $scope.$parent[$attrs.publishscopename] = [];
            }
          };
        },
      };
    })

    .directive("iqContent", function ($faceService, $location) {
      // 发布内容
      return {
        restrict: "AE",
        scope: false,
        // templateUrl:
        // './templates/common/iq_content.html',
        link: function ($scope, $element, $attr, $iq_popup) {
          //								var obj = $scope[$attr.obj];
          //我的通知修改，兼容其余模块
          var obj = $scope;
          var tmpstr = $attr.obj;
          var tmparr = tmpstr.split(".");
          for (var iii = 0; iii < tmparr.length; iii++) {
            obj = obj[tmparr[iii]];
          }

          var type = $attr.type;
          var storetype = $attr.storetype;
          var content = "";
          var userIdNames = "";

          if (storetype == "store") {
            obj = obj.obj;
          }

          if (type == "blog") {
            content = obj.content.content;
            userIdNames = obj.content.userIdNames;
          } else if (type == "discuss" || type == "noticediscuss") {
            content = obj.content.discuss.content;
            userIdNames = obj.content.discuss.userIdNames;
          } else if (type == "discussmaster") {
            content = obj.content.master.content;
            userIdNames = obj.content.master.userIdNames;
          } else if (type == "relay") {
            content = obj.content.relay.content;
            userIdNames = obj.content.relay.userIdNames;
          } else if (type == "relaymaster") {
            content = obj.content.master.content;
            userIdNames = obj.content.master.userIdNames;
          } else if (type == "task") {
            content = obj.content.content;
            content = content.replace(new RegExp("&nbsp;", "g"), " "); // 空格替换
          } else if (type == "schedule") {
            content = obj.content.content;
            content = content.replace(new RegExp("&nbsp;", "g"), " "); // 空格替换
          } else if (type == "discussshow") {
            content = obj.content;
            userIdNames = obj.userIdNames;
          } else if (type == "noticeat") {
            content = obj.content;
            userIdNames = obj.userIdNames;
          } else if (type == "systemnotice") {
            content = obj.content;
            userIdNames = obj.userIdNames;
          } else if (type == "privatenotice") {
            content = obj.content;
          } else if (type == "blogsearch") {
            content = obj.content;
          }

          // 表情处理
          var reg = new RegExp("\\[[^\\]]*\\]", "g"); // 创建正则RegExp对象
          var faceString = content.match(
            /\[([A-Za-z]|[\u4E00-\u9FA5]|[\uFE30-\uFFA0])+\]/g
          ); //得到表情的文字表示
          var faces = $faceService.getFaces();
          if (faceString) {
            var faceStringLength = faceString.length;
            var faceUrl = []; //得到表情图片的url
            var faceStringCount = 0;
            var middleCount = 0;
            for (var i = 0; i < faceStringLength; i++) {
              for (var j = 0; j < faces.length; j++) {
                if (
                  faces[j].title ==
                  faceString[i].replace("[", "").replace("]", "")
                ) {
                  faceUrl[faceStringCount] = faces[j].faceclass;
                  middleCount = faceStringCount;
                  faceStringCount++;
                }
              }
              if (!faceUrl[middleCount]) {
                faceStringCount++;
              }
            }
            var imgList = [];
            for (var i = 0; i < faceStringLength; i++) {
              if (faceUrl[i]) {
                imgList[i] =
                  "<span title='" +
                  faceString[i].replace("[", "").replace("]", "") +
                  " 'class=" +
                  "'face-in-pre " +
                  faceUrl[i] +
                  "'/>";
                content = content.replace(faceString[i], imgList[i]); // 替换表情代码为表情图片链接
              } else {
                imgList[i] = faceString[i];
              }
            }
          }
          //								if (faces != null) {
          //									for (var j = 0; j < faces.length; j++) {
          //										// alert(faces[j]);
          //										var imgPath = null;
          //										var faceBase = ImgIputHandler.facePath;
          //										for (var k = 0; k < faceBase.length; k++) {
          //											var key = "["
          //													+ faceBase[k].faceName
          //													+ "]";
          //											if (key == faces[j]) {// 如果表情库的faceName等于匹配到的表情代码
          //												imgPath = faceBase[k].facePath;
          //												break;
          //											}
          //										}
          //
          //										if (imgPath == null) {// 如果没有找到表情
          //
          //										} else {
          //											// content =
          //											// content.replace(faces[j], "<img
          //											// src=\"img/face/" + imgPath +
          //											// "\"/>");//替换表情代码为表情图片链接
          //											content = content.replace(faceString,
          //													"<img src=\"" + imgPath
          //															+ "\"/>");// 替换表情代码为表情图片链接
          //										}
          //
          //									}
          //								}
          // 表情处理--结束

          var topclick = function (e) {
            $scope[$attr.topclick](e.data);
          };

          var atclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/personalpage/gotouserpage/" + e.data);
            });
          };

          var taskclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/task/detail/" + e.data);
            });
          };

          var schedulclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/schedule/detail/" + e.data);
            });
          };

          var noteclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/note/view/" + e.data);
            });
          };

          var meetingclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/meeting/showmeeting/" + e.data);
            });
          };

          var telmeetingclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/meeting/shownettel/" + e.data);
            });
          };

          var netdiskclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/netdisk/" + e.data);
            });
          };

          var personapproveclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("person-org/person-manage/0/");
            });
          };

          // #处理
          var regJing = new RegExp("#[^#\\s&]*#", "g"); // 创建正则RegExp对象
          var jings = content.match(regJing);
          if (jings != null) {
            for (var m = 0; m < jings.length; m++) {
              // onClick=\"topicRelations(topic.id,
              // topic.topic)\"
              content = content.replace(
                jings[m],
                "<a topic_replace='topic" + m + "'></a>"
              );
            }
          }
          // #处理--结束

          // @处理
          var regAt = new RegExp("@[^@\\s&]*", "g"); // 创建正则RegExp对象
          var ats = content.match(regAt);
          if (ats != null) {
            for (var n = 0; n < ats.length; n++) {
              if (ats[n] != "@") {
                content = content.replace(
                  ats[n],
                  "<a at_replace='at" + n + "'></a>"
                );
              }
            }
          }
          // href=\"" + "#/personalpage/gotouserpage/" +
          // "8a811c704f25ba6d014f25f5c59e0005" + "\
          // ats[n]
          // @处理--结束

          $element.html(content);

          // 绑定#的单击事件
          if (jings != null) {
            for (var m = 0; m < jings.length; m++) {
              var _a = $element.find("[topic_replace='topic" + m + "']");
              var topicName = jings[m].substring(1, jings[m].length - 1); // 去掉两边的#号
              _a.on("click", "", topicName, topclick)
                .addClass("talk-subject-textcolor ng-binding ng-scope")
                .html(jings[m]);
            }
          }
          // 绑定@的单击事件
          if (ats != null) {
            var users = [];
            if (userIdNames) {
              var userList = userIdNames.split(";");
              if (userList && userList.length > 0) {
                for (var i = 0; i < userList.length; i++) {
                  if (userList[i]) {
                    var user = eval("(" + userList[i] + ")");
                    users.push(user);
                  }
                }
              }
            }

            for (var n = 0; n < ats.length; n++) {
              var _b = $element.find("[at_replace='at" + n + "']");
              // var atName = ats[n].substring(1,
              // ats[n].length-1);
              if (users.length > 0) {
                var addat = true;
                for (var i = 0; i < users.length; i++) {
                  if ("@" + users[i].name == ats[n]) {
                    _b.on("click", "", users[i].id, atclick).html(ats[n]);
                    users = removeElementByIndex(users, i);
                    addat = false;
                    break;
                  }
                }
                if (addat == true) {
                  _b.html(ats[n]);
                  // _b.on("click", '', '',
                  // atclick).html(ats[n]);
                }
              } else {
                _b.html(ats[n]);
              }
            }
          }

          // 处理任务、日程的点击事件
          if (type == "task") {
            var _d = $element.find("[task_replace]");
            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
          } else if (type == "schedule") {
            var _c = $element.find("[schedul_replace]");
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
          } else if (type == "discussmaster") {
            var _c = $element.find("[schedul_replace]");
            var _d = $element.find("[task_replace]");
            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
          } else if (type == "relaymaster") {
            var _c = $element.find("[schedul_replace]");
            var _d = $element.find("[task_replace]");
            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
          } else if (type == "systemnotice") {
            var _c = $element.find("[schedul_replace]"); // 日程连接
            var _d = $element.find("[task_replace]"); // 任务连接
            var _e = $element.find("[notice_user]"); // 笔记的用户连接
            var _f = $element.find("[notice_view]"); // 笔记的查询连接
            var _m = $element.find("[meeting_user]"); // 会议的用户连接
            var _n = $element.find("[meeting_replace]"); // 会议的查询连接
            var _p = $element.find("[tel_meeting_replace]"); // 电话会议的查询连接
            var _l1 = $element.find("[file_share_user]"); // 文件库的用户连接
            var _l2 = $element.find("[file_view]"); // 文件库的查询连接
            var _person = $element.find("[psnorg_approve_replace]"); // 人员批准连接

            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
            if (_e && _e.get(0)) {
              _e.on("click", "", _e.get(0).name, atclick);
            }
            if (_f && _f.get(0)) {
              _f.on("click", "", _f.get(0).name, noteclick);
            }
            if (_m && _m.get(0)) {
              _m.on("click", "", _m.get(0).name, atclick);
            }
            if (_n && _n.get(0)) {
              _n.on("click", "", _n.get(0).name, meetingclick);
            }
            if (_p && _p.get(0)) {
              _p.on("click", "", _p.get(0).name, telmeetingclick);
            }
            if (_l1 && _l1.get(0)) {
              _l1.on("click", "", _l1.get(0).name, atclick);
            }
            if (_l2 && _l2.get(0)) {
              _l2.on("click", "", _l2.get(0).name, netdiskclick);
            }
            if (_person && _person.get(0)) {
              _person.on("click", "", _person.get(0).name, personapproveclick);
            }
          }
        },
        controller: function (
          $scope,
          $element,
          $attrs,
          $location,
          $iq_user,
          $blog_service
        ) {},
      };
    })
    .directive("raiseQuestions", [
      "$iq_server",
      "$ocLazyLoad",
      function ($iq_server, $ocLazyLoad) {
        var submitValid = false;
        return {
          restrict: "E",
          templateUrl: "templates/common/raise-questions.html",
          scope: true,
          link: function ($scope, $element, $attr) {
            var res = {
              name: "angularFileUpload",
              files: ["../lib/plugins/angular-upload/angular-file-upload.js"],
            };
            if (old_browser.IE && old_browser.version <= 9) {
              res.files.push(
                "../lib/plugins/angular-upload/ng-file-upload-shim.min.js"
              );
            }
            var lazyLoadPromise = $ocLazyLoad.load(res);

            return lazyLoadPromise;
          },
          controller: function ($scope, $iq_popup, $iq_http, $iq_queue) {
            $scope.uploading = false;
            $scope.isLoaded = false;
            $scope.opened = "false";
            $iq_queue.get("css_main_loaded").promise.then(function () {
              $scope.isLoaded = true;
            });
            $scope.show_feedback = function () {
              $scope.feedback_show = true;
            };
            $scope.hide_feedback = function () {
              $scope.feedback_show = false;
            };
            $scope.goToListAndHide = function () {
              $scope.gotoState("/feedback");
              $scope.feedback_show = false;
            };
            $scope.submitValid = false;
            $scope.saveFeedback = function () {
              // 保存申请
              if ($scope.uploading) {
                $iq_popup.alert("请等待附件上传完毕后再提交", 5, "warn");
                return;
              }
              if (!$scope.feedback || !$scope.feedback.describe) {
                $scope.submitValid = true;
                submitValid = true;
                return;
              }
              $scope.submitValid = false;
              submitValid = false;
              var param = {};
              param.answerAndQuestion = [];
              param.open = $scope.opened;
              question = {
                describe: $scope.feedback.describe,
                attachments: $scope.upFiles,
              };
              param.answerAndQuestion.push(question);
              param.workOrderInformation = {};
              $scope.upFiles = null;
              $scope.feedback.describe = null;
              var params = {
                method: "POST",
                url: $iq_server.server() + "feedback/feedback",
                data: param,
                dataType: "json",
              };
              $iq_http.http(params, {
                success: function (re) {
                  if (re.data.success) {
                    $scope.hide_feedback();
                    $iq_popup.alert("提交成功！", 2, "success");
                  } else {
                    $scope.hide_feedback();
                    $iq_popup.alert(re.data.message, 2, "fail");
                  }
                },
                error: function () {
                  // error
                  // func
                  $scope.hide_feedback();
                  $iq_popup.alert("操作失败，请联系管理员！", 2, "fail");
                },
              });
            };
            $scope.feedback = {};
          },
        };
      },
    ])
    .directive("iqChartPie", [
      "$ocLazyLoad",
      function ($ocLazyLoad) {
        return {
          restrict: "E",
          replace: true,
          scope: {
            data: "=data",
            options: "=options",
          },
          link: function ($scope, $element, $attr) {
            // 在文件加载完成之前就会执行，controller要在加载玩之后才执行
            var res = {
              // 缓加载，在要使用的时候的时候才加载
              files: ["../lib/plugins/chart/Chart.js"],
            };
            var lazyLoadPromise = $ocLazyLoad.load(res).then(function () {
              // 数据处理
              var $canvas = $("<canvas></canvas>");
              $element.append($canvas);
              var ctx = $canvas.get(0).getContext("2d");
              var myNewChart = new Chart(ctx);
              var options = angular.extend({}, $scope.options);
              var type = $attr.type;
              var drawResult = "";
              var draw = function () {
                if ($scope.data && $scope.data.length > 0) {
                  if (type == "Doughnut" || !type) {
                    if (drawResult || drawResult.length != 0) {
                      drawResult.segments = [];
                    }
                    drawResult = myNewChart.Doughnut($scope.data, options);
                  } else {
                    if (drawResult || drawResult.length != 0) {
                      drawResult.segments = [];
                    }
                    drawResult = myNewChart.Pie($scope.data, options);
                  }
                }
              };
              $scope.$watch("data", function () {
                draw();
              });
              $scope.$watch("options", function () {
                draw();
              });
              draw();
            });
          },
        };
      },
    ])
    .directive("chartJs", function ($ocLazyLoad) {
      return {
        restrict: "A",
        scope: {
          type: "=",
          data: "=",
          options: "=",
          id: "@",
          width: "=",
          height: "=",
          resize: "=",
          segments: "@",
          responsive: "=",
          tooltip: "=",
          legend: "=",
        },
        link: function ($scope, $elem, $attrs) {
          var res = {
            // 缓加载，在要使用的时候的时候才加载
            files: ["../lib/plugins/chart/Chart.js"],
          };
          var lazyLoadPromise = $ocLazyLoad.load(res).then(function () {
            var ctx = $elem[0].getContext("2d");
            var autosize = false;

            $scope.size = function () {
              if ($scope.width <= 0) {
                $elem.width($elem.parent().width());
                ctx.canvas.width = $elem.width();
              } else {
                ctx.canvas.width = $scope.width || ctx.canvas.width;
                autosize = true;
              }

              if ($scope.height <= 0) {
                $elem.height($elem.parent().height());
                ctx.canvas.height = ctx.canvas.width / 2;
              } else {
                ctx.canvas.height = $scope.height || ctx.canvas.height;
                autosize = true;
              }
            };

            $scope.$watch(
              "data",
              function (newVal, oldVal) {
                if (chartCreated) chartCreated.destroy();

                // if data not defined, exit
                if (!newVal) {
                  return;
                }

                if (autosize) {
                  $scope.size();
                  chart = new Chart(ctx);
                }
                if ($scope.options) {
                  if ($scope.responsive || $scope.resize)
                    // 为true的话自动调大小
                    $scope.options.responsive = true;

                  if ($scope.responsive !== undefined)
                    $scope.options.responsive = $scope.responsive;
                }

                var type;
                if ($attrs.type) {
                  type = $attrs.type;
                } else {
                  type = "Pie";
                }
                chartCreated = chart[type]($scope.data, $scope.options);
                chartCreated.update();
                if ($scope.legend)
                  angular
                    .element($elem[0])
                    .parent()
                    .after(chartCreated.generateLegend());
              },
              true
            );

            $scope.$watch(
              "tooltip",
              function (newVal, oldVal) {
                if (chartCreated) chartCreated.draw();
                if (newVal === undefined || !chartCreated.segments) return;
                if (
                  !isFinite(newVal) ||
                  newVal >= chartCreated.segments.length ||
                  newVal < 0
                )
                  return;
                var activeSegment = chartCreated.segments[newVal];
                activeSegment.save();
                activeSegment.fillColor = activeSegment.highlightColor;
                chartCreated.showTooltip([activeSegment]);
                activeSegment.restore();
              },
              true
            );

            $scope.size();
            var chart = new Chart(ctx);
            var chartCreated;
          });
        },
      };
    })
    .directive("iqFormModel", function (
      $iq_http,
      $iq_server,
      $iq_popup,
      $iq_pop_select
    ) {
      return {
        restrict: "AE",
        replace: true,
        scope: {
          formId: "=formid", // 表单id
          formInfo: "=forminfo", // 新建时此对象不传，修改时传表单对象
          getData: "=getdata", // 返回的数据
          config: "=config", // {applyId : 'XX'}
        },
        templateUrl: "./templates/common/iq_form_model.html",
        controller: function ($scope, $iq_user, $q) {
          // 处理指定审批人的正则
          var personReg = /([^;]+),([^;]+)/g;

          // 获取当前登录人对应的部门ID
          var getUserId = function () {
            var def = $q.defer();
            $iq_user.getUserInfo().then(function (re) {
              var userId = re.id;
              def.resolve(re);
              //return re;
            });
            return def.promise;
          };

          // 定义角色中选人input表单的循环数据
          $scope.getPersonInRole = {};

          $scope.getData = {};
          // 处理传参的 版本信息
          var newModelVersion = "0";
          if ($scope.formInfo && $scope.formInfo.version) {
            newModelVersion = $scope.$scope.formInfo.version;
          }
          // 定义显示传入对象
          $scope.showData = {};
          // 判断是编辑还是新建申请
          if ($scope.formInfo) {
            // 修改时
            var applyPersonId = null;
            $scope.$watch("formInfo.applyPerson", function () {
              // 替代人申请时传入替代人信息
              if ($scope.formInfo.applyPerson) {
                applyPersonId = $scope.formInfo.applyPerson.id;
                editRenderItem(applyPersonId);
              }
            });

            $scope.$watch("formInfo.id", function () {
              if ($scope.formInfo.id) {
                $scope.showNewVersion = $scope.formInfo.newFlow;
                if ($scope.showNewVersion) {
                  // 处理新版本编辑
                  applyPersonId = $scope.formInfo.applyPerson
                    ? $scope.formInfo.applyPerson.id
                    : null;
                  editRenderItem(applyPersonId);
                } else {
                  // 处理老版本编辑
                  if (
                    $scope.formInfo.apprUsers &&
                    $scope.formInfo.apprUsers.length > 0
                  ) {
                    $scope.getData = angular.copy($scope.formInfo);
                    $scope.tempObj = angular.copy($scope.formInfo);
                    angular.forEach($scope.tempObj.apprUsers, function (v, k) {
                      v.readOnlyStr = "";
                      if (v.useId) {
                        v.readOnlyStr += v.name + " ";
                      }
                    });
                  }
                }
              }
            });
          } else {
            // 新建申请单时，拿最新版本渲染表单信息
            $scope.showNewVersion = true;
            var applyPersonId = null;
            $scope.$watch("config.applyPersonId", function () {
              // 替代人申请时传入替代人信息
              applyPersonId =
                $scope.config && $scope.config.applyPersonId
                  ? $scope.config.applyPersonId
                  : "";
              if ($scope.getData && applyPersonId) {
                renderItems(applyPersonId);
              } else {
                getUserId().then(function (res) {
                  renderItems(applyPersonId);
                });
              }
            });
            $scope.$watch("formId", function () {
              if ($scope.formId) {
                $iq_http
                  .http({
                    method: "GET",
                    url:
                      $iq_server.server() +
                      "flowmanager/customForm/" +
                      $scope.formId +
                      "/" +
                      newModelVersion,
                  })
                  .then(function (re) {
                    $scope.getData = re.data.data;
                    getUserId().then(function (res) {
                      renderItems(applyPersonId);
                    });
                  });
              }
            });
          }

          var isRender = function (re_personId, personId) {
            if (!personId) {
              return false;
            }
            if (re_personId && personId && personId == re_personId) {
              return false;
            }
            return true;
          };

          var re_personId = null;
          var renderItems = function (applyPersonId) {
            if (
              $scope.getData &&
              $scope.getData.items &&
              $scope.getData.items.length > 0
            ) {
              // 获取当前登录用户所在的部门
              var personId = null;
              if (applyPersonId) {
                personId = applyPersonId;
                renderItemsSub(personId);
              } else {
                getUserId().then(function (re) {
                  personId = re.id;
                  renderItemsSub(personId);
                });
              }
            }
          };

          var renderItemsSub = function (personId) {
            if (isRender(re_personId, personId)) {
              angular.forEach($scope.getData.items, function (data, index) {
                if (data.controlType == 1) {
                  // 部门负责人
                  var tempDeptStr = "",
                    tempDeptObj = "";
                  data.properties = personId;
                  if (isRender(re_personId, personId)) {
                    $iq_http
                      .http({
                        method: "GET",
                        url:
                          $iq_server.server() +
                          "person/" +
                          personId +
                          "/manager/status-filter:1",
                      })
                      .then(function (re) {
                        var deptManager = re.data.data;
                        angular.forEach(deptManager, function (
                          value,
                          index,
                          array
                        ) {
                          tempDeptStr += value.name + " ";
                          tempDeptObj += value.id + "," + value.name + ";";
                        });
                        $scope.showData[index] = tempDeptStr;
                        if (deptManager && deptManager.length > 0) {
                          // 部门负责人有人时才赋值
                          data.value = tempDeptObj.substr(
                            0,
                            tempDeptObj.length - 1
                          );
                        } else {
                          data.value = null;
                        }
                      });
                  }
                }
                if (data.controlType == 2) {
                  // 用户自由选人
                  data.value = [];
                }
                if (data.controlType == 3) {
                  // 指定审批角色
                  var tempRoleStr = "";
                  data.properties.replace(personReg, function (item) {
                    var key = item.split(",")[0];
                    if (re_personId && key == re_personId) {
                      // 上一次选的代申请不为空则拿第二个
                      item = item.replace(re_personId + ",", "");
                      key = item.split(",")[0];
                    }
                    if (key.substring(0, 1) == "s") {
                      // 部门角色
                      if (isRender(re_personId, personId)) {
                        $iq_http
                          .http({
                            method: "GET",
                            url:
                              $iq_server.server() +
                              "person/" +
                              personId +
                              "/station/" +
                              key.substr(2, key.length) +
                              "/persons/status-filter:1",
                          })
                          .then(function (re) {
                            angular.forEach(re.data.data, function (
                              data,
                              index
                            ) {
                              tempRoleStr += data.name + " ";
                            });
                            $scope.showData[index] = tempRoleStr;
                            if (re.data.data && re.data.data.length > 0) {
                              data.value = key;
                            } else {
                              data.value = null;
                            }
                          });
                        data.properties = personId + "," + item;
                      }
                    } else {
                      // 公司角色
                      $iq_http
                        .http({
                          method: "GET",
                          url:
                            $iq_server.server() +
                            "role/" +
                            key +
                            "/persons/status-filter:1",
                        })
                        .then(function (re) {
                          angular.forEach(re.data.data, function (data, index) {
                            tempRoleStr += data.name + " ";
                          });
                          $scope.showData[index] = tempRoleStr;
                          if (re.data.data && re.data.data.length > 0) {
                            data.value = key;
                          } else {
                            data.value = null;
                          }
                        });
                    }
                  });
                }
                if (data.controlType == 4) {
                  // 指定审批人
                  var tempPersonStr = "";
                  data.properties.replace(personReg, function (item) {
                    var key = item.split(",")[0];
                    var value = item.split(",")[1];
                    tempPersonStr += value + " ";
                  });
                  $scope.showData[index] = tempPersonStr;
                }
                if (data.controlType == 5) {
                  // 用户角色中选人
                  data.value = "";
                  // 获取角色中的人员
                  $scope.getPersonInRole[index] = [];
                  $scope.showData[index] = {};
                  data.properties.replace(personReg, function (item) {
                    var key = item.split(",")[0];
                    if (re_personId && key == re_personId) {
                      // 上一次选的代申请不为空则拿第二个
                      item = item.replace(re_personId + ",", "");
                      key = item.split(",")[0];
                    }
                    if (key.substring(0, 1) == "s") {
                      // 部门角色
                      if (isRender(re_personId, personId)) {
                        $iq_http
                          .http({
                            method: "GET",
                            url:
                              $iq_server.server() +
                              "person/" +
                              personId +
                              "/station/" +
                              key.substr(2, key.length) +
                              "/persons/status-filter:1",
                          })
                          .then(function (re) {
                            $scope.showData[index].items = re.data.data;
                            $scope.showData[index].label = "请选择角色中的人员";
                          });
                        data.properties = personId + "," + item;
                      }
                    } else {
                      // 公司角色
                      $iq_http
                        .http({
                          method: "GET",
                          url:
                            $iq_server.server() +
                            "role/" +
                            key +
                            "/persons/status-filter:1",
                        })
                        .then(function (re) {
                          $scope.showData[index].items = re.data.data;
                          $scope.showData[index].label = "请选择角色中的人员";
                        });
                    }
                  });
                }
              });
              re_personId = personId;
            }
          };
          var editRenderItem = function (applyPersonId) {
            if ($scope.formInfo.items && $scope.formInfo.items.length > 0) {
              var personId = null;
              $scope.getData = angular.copy($scope.formInfo);
              if (applyPersonId) {
                personId = applyPersonId;
              } else {
                personId = $scope.getData.createUser;
              }
              if (isRender(re_personId, personId)) {
                angular.forEach($scope.getData.items, function (data, index) {
                  if (data.controlType == 1) {
                    // 部门负责人
                    var tempDeptStr = "",
                      tempDeptObj = "";
                    data.properties = personId;
                    // 获取当前登录用户所在的部门
                    $iq_http
                      .http({
                        method: "GET",
                        url:
                          $iq_server.server() +
                          "person/" +
                          personId +
                          "/manager/status-filter:1",
                      })
                      .then(function (re) {
                        var deptManager = re.data.data;
                        angular.forEach(deptManager, function (
                          value,
                          index,
                          array
                        ) {
                          tempDeptStr += value.name + " ";
                          tempDeptObj += value.id + "," + value.name + ";";
                        });
                        $scope.showData[index] = tempDeptStr;
                        if (deptManager && deptManager.length > 0) {
                          data.value = tempDeptObj.substr(
                            0,
                            tempDeptObj.length - 1
                          );
                        } else {
                          data.value = null;
                        }
                        $scope.getData.items[index] = data;
                      });
                  }
                  if (data.controlType == 2) {
                    // 用户自由选人
                    $scope.showData[index] = [];
                    if (data.value) {
                      data.value.replace(personReg, function (item) {
                        var key = item.split(",")[0];
                        $scope.showData[index].push(key);
                      });
                    }
                  }
                  if (data.controlType == 3) {
                    // 指定审批角色
                    var tempRoleStr = "";
                    data.properties.replace(personReg, function (item) {
                      if (item.indexOf("s-") != -1) {
                        // 部门角色
                        var old = item.split(",")[0];
                        if (personId && old != personId) {
                          // 上一次选的代申请不为空则拿第二个
                          item = item.replace(old, personId);
                          data.properties = item;
                          $scope.formInfo.items = angular.copy(
                            $scope.getData.items
                          );
                        }
                        if (isRender(re_personId, personId)) {
                          var roleId = item.split(",")[1];
                          var realRoleId = roleId.substr(2, roleId.length);
                          $iq_http
                            .http({
                              method: "GET",
                              url:
                                $iq_server.server() +
                                "person/" +
                                personId +
                                "/station/" +
                                realRoleId +
                                "/persons/status-filter:1",
                            })
                            .then(function (re) {
                              angular.forEach(re.data.data, function (
                                data,
                                index
                              ) {
                                tempRoleStr += data.name + " ";
                              });
                              $scope.showData[index] = tempRoleStr;
                              if (re.data.data && re.data.data.length > 0) {
                                data.value = roleId;
                              } else {
                                data.value = null;
                              }
                              $scope.getData.items[index] = data;
                            });
                        }
                      } else {
                        var key = item.split(",")[0];
                        $iq_http
                          .http({
                            method: "GET",
                            url:
                              $iq_server.server() +
                              "role/" +
                              key +
                              "/persons/status-filter:1",
                          })
                          .then(function (re) {
                            angular.forEach(re.data.data, function (
                              data,
                              index
                            ) {
                              tempRoleStr += data.name + " ";
                            });
                            $scope.showData[index] = tempRoleStr;
                            if (re.data.data && re.data.data.length > 0) {
                              data.value = key;
                            } else {
                              data.value = null;
                            }
                            $scope.getData.items[index] = data;
                          });
                      }
                    });
                  }
                  if (data.controlType == 4) {
                    // 指定审批人
                    var tempPersonStr = "";
                    data.value.replace(personReg, function (item) {
                      var key = item.split(",")[0];
                      var value = item.split(",")[1];
                      tempPersonStr += value + " ";
                    });
                    $scope.showData[index] = tempPersonStr;
                  }
                  if (data.controlType == 5) {
                    // 用户角色中选人
                    // 获取角色中的人员
                    $scope.showData[index] = {};
                    data.properties.replace(personReg, function (item) {
                      if (item.indexOf("s-") != -1) {
                        // 部门角色
                        var old = item.split(",")[0];
                        if (personId && old != personId) {
                          // 上一次选的代申请不为空则拿第二个
                          item = item.replace(old, personId);
                          data.properties = item;
                          $scope.formInfo.items = angular.copy(
                            $scope.getData.items
                          );
                        }
                        if (isRender(re_personId, personId)) {
                          var roleId = item.split(",")[1];
                          $iq_http
                            .http({
                              method: "GET",
                              url:
                                $iq_server.server() +
                                "person/" +
                                personId +
                                "/station/" +
                                roleId.substr(2, roleId.length) +
                                "/persons/status-filter:1",
                            })
                            .then(function (re) {
                              $scope.showData[index].items = re.data.data;
                              $scope.showData[index].label =
                                "请选择角色中的人员";
                            });
                        }
                      } else {
                        var key = item.split(",")[0];
                        $iq_http
                          .http({
                            method: "GET",
                            url:
                              $iq_server.server() +
                              "role/" +
                              key +
                              "/persons/status-filter:1",
                          })
                          .then(function (re) {
                            $scope.showData[index].items = re.data.data;
                            $scope.showData[index].label = "请选择角色中的人员";
                          });
                      }
                    });
                    if (data.value) {
                      $scope.getPersonInRole[index] = [];
                      data.value.replace(personReg, function (item) {
                        var temprRolePersonObj = {};
                        var key = item.split(",")[0];
                        var value = item.split(",")[1];
                        temprRolePersonObj.id = key;
                        temprRolePersonObj.name = value;
                        $scope.getPersonInRole[index].push(temprRolePersonObj);
                      });
                    }
                  }
                });
                re_personId = personId;
              }
            }
          };
          // 点击弹出角色人员的弹出按钮事件
          $scope.personInRole = function (item, index) {
            if (
              $scope.getPersonInRole &&
              $scope.getPersonInRole[index] &&
              $scope.getPersonInRole[index].length > 0
            ) {
              $scope.showData[index].choiceItem = $scope.getPersonInRole[index];
            }
            $iq_pop_select
              .popmultipleselect($scope.showData[index])
              .then(function (re) {
                $scope.getPersonInRole[index] = re;
                var tempRolePersonStr = "";
                angular.forEach(re, function (data, index) {
                  tempRolePersonStr += data.id + "," + data.name + ";";
                });
                item.value = tempRolePersonStr.substr(
                  0,
                  tempRolePersonStr.length - 1
                );
              });
          };
          // 删除角色中的人员
          $scope.delPerson = function (person, index, item, e) {
            if (e.stopPropagation) {
              e.stopPropagation();
            } else {
              e.cancelBubble = true;
            }
            if (person) {
              var tempRolePersonStr = "";
              angular.forEach($scope.getPersonInRole[index], function (
                v,
                k,
                array
              ) {
                if (person.id == v.id) {
                  array.splice(k, 1);
                }
              });
              angular.forEach($scope.getPersonInRole[index], function (v, k) {
                tempRolePersonStr += v.id + "," + v.name + ";";
              });
              item.value = tempRolePersonStr.substr(
                0,
                tempRolePersonStr.length - 1
              );
              person = null;
            }
          };
        },
      };
    })
    .directive("iqFormReadModel", function (
      $iq_http,
      $iq_server,
      $iq_popup,
      $iq_pop_select
    ) {
      return {
        restrict: "AE",
        replace: true,
        scope: {
          getData: "=getdata",
        },
        templateUrl: "./templates/common/iq_form_read_model.html",
        controller: function ($scope, $iq_user) {
          var source = angular.copy($scope.getData);
          if (source && source.id) {
            return false;
          }
          // 处理指定审批人的正则
          var personReg = /([^;]+),([^;]+)/g;
          // newFlow
          $scope.$watch("getData.newFlow", function (n, o) {
            if (
              $scope.getData.newFlow &&
              $scope.getData.items &&
              $scope.getData.items.length > 0
            ) {
              $scope.showData = {};
              angular.forEach($scope.getData.items, function (data, index) {
                if (data.controlType == 1) {
                  var tempDeptStr = "",
                    tempDeptObj = "";
                  // 获取当前登录用户所在的部门
                  if (
                    $scope.getData.applyForOther &&
                    $scope.getData.applyPerson
                  ) {
                    var personId = $scope.getData.applyPerson.id;
                  } else {
                    var personId = $scope.getData.createUser;
                  }
                  $iq_http
                    .http({
                      method: "GET",
                      url:
                        $iq_server.server() +
                        "person/" +
                        personId +
                        "/manager/status-filter:1",
                    })
                    .then(function (re) {
                      var deptManager = re.data.data;
                      angular.forEach(deptManager, function (
                        value,
                        index,
                        array
                      ) {
                        tempDeptStr += value.name + " ";
                        tempDeptObj += value.id + "," + value.name + ";";
                      });
                      $scope.showData[index] = tempDeptStr;
                      data.value = tempDeptObj.substr(
                        0,
                        tempDeptObj.length - 1
                      );
                    });
                }
                if (data.controlType == 2) {
                  var tempFreePersonStr = "";
                  if (data.value) {
                    data.value.replace(personReg, function (item) {
                      var value = item.split(",")[1];
                      tempFreePersonStr += value + " ";
                    });
                    $scope.showData[index] = tempFreePersonStr;
                  }
                }
                if (data.controlType == 3) {
                  var tempRoleStr = "";
                  data.properties.replace(personReg, function (item) {
                    if (item.split(",").length > 2) {
                      var personId = item.split(",")[0];
                      var roleId = item.split(",")[1];
                      $iq_http
                        .http({
                          method: "GET",
                          url:
                            $iq_server.server() +
                            "person/" +
                            personId +
                            "/station/" +
                            roleId.substr(2, roleId.length) +
                            "/persons/status-filter:1",
                        })
                        .then(function (re) {
                          angular.forEach(re.data.data, function (data, index) {
                            tempRoleStr += data.name + " ";
                          });
                          $scope.showData[index] = tempRoleStr;
                        });
                    } else {
                      var key = item.split(",")[0];
                      $iq_http
                        .http({
                          method: "GET",
                          url:
                            $iq_server.server() +
                            "role/" +
                            key +
                            "/persons/status-filter:1",
                        })
                        .then(function (re) {
                          angular.forEach(re.data.data, function (data, index) {
                            tempRoleStr += data.name + " ";
                          });
                          $scope.showData[index] = tempRoleStr;
                        });
                    }
                  });
                }
                if (data.controlType == 4) {
                  var tempPersonStr = "";
                  if (data.value) {
                    data.value.replace(personReg, function (item) {
                      var value = item.split(",")[1];
                      tempPersonStr += value + " ";
                    });
                    $scope.showData[index] = tempPersonStr;
                  }
                }
                if (data.controlType == 5) {
                  if (data.value) {
                    var tempRolePersonStr = "";
                    if (data.value) {
                      data.value.replace(personReg, function (item) {
                        var value = item.split(",")[1];
                        tempRolePersonStr += value + " ";
                      });
                      $scope.showData[index] = tempRolePersonStr;
                    }
                  }
                }
              });
            }
          });
        },
      };
    })
    .directive("iqFlowModelBtn", function ($iq_http, $iq_server, $iq_user) {
      var findIndexById = function (list, id) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].id == id) {
            return i;
          }
        }
      };
      var insertByIndex = function (list, index, obj) {
        if (index >= 0 && index < list.length) {
          list.push(obj);
          for (var i = list.length - 1; i > index; i--) {
            list[i] = list[i - 1];
          }
          list[index] = obj;
        }
      };
      return {
        restrict: "AE",
        replace: true,
        scope: {
          flowId: "=flowid",
          btnClick: "=btnclick",
          exBtns: "=exbtns",
          /**
           * [{ label://显示名称 location:""//位置 before/after
           * 默认before
           * target:""//submit,reject,cancel,addsign,transfer,goto,replace,cancel
           * //location和target一起标记按钮插入位置
           * class:""//扩展的class caption:true//boolean
           * 显示条件，false则不现实，当然也可以不传入这整个对象
           * event:function(){} }]
           */
          module: "=module",
          hasremark: "=hasremark", // 是否显示填写意见
        },
        templateUrl: "./templates/common/iq_flow_model_btn.html",
        controller: function (
          $scope,
          $iq_popup,
          $iq_pop_select,
          $iq_permission
        ) {
          var g_data;
          $scope.btns = [];

          var initBtns = function (data) {
            if (g_data == data) return;
            g_data = data;
            $scope.hasremark = data.currentNode.canSubmit == "1";

            $scope.btns = [];
            // submit
            $scope.btns.push({
              id: "submit",
              label: "同意",
              event: function () {
                $scope.btnClick.submit();
              },
              class: "btn btn-medium",
              caption: data.currentNode.canSubmit == "1",
            });
            // reject
            $scope.btns.push({
              id: "reject",
              label: "驳回",
              event: function () {
                var tempRejectObj = {};
                if (
                  data.currentNode.rejectNodes &&
                  data.currentNode.rejectNodes.length > 0
                ) {
                  tempRejectObj.items = data.currentNode.rejectNodes;
                } else {
                  // 兼容报销老系统
                  tempRejectObj.items = [
                    {
                      id: "startnode",
                      name: "开始环节",
                    },
                  ];
                }

                tempRejectObj.label = "请选择驳回环节";
                if (tempRejectObj.items.length > 0) {
                  if (tempRejectObj.items.length == 1) {
                    $scope.btnClick.reject(tempRejectObj.items[0].id);
                  } else {
                    $iq_pop_select
                      .popsingleselect(tempRejectObj)
                      .then(function (re) {
                        $scope.btnClick.reject(re.id);
                      });
                  }
                } else {
                  $iq_popup.alert("没有可驳回的环节", 2, "warn");
                }
              },
              class: "btn btn-medium",
              caption: data.currentNode.canReject == "1",
            });
            // withdraw
            $scope.btns.push({
              id: "withdraw",
              label: "撤回",
              event: function () {
                var confirm = $iq_popup.confirm("确定撤回吗?");
                confirm.then(function () {
                  $scope.btnClick.withdraw();
                });
              },
              class: "btn btn-medium btn-light",
              caption: data.currentNode.canCancel == "1",
            });
            // 加签
            $scope.btns.push({
              id: "addsign",
              label: "加签",
              event: function () {
                $iq_popup.deptpeople(null, "single").then(function (re) {
                  $scope.btnClick.addSign(re[0].id);
                });
              },
              class: "btn btn-medium btn-light",
              caption: data.currentNode.canAddsign == "1",
            });
            // 转办
            $scope.btns.push({
              id: "transfer",
              label: "转办",
              event: function () {
                $iq_popup.deptpeople(null, "single").then(function (re) {
                  $scope.btnClick.transfer(re[0].id);
                });
              },
              class: "btn btn-medium btn-light",
              caption: data.currentNode.canTransfer == "1",
            });

            // 强制跳转
            $scope.btns.push({
              id: "goto",
              label: "强制跳转",
              event: function () {
                var tempForceJumpObj = {};
                tempForceJumpObj.items = data.flowNodes;
                tempForceJumpObj.label = "请选择强制跳转环节";
                $iq_pop_select
                  .popsingleselect(tempForceJumpObj)
                  .then(function (re) {
                    $scope.btnClick.forceGoto(re.id);
                  });
              },
              class: "btn btn-medium btn-light",
              caption: hasPermission,
            });
            // 替换处理人
            $scope.btns.push({
              id: "replace",
              label: "替换处理人",
              event: function () {
                $iq_popup.deptpeople().then(function (re) {
                  var val = "";
                  angular.forEach(re, function (v, k) {
                    val += v.id + ",";
                  });
                  val = val.substring(0, val.length - 1);
                  $scope.btnClick.replace(val);
                });
              },
              class: "btn btn-medium btn-light",
              caption: hasPermission,
            });
            // 返回
            $scope.btns.push({
              id: "cancel",
              label: "返回",
              event: function () {
                history.back();
              },
              class: "btn btn-medium btn-return",
              caption: true,
            });

            for (var i = 0; $scope.exBtns && i < $scope.exBtns.length; i++) {
              var btn = $scope.exBtns[i];
              if (btn) {
                var reindex = btn.location == "after" ? 1 : 0;
                var position = findIndexById($scope.btns, btn.target);
                var newbtn = angular.extend(
                  {
                    class: "btn btn-medium",
                    caption: btn.caption,
                  },
                  btn
                );
                newbtn.id = new Date().getTime();
                insertByIndex($scope.btns, position, newbtn);
              }
            }
          };

          var role = $scope.module + ":systemSetting";
          var hasPermission = false;
          var rolePermission = false;
          var statePermission = false;
          var calPermission = function (state) {
            if (
              state == "0" ||
              state == "2" ||
              state == "3" ||
              state == "5" ||
              state == "6"
            ) {
              statePermission = false;
            } else {
              statePermission = true;
            }
            var newPermission =
              rolePermission && !!$scope.flowId && statePermission;
            if (hasPermission != newPermission) {
              hasPermission = newPermission;
              if ($scope.btns.length > 0) {
                $scope.btns[
                  findIndexById($scope.btns, "goto")
                ].caption = hasPermission;
                $scope.btns[
                  findIndexById($scope.btns, "replace")
                ].caption = hasPermission;
              }
            }

            return hasPermission;
          };
          $iq_permission.has(role).then(function (permission) {
            rolePermission = permission;
            calPermission();
          });

          $scope.$watchCollection("exBtns", function () {
            initBtns(angular.copy(g_data));
          });
          $scope.$watchCollection("btns", function () {
            var write = 0;
            for (var i = 0; i < $scope.btns.length; i++) {
              if ($scope.btns[i].label == "记账") {
                write = 1;
                break;
              } else if ($scope.btns[i].label == "查看记账") {
                write = 2;
                break;
              }
            }
            if (write == 1) {
              for (var j = 0; j < $scope.btns.length; j++) {
                if ($scope.btns[j].label == "同意") {
                  $scope.btns[j].caption = false;
                  break;
                }
              }
            }
            if (write == 2) {
              for (var j = 0; j < $scope.btns.length; j++) {
                if (
                  $scope.btns[j].label == "同意" ||
                  $scope.btns[j].label == "驳回"
                ) {
                  $scope.btns[j].caption = false;
                }
              }
            }
          });
          var default_data = {
            currentNode: {},
            flowNodes: [],
          };
          // 获取后台流程数据
          $scope.$watch("flowId", function () {
            if ($scope.flowId) {
              $iq_http
                .http({
                  method: "GET",
                  url: $iq_server.server() + "flow/flow-info/" + $scope.flowId,
                })
                .then(function (re) {
                  var data = angular.copy(re.data.data);
                  // g_data = data
                  initBtns(data);
                  calPermission(data.currentNode.flowStatus);
                });
            } else {
              initBtns(default_data);
            }
          });
        },
      };
    })
    .directive("iqFace", function ($iq_http, $iq_server, $faceService) {
      return {
        //表情插件，插入表情
        restrict: "AE",
        templateUrl: "./templates/common/iq-face.html",
        scope: {
          mtype: "=mtype", //调用此组件的模块标志
          retype: "=retype", //调用此组件的模块标志
        },
        link: function ($scope, $element, $attr) {
          //烦人的jq处理
          $scope.$on("ngRepeatFinished", function (ngRepeatFinishedEvent) {
            //下面是在table render完成后执行的js
            var $addFaceBoxm = $element.find(".publish-pop.add-face"); //表情框
            var $addFaceListm = $addFaceBoxm.find("ul"); //表情列表
            var $addFaceBtnBoxm = $addFaceBoxm.find(".add-face-btn"); //翻页按钮
            var $faceBoxm = $element.find(".ctrl-text.add-emoji"); //整体表情框
            var addFace_btnHtmlm = ""; //插入到表情框的翻页按钮
            var addFacePagem = $addFaceListm.length; //总页数
            for (i = 1; i <= addFacePagem; i++) {
              $addFaceListm.eq(i - 1).css("left", 373 * (i - 1) + "px"); //表情框大小规定
              if (i == 1) {
                addFace_btnHtmlm += '<span class="faceActive"></span>'; //初始显示第一页的表情
              } else {
                addFace_btnHtmlm += "<span></span>";
              }
            }
            $addFaceBtnBoxm.html(addFace_btnHtmlm);
            $addFaceBtnm = $addFaceBtnBoxm.find("span");
            $addFaceBtnm.click(function () {
              $addFaceBtnm.removeClass("faceActive");
              $(this).addClass("faceActive");
              addFaceBtnIndexm = $addFaceBtnm.index($(this)); //得到是第几个按钮
              $addFaceListm.each(function () {
                addFaceList_left =
                  ($addFaceListm.index($(this)) - addFaceBtnIndexm) * 373;
                $(this)
                  .stop()
                  .animate(
                    {
                      left: addFaceList_left + "px",
                    },
                    "slow"
                  );
              });
            });
            //单独添加：点击表情的动作.off().unbind('click')$("[name='subDiscuss']"
            $(".add-face-list>ul>li>span")
              .off()
              .click(function (e) {
                var $this = $(this);
                var obj = $this
                  .parents(".publish-ctrl")
                  .prev("input")
                  .prev("textarea");
                var obj1 = $this.parents("[id='remain']");
                if ($scope.retype == "remain") {
                  var str = "//";
                  if (!$scope.$parent.relayMessage) {
                    $scope.$parent.relayMessage =
                      " [" + $this.attr("title") + "]";
                  } else {
                    var index = str.indexOf($scope.$parent.relayMessage);
                    var lstr = $scope.$parent.relayMessage.substring(0, index);
                    var estr = $scope.$parent.relayMessage.substring(
                      index,
                      $scope.$parent.relayMessage.length
                    );
                    $scope.$parent.relayMessage =
                      lstr + " [" + $this.attr("title") + "]" + estr;
                    //                                    $addFaceBoxm.addClass('hide');
                    obj1.click();
                    $addFaceBoxm.removeClass("hide");
                  }
                  //                    			$addFaceBoxm.addClass('hide');
                }
                if ($("#myflag").val() != "1") {
                  //??????
                  $scope.$apply(function () {
                    if (
                      $scope.mtype == "adressbook" ||
                      $scope.mtype == "main" ||
                      $scope.mtype == "feedback"
                    ) {
                      if (!$scope.$parent.publishMessage) {
                        $scope.$parent.publishMessage =
                          "[" + $this.attr("title") + "]";
                      } else {
                        $scope.$parent.publishMessage =
                          $scope.$parent.publishMessage +
                          " [" +
                          $this.attr("title") +
                          "]";
                      }
                    } else if ($scope.mtype == "notice") {
                      if (!$scope.$parent.content) {
                        $scope.$parent.content =
                          "[" + $this.attr("title") + "]";
                      } else {
                        $scope.$parent.content =
                          $scope.$parent.content +
                          "[" +
                          $this.attr("title") +
                          "]";
                      }
                    } else if (obj.length > 0) {
                      obj[0].value =
                        obj[0].value + "[" + $this.attr("title") + "]";
                      $this.parents(".publish-pop.add-face").addClass("hide");
                    } else {
                      if (!$scope.publishMessage) {
                        $scope.publishMessage = "[" + $this.attr("title") + "]";
                      } else {
                        $scope.publishMessage =
                          $scope.publishMessage +
                          "[" +
                          $this.attr("title") +
                          "]";
                      }
                    }
                  });
                  //	                            $addFaceBox1.addClass('hide');
                }
                e.stopPropagation(); //不再派发事件
              });
            $addFaceBoxm.click(function (e) {
              //点击“表情”按钮，显示表情框（待定）
              $addFaceBoxm.removeClass("hide");
              e.stopPropagation();
            });
            $faceBoxm.off().click(function () {
              //点击“表情”按钮，显示表情框
              $addFaceBoxm.toggleClass("hide");
              if ($scope.mtype == "adressbook" || $scope.mtype == "notice") {
                $addFaceBoxm.css({
                  left: "0px",
                  top: "35px",
                });
              } else if ($scope.mtype == "feedback") {
                $addFaceBoxm.css({
                  left: "40px",
                  top: "15px",
                });
              } else if ($scope.retype == "remain") {
                $addFaceBoxm.css({
                  left: "-5px",
                  top: "28px",
                });
              } else {
                $addFaceBoxm.css({
                  left: "133px",
                  top: "35px",
                });
              }
              return false;
            });
            $("body").click(function () {
              $addFaceBoxm.addClass("hide");
            });
          });
        },
        controller: function ($scope) {
          $scope.faceList = [];
          var faces = $faceService.getFaces();
          var maxCount = 48; //一个表情栏显示的表情个数
          var length = Math.ceil(faces.length / maxCount);
          var face = [];
          var count = 0;
          for (var i = 0; i < length; i++) {
            for (var j = 0; j < maxCount; j++) {
              if (!!faces[count]) {
                face.push(faces[count]);
                count++;
              } else {
                face.push({});
                count++;
              }
            }
            $scope.faceList.push(face);
            face = [];
          }
        },
      };
    })
    .directive("iqShowFace", function (
      $iq_http,
      $timeout,
      $iq_server,
      $faceService
    ) {
      return {
        restrict: "AE",
        scope: {
          descript: "=ngModel",
        },
        controller: function ($scope, $faceService, $element) {
          if ($scope.descript != undefined) {
            var faces = $faceService.getFaces();
            var inputModel = $scope.descript;
            var faceString = inputModel.match(
              /\[([A-Za-z]|[\u4E00-\u9FA5]|[\uFE30-\uFFA0])+\]/g
            ); //得到表情的文字表示
            if (faceString) {
              var faceStringLength = faceString.length;
              var faceUrl = []; //得到表情图片的url
              var faceStringCount = 0;
              var middleCount = 0;
              for (var i = 0; i < faceStringLength; i++) {
                for (var j = 0; j < faces.length; j++) {
                  if (
                    faces[j].title ==
                    faceString[i].replace("[", "").replace("]", "")
                  ) {
                    faceUrl[faceStringCount] = faces[j].faceclass;
                    middleCount = faceStringCount;
                    faceStringCount++;
                  }
                }
                if (!faceUrl[middleCount]) {
                  faceStringCount++;
                }
              }
              var imgList = [];
              for (var i = 0; i < faceStringLength; i++) {
                if (faceUrl[i]) {
                  imgList[i] =
                    "<span title='" +
                    faceString[i].replace("[", "").replace("]", "") +
                    " 'class=" +
                    "'face-in-pre " +
                    faceUrl[i] +
                    "'/>";
                } else {
                  imgList[i] = faceString[i];
                }
              }
            }
            var preHtml = ""; //要显示的html
            preHtml = inputModel;
            preHtml = preHtml.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (faceString) {
              for (var i = 0; i < faceString.length; i++) {
                preHtml = preHtml.replace(faceString[i], imgList[i]);
              }
            }
            $timeout(function () {
              $("<pre>")
                .addClass("release-body pre")
                .html(preHtml)
                .appendTo($element);
            });
          } else {
          }
        },
      };
    })
    .directive("onFinishRenderFilters", function ($timeout) {
      //监听ng-repert执行完毕
      return {
        restrict: "A",
        link: function (scope, element, attr) {
          if (scope.$last === true) {
            $timeout(function () {
              scope.$emit("ngRepeatFinished");
            });
          }
        },
      };
    })
    .directive("iqContentNew", function ($faceService, $location) {
      // 发布内容
      return {
        restrict: "AE",
        scope: false,
        // templateUrl:
        // './templates/common/iq_content.html',
        link: function ($scope, $element, $attr, $iq_popup) {
          //								var obj = $scope[$attr.obj];
          //我的通知修改，兼容其余模块
          var obj = $scope;
          var tmpstr = $attr.obj;
          var tmparr = tmpstr.split(".");
          for (var iii = 0; iii < tmparr.length; iii++) {
            obj = obj[tmparr[iii]];
          }

          var type = $attr.type;
          var storetype = $attr.storetype;
          var content = "";
          var userIdNames = "";

          if (storetype == "store") {
            obj = obj.obj;
          }

          if (type == "blog") {
            content = obj.content.content;
            userIdNames = obj.content.userIdNames;
          } else if (type == "discuss" || type == "noticediscuss") {
            content = obj.discuss.content;
            userIdNames = obj.discuss.userIdNames;
          } else if (type == "discussmaster") {
            content = obj.master.content;
            userIdNames = obj.master.userIdNames;
          } else if (type == "relay") {
            content = obj.content.relay.content;
            userIdNames = obj.content.relay.userIdNames;
          } else if (type == "relaymaster") {
            content = obj.content.master.content;
            userIdNames = obj.content.master.userIdNames;
          } else if (type == "task") {
            content = obj.content.content;
            content = content.replace(new RegExp("&nbsp;", "g"), " "); // 空格替换
          } else if (type == "schedule") {
            content = obj.content.content;
            content = content.replace(new RegExp("&nbsp;", "g"), " "); // 空格替换
          } else if (type == "discussshow") {
            content = obj.content;
            userIdNames = obj.userIdNames;
          } else if (type == "noticeat") {
            content = obj.content;
            userIdNames = obj.userIdNames;
          } else if (type == "systemnotice") {
            content = obj.content;
            userIdNames = obj.userIdNames;
          } else if (type == "privatenotice") {
            content = obj.content;
          } else if (type == "blogsearch") {
            content = obj.content;
          }

          // 表情处理
          var reg = new RegExp("\\[[^\\]]*\\]", "g"); // 创建正则RegExp对象
          var faceString = content.match(
            /\[([A-Za-z]|[\u4E00-\u9FA5]|[\uFE30-\uFFA0])+\]/g
          ); //得到表情的文字表示
          var faces = $faceService.getFaces();
          if (faceString) {
            var faceStringLength = faceString.length;
            var faceUrl = []; //得到表情图片的url
            var faceStringCount = 0;
            var middleCount = 0;
            for (var i = 0; i < faceStringLength; i++) {
              for (var j = 0; j < faces.length; j++) {
                if (
                  faces[j].title ==
                  faceString[i].replace("[", "").replace("]", "")
                ) {
                  faceUrl[faceStringCount] = faces[j].faceclass;
                  middleCount = faceStringCount;
                  faceStringCount++;
                }
              }
              if (!faceUrl[middleCount]) {
                faceStringCount++;
              }
            }
            var imgList = [];
            for (var i = 0; i < faceStringLength; i++) {
              if (faceUrl[i]) {
                imgList[i] =
                  "<span title='" +
                  faceString[i].replace("[", "").replace("]", "") +
                  " 'class=" +
                  "'face-in-pre " +
                  faceUrl[i] +
                  "'/>";
                content = content.replace(faceString[i], imgList[i]); // 替换表情代码为表情图片链接
              } else {
                imgList[i] = faceString[i];
              }
            }
          }
          //								if (faces != null) {
          //									for (var j = 0; j < faces.length; j++) {
          //										// alert(faces[j]);
          //										var imgPath = null;
          //										var faceBase = ImgIputHandler.facePath;
          //										for (var k = 0; k < faceBase.length; k++) {
          //											var key = "["
          //													+ faceBase[k].faceName
          //													+ "]";
          //											if (key == faces[j]) {// 如果表情库的faceName等于匹配到的表情代码
          //												imgPath = faceBase[k].facePath;
          //												break;
          //											}
          //										}
          //
          //										if (imgPath == null) {// 如果没有找到表情
          //
          //										} else {
          //											// content =
          //											// content.replace(faces[j], "<img
          //											// src=\"img/face/" + imgPath +
          //											// "\"/>");//替换表情代码为表情图片链接
          //											content = content.replace(faceString,
          //													"<img src=\"" + imgPath
          //															+ "\"/>");// 替换表情代码为表情图片链接
          //										}
          //
          //									}
          //								}
          // 表情处理--结束

          var topclick = function (e) {
            $scope[$attr.topclick](e.data);
          };

          var atclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/personalpage/gotouserpage/" + e.data);
            });
          };

          var taskclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/task/detail/" + e.data);
            });
          };

          var schedulclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/schedule/detail/" + e.data);
            });
          };

          var noteclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/note/view/" + e.data);
            });
          };

          var meetingclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/meeting/showmeeting/" + e.data);
            });
          };

          var telmeetingclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/meeting/shownettel/" + e.data);
            });
          };

          var netdiskclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("/netdisk/" + e.data);
            });
          };

          var personapproveclick = function (e) {
            e.preventDefault(); // 阻止本身的其他事件发生
            e.stopPropagation(); // 阻止冒泡，阻止其他相关时间发生
            $scope.$apply(function () {
              // 执行新的angular生命周期
              $location.path("person-org/person-manage/0/");
            });
          };

          // #处理
          var regJing = new RegExp("#[^#\\s&]*#", "g"); // 创建正则RegExp对象
          var jings = content.match(regJing);
          if (jings != null) {
            for (var m = 0; m < jings.length; m++) {
              // onClick=\"topicRelations(topic.id,
              // topic.topic)\"
              content = content.replace(
                jings[m],
                "<a topic_replace='topic" + m + "'></a>"
              );
            }
          }
          // #处理--结束

          // @处理
          var regAt = new RegExp("@[^@\\s&]*", "g"); // 创建正则RegExp对象
          var ats = content.match(regAt);
          if (ats != null) {
            for (var n = 0; n < ats.length; n++) {
              if (ats[n] != "@") {
                content = content.replace(
                  ats[n],
                  "<a at_replace='at" + n + "'></a>"
                );
              }
            }
          }
          // href=\"" + "#/personalpage/gotouserpage/" +
          // "8a811c704f25ba6d014f25f5c59e0005" + "\
          // ats[n]
          // @处理--结束

          $element.html(content);

          // 绑定#的单击事件
          if (jings != null) {
            for (var m = 0; m < jings.length; m++) {
              var _a = $element.find("[topic_replace='topic" + m + "']");
              var topicName = jings[m].substring(1, jings[m].length - 1); // 去掉两边的#号
              _a.on("click", "", topicName, topclick)
                .addClass("talk-subject-textcolor ng-binding ng-scope")
                .html(jings[m]);
            }
          }
          // 绑定@的单击事件
          if (ats != null) {
            var users = [];
            if (userIdNames) {
              var userList = userIdNames.split(";");
              if (userList && userList.length > 0) {
                for (var i = 0; i < userList.length; i++) {
                  if (userList[i]) {
                    var user = eval("(" + userList[i] + ")");
                    users.push(user);
                  }
                }
              }
            }

            for (var n = 0; n < ats.length; n++) {
              var _b = $element.find("[at_replace='at" + n + "']");
              // var atName = ats[n].substring(1,
              // ats[n].length-1);
              if (users.length > 0) {
                var addat = true;
                for (var i = 0; i < users.length; i++) {
                  if ("@" + users[i].name == ats[n]) {
                    _b.on("click", "", users[i].id, atclick).html(ats[n]);
                    users = removeElementByIndex(users, i);
                    addat = false;
                    break;
                  }
                }
                if (addat == true) {
                  _b.html(ats[n]);
                  // _b.on("click", '', '',
                  // atclick).html(ats[n]);
                }
              } else {
                _b.html(ats[n]);
              }
            }
          }

          // 处理任务、日程的点击事件
          if (type == "task") {
            var _d = $element.find("[task_replace]");
            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
          } else if (type == "schedule") {
            var _c = $element.find("[schedul_replace]");
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
          } else if (type == "discussmaster") {
            var _c = $element.find("[schedul_replace]");
            var _d = $element.find("[task_replace]");
            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
          } else if (type == "relaymaster") {
            var _c = $element.find("[schedul_replace]");
            var _d = $element.find("[task_replace]");
            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
          } else if (type == "systemnotice") {
            var _c = $element.find("[schedul_replace]"); // 日程连接
            var _d = $element.find("[task_replace]"); // 任务连接
            var _e = $element.find("[notice_user]"); // 笔记的用户连接
            var _f = $element.find("[notice_view]"); // 笔记的查询连接
            var _m = $element.find("[meeting_user]"); // 会议的用户连接
            var _n = $element.find("[meeting_replace]"); // 会议的查询连接
            var _p = $element.find("[tel_meeting_replace]"); // 电话会议的查询连接
            var _l1 = $element.find("[file_share_user]"); // 文件库的用户连接
            var _l2 = $element.find("[file_view]"); // 文件库的查询连接
            var _person = $element.find("[psnorg_approve_replace]"); // 人员批准连接

            if (_d && _d.get(0)) {
              _d.on("click", "", _d.get(0).name, taskclick);
            }
            if (_c && _c.get(0)) {
              _c.on("click", "", _c.get(0).name, schedulclick);
            }
            if (_e && _e.get(0)) {
              _e.on("click", "", _e.get(0).name, atclick);
            }
            if (_f && _f.get(0)) {
              _f.on("click", "", _f.get(0).name, noteclick);
            }
            if (_m && _m.get(0)) {
              _m.on("click", "", _m.get(0).name, atclick);
            }
            if (_n && _n.get(0)) {
              _n.on("click", "", _n.get(0).name, meetingclick);
            }
            if (_p && _p.get(0)) {
              _p.on("click", "", _p.get(0).name, telmeetingclick);
            }
            if (_l1 && _l1.get(0)) {
              _l1.on("click", "", _l1.get(0).name, atclick);
            }
            if (_l2 && _l2.get(0)) {
              _l2.on("click", "", _l2.get(0).name, netdiskclick);
            }
            if (_person && _person.get(0)) {
              _person.on("click", "", _person.get(0).name, personapproveclick);
            }
          }
        },
        controller: function (
          $scope,
          $element,
          $attrs,
          $location,
          $iq_user,
          $blog_service
        ) {},
      };
    })
    .directive("ngRightClick", [
      "$rootScope",
      "$templateCache",
      function ($rootScope, $templateCache) {
        function Mousepos(ev) {
          var e = ev || window.ev;
          var contw = $("ul.thumbnail-block").width();
          var left = e.clientX - 250; //|| e.clientX + scrollX;
          var top = e.target.offsetTop;
          //|| e.clientY + scrollY;
          if (e.currentTarget.clientWidth < 690) {
            if (e.pageX - 115 > contw) {
              left = e.pageX - 385;
            } else {
              left = e.pageX - 230;
            }
            //top -= window.screenTop;
            top = e.pageY - 50;
          } else {
            if (e.currentTarget.clientWidth - left < 150) {
              left = e.currentTarget.clientWidth - 155;
            }
          }
          return {
            top: top,
            left: left,
          };
        }
        return {
          link: function (scope, element, iattr) {
            element.bind("contextmenu", function (event) {
              var position = Mousepos(event);
              event.preventDefault();
              var myoptions = scope.$eval(iattr.ngRightClick);
              myoptions.then(
                function (re) {
                  var url = "./templates/common/iq_context_menu1.html";
                  if (re.html) {
                    $templateCache.put(
                      "./templates/common/iq_context_menu1.html",
                      re.html
                    );
                  }
                  if (re.url) {
                    url = re.url;
                  }
                  $rootScope.$broadcast("rightmenu", {
                    data: re.menuOptionsArray,
                    target: position,
                    path: re.path,
                    url: url,
                  });
                },
                function () {
                  console.log("error");
                }
              );
            });
          },
        };
      },
    ])
    .directive("contextMenu", [
      "$parse",
      "$q",
      "$sce",
      "$templateCache",
      function ($parse, $q, $sce, $templateCache) {
        return {
          restrict: "AE",
          replace: true,
          templateUrl: "./templates/common/iq_context_menu.html",
          link: function ($scope, element, attrs) {
            $scope.$on("rightmenu", function (event, re) {
              $scope.url = re.url;
              event.preventDefault();
              $scope.options = re.data;
              var position = re.target;
              position.top = position.top + 23;
              $(element).css(position);
              $(element).addClass("context");
            });
            $(element).on("click", function ($event) {
              $(event.currentTarget).removeClass("context");
            });
            $(document.body).on("mouseup", function (e) {
              $(element).removeClass("context");
            });
          },
        };
      },
    ])
    .directive("iqPopover", function ($iq_server, $iq_http) {
      var demoUrl = "./templates/common/iq_popover.html";
      function getOffsetToBody(node) {
        var top = 0,
          left = 0;
        while (node) {
          top += node.offsetTop;
          left += node.offsetLeft;
          top -= node.scrollTop;
          left -= node.scrollLeft;
          node = node.offsetParent;
        }
        return {
          top: top,
          left: left,
        };
      }
      return {
        restrict: "AE",
        replace: true,

        templateUrl: demoUrl,
        link: function ($scope, $element, iElement, $iqmodal, $attr) {
          var flag = "";
          $scope.popoverContent = "";
          $scope.$on("popoverhide", function (event, obj) {
            flag = false;
            $scope.demoshow($element);
          });
          $scope.$on("popovershow", function (event, obj) {
            if (obj.url) {
              $scope.popoverContent = obj.url;
            } else {
              $scope.popoverContent = "./templates/common/iq_popover1.html";
            }
            flag = true;
            $scope.popmember = obj.data;
            var position = getOffsetToBody(obj.target);
            position.top -= $($element).height() - 30;
            position.left -= 107;
            console.log($element[0].clientHeight);
            $($element).css(position);
            $scope.demoshow($element);
            $scope.fegshow = true;
            if (
              $scope.popmember.prefixId.indexOf("p") == 0 ||
              !$scope.popmember.prefixId
            ) {
              $scope.personshow = true;
              $scope.departmentshow = false;
              $scope.fileshow = false;
              if (typeof $scope.popmember.department == "object") {
                $scope.departmentname = $scope.popmember.department.name;
              } else {
                $scope.departmentname = $scope.popmember.department;
              }
            } else if (
              $scope.popmember.prefixId == "d" ||
              !$scope.popmember.prefixId
            ) {
              $scope.personshow = false;
              $scope.departmentshow = true;
              $scope.fileshow = false;
            } else if (
              $scope.popmember.prefixId == "f-company" ||
              !$scope.popmember.prefixId
            ) {
              $scope.personshow = false;
              $scope.departmentshow = false;
              $scope.fileshow = true;
              if ($scope.popmember.parentDir) {
                $scope.filepath = "企业文件库";
                for (var i = 0; i < $scope.popmember.parentDir.length; i++) {
                  $scope.filepath = "企业文件库/";
                  $scope.filepath += $scope.popmember.parentDir[i].name;
                }
              }
            } else {
              $scope.personshow = false;
              $scope.departmentshow = false;
              $scope.fileshow = true;
              if ($scope.popmember.parentDir) {
                $scope.filepath = "个人文件库";
                for (var i = 0; i < $scope.popmember.parentDir.length; i++) {
                  $scope.filepath = "个人文件库/";
                  $scope.filepath += $scope.popmember.parentDir[i].name;
                }
              }
            }
            if (!$scope.popmember.position || !$scope.popmember.department) {
              $scope.fegshow = !$scope.fegshow;
            }
          });

          $element.on("mouseenter", function () {
            flag = true;
            $scope.demoshow($element);
          });
          $element.on("mouseleave", function () {
            flag = false;
            $scope.demoshow($element);
          });
          $scope.demoshow = function () {
            if (flag == true) {
              $($element).show();
            } else {
              setTimeout($($element).hide(), 1000);
            }
          };
        },
        controller: function (
          $scope,
          $iqmodal,
          $iq_popup,
          $notice_service,
          $iq_loading,
          $plateService,
          $iq_dialog,
          $rootScope
        ) {
          $scope.$on("kanbanMemberShow", function (ev, re) {
            $scope.plateData = re;
          });
          $scope.showPlateType = function (type) {
            if (!$scope.plateData.operator) {
              return false;
            }
            switch (type) {
              case 0:
                if (
                  $scope.plateData.kanbanMember.user.id ==
                    $scope.plateData.operator.user.id &&
                  $scope.plateData.kanbanMember.role == 2
                ) {
                  return true;
                } else {
                  return false;
                }
              case 1:
                if (
                  $scope.plateData.kanbanMember.role == 1 &&
                  $scope.plateData.operator.user.id ==
                    $scope.plateData.kanbanMember.user.id
                ) {
                  return true;
                } else {
                  return false;
                }
              case 2:
                if (
                  $scope.plateData.kanbanMember.role == 1 &&
                  $scope.plateData.operator.user.id !=
                    $scope.plateData.kanbanMember.user.id &&
                  $scope.plateData.operator.role != 2
                ) {
                  return true;
                } else {
                  return false;
                }
              case 3:
                if (
                  $scope.plateData.kanbanMember.role == 2 &&
                  $scope.plateData.operator.role != 2
                ) {
                  return true;
                } else {
                  return false;
                }
              case 4:
                if (
                  $scope.plateData.kanbanMember.role == 0 &&
                  $scope.plateData.operator.role == 0
                ) {
                  return true;
                } else {
                  return false;
                }
            }
          };
          $scope.withdrawKanban = function () {
            $plateService.withdraw($scope.plateData.plateId).then(function () {
              $rootScope.$broadcast("plateMemberChange");
            });
          };
          $scope.removeAdminRole = function () {
            $plateService
              .setKanbanAdmin(
                $scope.plateData.plateId,
                $scope.plateData.kanbanMember.user.id,
                0
              )
              .then(function () {
                $rootScope.$broadcast("plateMemberChange");
              });
          };
          $scope.removeMember = function () {
            $plateService
              .removeMembers(
                $scope.plateData.plateId,
                $scope.plateData.kanbanMember.user.id
              )
              .then(function () {
                $rootScope.$broadcast("plateMemberChange");
              });
          };
          $scope.setAdminRole = function () {
            $plateService
              .setKanbanAdmin(
                $scope.plateData.plateId,
                $scope.plateData.kanbanMember.user.id,
                1
              )
              .then(function () {
                $rootScope.$broadcast("plateMemberChange");
              });
          };
          $scope.transferOwner = function () {
            var sharefile = $iq_dialog.sharefilePeople([]);
            sharefile.then(function (list) {
              if (list != null && list.length > 0) {
                if ($scope.plateData.operator.user.id != list[0].id) {
                  $plateService
                    .transferOwner($scope.plateData.plateId, list[0].id)
                    .then(function (re) {
                      if (re.data.success) {
                        $rootScope.$broadcast("plateMemberChange");
                      } else {
                        $iq_popup.alert(re.data.message, 3, "warn");
                      }
                    });
                }
              }
            });
          };
          $scope.sendMessage = function (person) {
            var modalInstance = $iqmodal.open({
              windowClass: "modal fade mymodal send-message-modal",
              controller: function (
                $scope,
                $modalInstance,
                $iq_popup,
                $notice_service,
                $iq_loading
              ) {
                $scope.publish = function () {
                  $(".publish-pop.add-face").addClass("hide");
                  var content = angular.element("#publishMessageId").val();
                  content = transBeforeSave(content);
                  if (
                    content == "" ||
                    content == null ||
                    content == undefined
                  ) {
                    $iq_popup.alert("发送内容为空！", 2, "warn");
                    return;
                  }
                  var data = {
                    typeId: "private",
                    type: "私信",
                    content: content,
                    connectUrl: "http://",
                    userId: person.id,
                    userName: person.name,
                    sendTime: getStringDate(new Date()),
                    readState: "0",
                  };
                  $iq_loading.show();
                  $notice_service.save(data, function () {
                    $modalInstance.close("ok");
                  });
                };
                $scope.close = function () {
                  $modalInstance.close("close");
                };
              },
              templateUrl: "./apps/netdisk2/page/send-message-model.html",
            });
          };
        },
      };
    })
    .directive("iqLogOperation", function ($compile, $iq_user, $timeout) {
      return {
        restrict: "E",
        replace: true,
        scope: {
          source: "=source",
        },
        templateUrl: "./templates/common/iq_logoperation.html",
        link: function (scope, ele, attr) {
          scope.cardIds = [];
          scope.$watch("source", function () {
            if (scope.source) {
              angular.forEach(scope.source, function (v, k) {
                var str = v.message;
                //匹配名字
                var nameReg = /([^\[\]]+(?=\[\/))/g;
                var nameArr = str.match(nameReg);
                //匹配所有标签
                var strReg = /\[[^\[]+\[\/[^ ]*?\]/g;
                var result = str.match(strReg);
                //匹配所有的属性和属性值
                var attrReg = /([^\s*\]]+)=([^\s*\]]+)/g;
                //匹配类型
                var typeReg = /[^\[^\/]+(?=\])/g;
                scope.boxArr = []; //定义存放属性和属性值得数组
                angular.forEach(result, function (v, k) {
                  var outObj = {},
                    inObj = {};
                  v.replace(attrReg, function (item) {
                    var key = item.split("=")[0];
                    var value = item.split("=")[1];
                    inObj[key] = value;
                  });
                  outObj[v.match(typeReg)[1]] = inObj;
                  scope.boxArr.push(outObj);
                });
                //找到数组所在的索引
                var getIndex = function (source, target) {
                  var index = "";
                  angular.forEach(source, function (v, k) {
                    if (v == target) {
                      index = k;
                    }
                  });
                  return index;
                };
                //替换所有标签为名字
                v.message = str.replace(strReg, function (s) {
                  var index = getIndex(result, s);
                  if (scope.boxArr[index].card) {
                    scope.cardIds.push(scope.boxArr[index].card.id);
                    return "<b>" + nameArr[index] + "</b>&nbsp;";
                  } else if (scope.boxArr[index].file) {
                    var a = scope.boxArr[index].file.fileid
                      ? scope.boxArr[index].file.fileid
                      : "";
                    var b = scope.boxArr[index].file.dirid
                      ? scope.boxArr[index].file.dirid
                      : "";
                    var curhtml =
                      '<a href="javascript:void(0);" ng-click="func(\'' +
                      a +
                      "','" +
                      b +
                      "')\">" +
                      nameArr[index] +
                      "</a>";
                    return curhtml;
                  } else {
                    return nameArr[index];
                  }
                });
                $timeout(function () {
                  $(".compile-file").each(function (i) {
                    if (i == k) {
                      $(this).html(v.message);
                    }
                  });
                  $compile($(".compile-file"))(scope);
                });
              });
            }
          });
        },
        controller: function ($scope) {
          $scope.func = function (a, b) {
            $scope.$parent.$parent.$parent.download(a, b);
          };
        },
      };
    })
    .directive("iqLogOperationPlate", function (
      $compile,
      $iq_user,
      $timeout,
      $state
    ) {
      return {
        restrict: "E",
        replace: true,
        scope: {
          source: "=source",
          sourceid: "=sourceid",
          sourcetype: "=sourcetype",
        },
        templateUrl: "./templates/common/iq-logoperationplates.html",
        link: function (scope, ele, attr) {
          scope.$watch("source", function () {
            if (scope.source) {
              angular.forEach(scope.source, function (v, k) {
                var str = v.message;
                //匹配名字
                var nameReg = /([^\[\]]+(?=\[\/))/g;
                var nameArr = str.match(nameReg);
                //匹配所有标签
                var strReg = /\[[^\[]+\[\/[^ ]*?\]/g;
                var result = str.match(strReg);
                //匹配所有的属性和属性值
                var attrReg = /([^\s*\]]+)=([^\s*\]]+)/g;
                //匹配类型
                var typeReg = /[^\[^\/]+(?=\])/g;
                scope.boxArr = []; //定义存放属性和属性值得数组
                angular.forEach(result, function (v, k) {
                  var outObj = {},
                    inObj = {};
                  v.replace(attrReg, function (item) {
                    var array = item.split("=");
                    var key = array[0];
                    var value = array[1];
                    inObj[key] = value;
                  });
                  outObj[v.match(typeReg)[1]] = inObj;
                  scope.boxArr.push(outObj);
                });

                v.parts = [];
                var m = 0,
                  n = 0;
                for (var i = 0; i < result.length; i++) {
                  var onepart = {};
                  var strinfo = "";

                  var lettlem = str.indexOf(result[i], n);
                  m = lettlem + result[i].length;

                  if (i < result.length - 1) {
                    n = str.indexOf(result[i + 1], m);
                  } else {
                    n = str.length;
                  }

                  if (m < n) {
                    strinfo = str.substring(m, n);
                  }

                  if (i == 0) {
                    v.operatename = nameArr[i];
                    if (scope.boxArr[i].card) {
                      v.operateid = scope.boxArr[i].card.id;
                    }
                    v.operateinfo = strinfo;
                  } else {
                    if (scope.boxArr[i].card != undefined) {
                      onepart.username = nameArr[i];
                      onepart.userid = scope.boxArr[i].card.id;
                      onepart.strinfo = strinfo;
                    } else if (scope.boxArr[i].kanban != undefined) {
                      onepart.kanbanname = nameArr[i];
                      onepart.kanbanid = scope.boxArr[i].kanban.id;
                      onepart.strinfo = strinfo;
                    } else if (scope.boxArr[i].task != undefined) {
                      onepart.taskname = nameArr[i];
                      onepart.taskid = scope.boxArr[i].task.id;
                      onepart.strinfo = strinfo;
                    }
                    v.parts.push(onepart);
                  }
                }
              });
            }
          });
        },
        controller: function ($scope, $attrs, $iq_server, $iq_http) {
          $scope.goTask = function (id) {
            if ($scope.$parent.editTasks) {
              $scope.$parent.editTasks(id);
            }
          };

          $scope.$on("logOperateInfo", function (ev) {
            $scope.operateinfo = "查看更多";
            $scope.readmore = true;
          });

          $scope.sourcetype = $attrs.sourcetype;

          $scope.operateinfo = "查看更多";
          $scope.readmore = true;
          $scope.logmore = function () {
            if ($scope.readmore) {
              $scope.operateinfo = "正在加载数据......";
              var param = {
                pageSize: 10,
                page: 1,
              };
              if ($scope.source != undefined && $scope.source != null) {
                param.pageSize = $scope.source.length + 10;
              }

              var url;
              if ($scope.sourcetype == "fromrecent") {
                url = $iq_server.server() + "kanban/kanban_total_logs";
              } else if (
                ($scope.sourcetype == "fromkanban" ||
                  $scope.sourcetype == "fromkanbanPopover") &&
                $scope.sourceid
              ) {
                url =
                  $iq_server.server() +
                  "kanban/kanbans/" +
                  $scope.sourceid +
                  "/kanban_total_logs";
              } else if ($scope.sourcetype == "fromtask" && $scope.sourceid) {
                url =
                  $iq_server.server() +
                  "kanban/kanban_tasks/" +
                  $scope.sourceid +
                  "/kanban_total_logs";
              }

              if (url) {
                var params = {
                  method: "GET",
                  url: url,
                  params: param,
                };
                $iq_http.http(params).then(function (re) {
                  if (re.data.success) {
                    var logs = angular.copy(re.data.list);
                    var total = re.data.pager.total;
                    $scope.source = logs;
                    if ($scope.source.length < total) {
                      $scope.operateinfo = "查看更多";
                    } else {
                      $scope.operateinfo = "没有更多了";
                      $scope.readmore = false;
                    }
                  }
                });
              }
            }
          };
        },
      };
    })
    .directive("iqHeadImg", function () {
      return {
        link: function (scope, iElement, iAttr, ctrl, $transclude) {
          //如果用户是chrome或者safari就显示头像，否则显示默认灰色头像
          if (old_browser.Chrome || old_browser.Safari) {
            // 检测用户姓名是否是英文
            var str = iAttr.name;
            var id = iAttr.id;
            var tname = {};
            // 颜色数组
            var colors = [
              "#63d5e6",
              "#74dcc5",
              "#6ec1fb",
              "#5dc9f9",
              "#f690a1",
              "#ff9e57",
            ];
            // 用户的颜色,注意最后一位有可能是字母，要转换成ASCII码
            var color = colors[parseInt(id.charCodeAt(id.length - 1)) % 6];
            var _this = iElement.context;
            tname.name = "";
            if (str.length != 0) {
              regHan = /.*[\u4e00-\u9fa5].*/;
              regNum = /.*[0-9].*/;
              if (regHan.test(str) || regNum.test(str)) {
                // 包含汉字或者数字，取后两位显示
                tname.name = str.slice(-2);
              } else {
                // 判断英文中有几个单词
                var namearray = str.split(" ");
                if (namearray.length > 1) {
                  str =
                    namearray[0].toString().charAt(0) +
                    namearray[1].toString().charAt(0);
                  tname.name = str;
                } else {
                  tname.name = str.slice(0, 2);
                }
              }
            }
            // svg文件内容
            svg = encodeURI(
              '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"> <g id="canvas_1"><circle id="circle1" fill="' +
                color +
                '" cx="50" cy="50" r="50" /> <text id="text1" x="50%" y="50%" fill="#FFFFFF" font-family="\'MicrosoftYaHei\'" font-size="32" text-anchor="middle" dy=".3em">' +
                tname.name +
                " </text> </g></svg>"
            );

            _this.src = "data:image/svg+xml;charset=UTF-8," + svg;
          } else {
            _this.src = "theme/img/default.png";
          }
        },
      };
    })
    .directive("iqTextArea", function () {
      function autoHeight(elem) {
        elem.style.overflow = "hidden";
        if (!event || !event.type || event.type != "click") {
          //nieyy：排除click，解决页面上下跳动问题。
          elem.style.height = "auto";
        }
        elem.scrollTop = "0";
        elem.style.height = elem.scrollHeight + "px";
      }
      return {
        restrict: "A",
        link: function (scope, ele, attrs) {
          var oriEle = $(ele).get(0);
          $(oriEle).focus();
          $(oriEle).bind("keyup click change", function (e) {
            autoHeight($(this).get(0));
          });
          var timer = setInterval(function () {
            if ($(oriEle).val()) {
              autoHeight(oriEle);
              clearInterval(timer);
            }
          }, 100);
        },
      };
    });
})();
